define(["lodash","zepto"], function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_4__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 86);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = {
    /**
     * Returns the string with the first character capitalized
     *
     * @param {string} String to be capitalized
     * @param {boolean} [lowerCaseElse] Pass true if the rest of the string should be lower case
     * @returns {string}
     */
    capitalize: function capitalize(string, lowerCaseElse) {
        return _.upperFirst(lowerCaseElse ? string.toLowerCase() : string);
    },


    /**
     * Returns true if string starts with 'searchString' parameter, false otherwise.
     *
     * If 'ignoreCase' is true, the function will be case insensitive
     *
     * @param {string} string
     * @param {string} searchString
     * @param {boolean} [ignoreCase]
     * @returns {boolean}
     */
    startsWith: function startsWith(string, searchString, ignoreCase) {
        if (!string) {
            return false;
        }
        if (ignoreCase) {
            return startsWith(string.toLowerCase(), searchString.toLowerCase(), false);
        }
        return _.startsWith(string, searchString);
    },

    /**
     * Returns true if string ends with 'endsWith' parameter, false otherwise.
     *
     * If 'ignoreCase' is true, the function will be case insensitive
     *
     * @param {string} string
     * @param {string} endsWith
     * @param {boolean} [ignoreCase]
     * @returns {boolean}
     */
    endsWith: function endsWith(string, _endsWith, ignoreCase) {
        if (!string) {
            return false;
        }
        if (ignoreCase) {
            return this.endsWith(string.toLowerCase(), _endsWith.toLowerCase(), false);
        }
        return _.endsWith(string, _endsWith);
    },
    isNullOrEmpty: function isNullOrEmpty(str) {
        return !str || !str.trim();
    },
    isTrue: function isTrue(str) {
        return str === 'true';
    }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var stringUtils = __webpack_require__(5);

var CSS_UNITS = {
    pct: '%',
    px: 'px',
    vw: 'vw',
    vh: 'vh'
};

var rgbaRegexp = /^\d+,\d+,\d+,(\d+.?\d*)?/;

function toCalcExp(measurements) {
    return 'calc(' + measurements.join(' + ') + ')';
}

function roundToNearestHalf(num) {
    return Math.round(num * 2) / 2;
}

function getScreenUnitsAsPixels(screenUnits, screenDimension) {
    return roundToNearestHalf(screenUnits / 100 * screenDimension);
}

function getUnitsDataWithoutScreenUnits(unitsData, screenDimension) {
    var newUnitsData = _.clone(unitsData);

    if (_.isFinite(unitsData.vw)) {
        newUnitsData[CSS_UNITS.px] = (newUnitsData[CSS_UNITS.px] || 0) + getScreenUnitsAsPixels(unitsData.vw, screenDimension);
        delete newUnitsData[CSS_UNITS.vw];
    }

    if (_.isFinite(unitsData.vh)) {
        newUnitsData[CSS_UNITS.px] = (newUnitsData[CSS_UNITS.px] || 0) + getScreenUnitsAsPixels(unitsData.vh, screenDimension);
        delete newUnitsData[CSS_UNITS.vh];
    }

    return newUnitsData;
}

function convertUnitsDataToCssStringValue(unitsData, screenSizeInRelevantAxis) {
    var unitsDataWithoutScreenUnits = getUnitsDataWithoutScreenUnits(unitsData, screenSizeInRelevantAxis);

    var measurements = _(unitsDataWithoutScreenUnits).pick(_.keys(CSS_UNITS)).map(function (val, key) {
        return val + CSS_UNITS[key];
    }).value();
    return measurements.length > 1 ? toCalcExp(measurements) : measurements[0];
}

function concatenateStyleIdToClassName(styleId, className) {
    return styleId + '_' + className;
}

function concatenateStyleIdToSkinPart(styleId, skinPartName) {
    return styleId + skinPartName;
}

function concatenateStyleIdToClassList(styleId, classes) {
    return _(classes).compact().map(function (cls) {
        return concatenateStyleIdToClassName(styleId, cls);
    }).join(' ');
}

function normalizeColorStr(colorStr) {
    return rgbaRegexp.test(colorStr) ? 'rgba(' + colorStr + ')' : colorStr;
}

function createColorStyleText(colorVal, cssClassName, styleAttributeName) {
    var childColor = '';
    if (stringUtils.startsWith(colorVal, '#')) {
        childColor = styleAttributeName + ': ' + colorVal + ';';
    } else {
        childColor = styleAttributeName + ': rgba(' + colorVal + ');';
    }
    var colorStyle = '.' + cssClassName + ' {' + childColor + '}';
    return colorStyle;
}

function getColorsCssString(colorsArr) {
    return _.map(colorsArr, function (color, colorIndex) {
        return (//eslint-disable-line prefer-template
            createColorStyleText(color, 'color_' + colorIndex, 'color') + '\n' + createColorStyleText(color, 'backcolor_' + colorIndex, 'background-color')
        );
    }).join('\n') + '\n';
}

function elementHasClass(element, classname) {
    return _(element.className || '').split(' ').includes(classname);
}

function addClassToElement(element, classname) {
    if (!elementHasClass(classname)) {
        element.className = element.className ? element.className + ' ' + classname : classname;
    }
}

function removeClassFromElement(element, classname) {
    element.className = _(element.className).split(' ').without(classname).join(' ');
}

function addStylesheetOfUrl(url) {
    var link = window.document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = url;
    window.document.getElementsByTagName('head')[0].appendChild(link);
}

function parseFontStr(fontStr) {
    var split = fontStr.split(' ');
    var sizeSplit = split[3] ? split[3].split('/') : [];
    return {
        style: split[0],
        variant: split[1],
        weight: split[2],
        size: sizeSplit[0],
        lineHeight: sizeSplit[1],
        family: split[4].replace(/\+/g, ' '),
        color: split[5],
        bold: split[2] === 'bold' || parseInt(split[2], 10) >= 700,
        italic: split[0] === 'italic'
    };
}

module.exports = {
    convertUnitsDataToCssStringValue: convertUnitsDataToCssStringValue,
    concatenateStyleIdToClassName: concatenateStyleIdToClassName,
    concatenateStyleIdToClassList: concatenateStyleIdToClassList,
    concatenateStyleIdToSkinPart: concatenateStyleIdToSkinPart,
    normalizeColorStr: normalizeColorStr,
    elementHasClass: elementHasClass,
    addClassToElement: addClassToElement,
    removeClassFromElement: removeClassFromElement,
    addStylesheetOfUrl: addStylesheetOfUrl,
    getColorsCssString: getColorsCssString,
    parseFontStr: parseFontStr
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

/**
 * @param {utils.Store.requestDescriptor} request
 * @param {function} doneCallback
 * @param {function} fetchFunc
 */
function createAndSendRequest(request, doneCallback, fetchFunc) {
    var fallbackUrls = [];
    if (request.url) {
        fallbackUrls.push(request.url);
    }
    if (request.urls && _.isArray(request.urls)) {
        fallbackUrls = fallbackUrls.concat(request.urls);
    }

    if (_.isUndefined(request.maxTimeouts)) {
        request.maxTimeouts = 1;
    }

    if (_.isUndefined(request.current)) {
        request.current = 0;
    } else {
        request.current++;
    }
    var url = fallbackUrls[request.current];
    if (!url) {
        doneCallback(null, 'missing URL');
    }

    var requestToSend = {
        url: url,
        dataType: request.dataType || 'json',
        type: 'GET',
        cache: request.cache,
        syncCache: request.syncCache,
        name: request.name
    };
    if (request.data) {
        requestToSend.type = 'POST';
        requestToSend.contentType = 'application/json; charset=UTF-8';
        requestToSend.data = JSON.stringify(request.data);
    }

    if (requestToSend.dataType === 'jsonp' && request.jsonpCallback) {
        requestToSend.jsonpCallback = request.jsonpCallback;
    }

    if (request.requestTimeout && request.current < request.maxTimeouts) {
        requestToSend.timeout = request.requestTimeout;
    }

    // If this request returns with an error, request the next fallback url
    requestToSend.error = function (xhrRequest, errName, err) {
        if (errName === 'timeout') {
            _.invoke(request, 'ontimeout');
        }
        _.invoke(request, 'onUrlRequestFailure', requestToSend.url, xhrRequest && xhrRequest.status);
        if (fallbackUrls.length && request.current < fallbackUrls.length - 1) {
            createAndSendRequest(request, doneCallback, fetchFunc);
        } else {
            // TODO - consider collecting all errors for debug purposes.
            doneCallback(xhrRequest.status, err || errName);
        }
    };
    requestToSend.success = function (resData) {
        if (_.isFunction(request.isValidResponse) && !request.isValidResponse(resData)) {
            //420 = our made up xhr status code for invalid responses. The content returned from the server/statics wasn't real/valid
            requestToSend.error({ status: 420 }, 'error');
            return;
        }
        doneCallback(resData);
    };
    fetchFunc(requestToSend);
}

module.exports = {
    createAndSendRequest: createAndSendRequest
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// In case we're not running in the browser

var win = typeof window !== 'undefined' ? window : {};

var raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function ( /* function */callback) {
    return setTimeout(callback, 1000 / 60);
};

var caf = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || clearTimeout;

module.exports = {
    /**
     *
     * @param {function()} callback
     * @returns {number}
     */
    request: function request() {
        return raf.apply(win, arguments);
    },

    /**
     * @param {number} id
     */
    cancel: function cancel() {
        return caf.apply(win, arguments);
    }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function getBorderSizes(element) {
    var computedStyle = window.getComputedStyle(element);
    return {
        top: parseFloat(computedStyle.getPropertyValue('border-top-width'), 10),
        left: parseFloat(computedStyle.getPropertyValue('border-left-width'), 10)
    };
}

/**
 * Get an element dimensions and position relative to the *document* root and while ignoring all transforms
 * NOTE: To calculate relative to window, use getBoundingRect
 * @param {HTMLElement} element
 * @param {HTMLElement} [offsetParent] the topmost offset parent to calculate position against, if passed an element which is not an offset parent or not a parent of element will be ignored.
 * @returns {{top: number, left: number, width: number, height: number, bottom: number, right: number}}
 */
function getElementRect(element, offsetParent) {
    var top = element.offsetTop;
    var left = element.offsetLeft;

    var width = element.offsetWidth;
    var height = element.offsetHeight;

    while (element.offsetParent) {
        element = element.offsetParent;
        var border = getBorderSizes(element);
        top += border.top;
        left += border.left;

        if (offsetParent && element === offsetParent) {
            break;
        }

        top += element.offsetTop;
        left += element.offsetLeft;
    }

    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: top + height,
        right: left + width
    };
}

/**
 * Get an element dimensions and position relative to the *window* and while ignoring all transforms
 * @param {HTMLElement} element
 * @param {HTMLElement} [offsetParent] optional topmost offset parent to calculate position against, if passed an element which is not an offset parent or not a parent of element will be ignored.
 * @param {window|HTMLElement} [scrollContainer] optional alternative element to calculate scroll from. Can also be used to mock window
 * @returns {{top: number, left: number, width: number, height: number, bottom: number, right: number}}
 */
function getBoundingRect(element, offsetParent, scrollContainer) {
    scrollContainer = scrollContainer || typeof window !== 'undefined' && window;
    var elementRect = getElementRect(element, offsetParent);
    if (scrollContainer) {
        var scrollY = scrollContainer.pageYOffset || scrollContainer.scrollTop || 0;
        var scrollX = scrollContainer.pageXOffset || scrollContainer.scrollLeft || 0;

        elementRect.top -= scrollY;
        elementRect.bottom -= scrollY;
        elementRect.left -= scrollX;
        elementRect.right -= scrollX;
    }
    return elementRect;
}

/**
 * Get an element and all it's children dimensions and position relative to the *document* root and while ignoring all transforms
 * @param {HTMLElement} element
 * @param {Array<HTMLElement>} [elementChildren] for recursion
 * @param {HTMLElement} [offsetParent] the topmost offset parent to calculate position against, if passed an element which is not an offset parent or not a parent of element will be ignored.
 * @param {{top: number, left: number, width: number, height: number, bottom: number, right: number}} [contentRect] for recursion
 * @returns {{top: number, left: number, width: number, height: number, bottom: number, right: number}}
 */
function getContentRect(element, offsetParent, elementChildren, contentRect) {
    var $ = __webpack_require__(4);
    // If this is the firs time we run, calculate this element's bounds
    contentRect = contentRect || getElementRect(element, offsetParent);
    // Get all 'div' immediate children if not passed by the function
    elementChildren = elementChildren || $(element).children('div');

    _.forEach(elementChildren, function (child) {

        var rect = getElementRect(child, offsetParent);
        // If child has no size, meaning it is hidden, don't calculate it
        if (rect.width > 0 && rect.height > 0) {
            if (rect.left < contentRect.left) {
                contentRect.left = rect.left;
            }
            if (rect.right > contentRect.right) {
                contentRect.right = rect.right;
            }
            if (rect.top < contentRect.top) {
                contentRect.top = rect.top;
            }
            if (rect.bottom > contentRect.bottom) {
                contentRect.bottom = rect.bottom;
            }
        }

        var $child = $(child);
        var grandChildren = $child.children('div');
        // if a child has children and it's overflow value is not 'hidden', calculate their sizes too
        if (grandChildren.length && $child.css('overflow') !== 'hidden') {
            getContentRect(child, offsetParent, grandChildren, contentRect);
        }
    });
    contentRect.width = contentRect.right - contentRect.left;
    contentRect.height = contentRect.bottom - contentRect.top;

    return contentRect;
}

/**
 * Get an element and all it's children dimensions and position relative to the *window* and while ignoring all transforms
 * @param {HTMLElement} element
 * @param {HTMLElement} [offsetParent] the topmost offset parent to calculate position against, if passed an element which is not an offset parent or not a parent of element will be ignored.
 * @param {window|HTMLElement} [scrollContainer] optional alternative element to calculate scroll from. Can also be used to mock window
 * @returns {{top: number, left: number, width: number, height: number, bottom: number, right: number}}
 */
function getBoundingContentRect(element, offsetParent, scrollContainer) {
    scrollContainer = scrollContainer || typeof window !== 'undefined' && window;
    var elementRect = getContentRect(element, offsetParent);
    if (scrollContainer) {
        var scrollY = scrollContainer.pageYOffset || scrollContainer.scrollTop || 0;
        var scrollX = scrollContainer.pageXOffset || scrollContainer.scrollLeft || 0;

        elementRect.top -= scrollY;
        elementRect.bottom -= scrollY;
        elementRect.left -= scrollX;
        elementRect.right -= scrollX;
    }
    return elementRect;
}

module.exports = {
    getElementRect: getElementRect,
    getBoundingRect: getBoundingRect,
    getContentRect: getContentRect,
    getBoundingContentRect: getBoundingContentRect
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//******************************************************* SHA256 *******************************************************
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2 Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 * Also http://anmar.eu.org/projects/jssha2/
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */

var hexcase = 0;
/* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad = '';
/* base-64 pad character. "=" for strict RFC compliance   */

//            /*
//             * Perform a simple self-test to see if the VM is working
//             */
//            function sha256_vm_test()
//            {
//                return hex_sha256("abc").toLowerCase() ==
//                    "ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad";
//            }

/*
 * Calculate the sha256 of a raw string
 */
function rstr_sha256(s) {
    return binb2rstr(binb_sha256(rstr2binb(s), s.length * 8));
}

/*
 * Calculate the HMAC-sha256 of a key and some data (raw strings)
 */
function rstr_hmac_sha256(key, data) {
    var bkey = rstr2binb(key);
    if (bkey.length > 16) {
        bkey = binb_sha256(bkey, key.length * 8);
    }

    var ipad = [],
        opad = [];
    /* Arrays are of size 16 */
    for (var i = 0; i < 16; i++) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5C5C5C5C;
    }

    var hash = binb_sha256(ipad.concat(rstr2binb(data)), 512 + data.length * 8);
    return binb2rstr(binb_sha256(opad.concat(hash), 512 + 256));
}

/*
 * Convert a raw string to a hex string
 */
function rstr2hex(input) {
    var hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef';
    var output = '';
    var x = void 0;
    for (var i = 0; i < input.length; i++) {
        x = input.charCodeAt(i);
        output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
    }
    return output;
}

/*
 * Convert a raw string to a base-64 string
 */
function rstr2b64(input) {
    var tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var output = '';
    var len = input.length;
    for (var i = 0; i < len; i += 3) {

        var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
        for (var j = 0; j < 4; j++) {
            if (i * 8 + j * 6 > input.length * 8) {
                output += b64pad;
            } else {
                output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
            }
        }
    }
    return output;
}

/*
 * Convert a raw string to an arbitrary string encoding
 */
function rstr2any(input, encoding) {
    var divisor = encoding.length;
    var remainders = [];
    var i = void 0,
        q = void 0,
        x = void 0,
        quotient = void 0;

    /* Convert to an array of 16-bit big-endian values, forming the dividend */
    var dividend = [];
    var length = Math.ceil(input.length / 2);
    for (i = 0; i < length; i++) {
        dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
    }

    /*
     * Repeatedly perform a long division. The binary array forms the dividend,
     * the length of the encoding is the divisor. Once computed, the quotient
     * forms the dividend for the next step. We stop when the dividend is zero.
     * All remainders are stored for later use.
     */
    while (dividend.length > 0) {
        quotient = [];
        x = 0;
        for (i = 0; i < dividend.length; i++) {
            x = (x << 16) + dividend[i];
            q = Math.floor(x / divisor);
            x -= q * divisor;
            if (quotient.length > 0 || q > 0) {
                quotient[quotient.length] = q;
            }
        }
        remainders[remainders.length] = x;
        dividend = quotient;
    }

    /* Convert the remainders to the output string */
    var output = '';
    for (i = remainders.length - 1; i >= 0; i--) {
        output += encoding.charAt(remainders[i]);
    }

    /* Append leading zero equivalents */
    var full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
    for (i = output.length; i < full_length; i++) {
        output = encoding[0] + output;
    }

    return output;
}

/*
 * Encode a string as utf-8.
 * For efficiency, this assumes the input is valid utf-16.
 */
function str2rstr_utf8(input) {
    var output = '';
    var i = -1;
    var x = void 0,
        y = void 0;

    while (++i < input.length) {
        /* Decode utf-16 surrogate pairs */
        x = input.charCodeAt(i);
        y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
        if (x >= 0xD800 && x <= 0xDBFF && y >= 0xDC00 && y <= 0xDFFF) {
            x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
            i++;
        }

        /* Encode output as utf-8 */
        if (x <= 0x7F) {
            output += String.fromCharCode(x);
        } else if (x <= 0x7FF) {
            output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);
        } else if (x <= 0xFFFF) {
            output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
        } else if (x <= 0x1FFFFF) {
            output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
        }
    }
    return output;
}

/*
 * Encode a string as utf-16
 */
/*
 function str2rstr_utf16le(input) {
 var output = "";
 for (var i = 0; i < input.length; i++) {
 output += String.fromCharCode(input.charCodeAt(i) & 0xFF,
 (input.charCodeAt(i) >>> 8) & 0xFF);
 }
 return output;
 }
 function str2rstr_utf16be(input) {
 var output = "";
 for (var i = 0; i < input.length; i++) {
 output += String.fromCharCode((input.charCodeAt(i) >>> 8) & 0xFF,
 input.charCodeAt(i) & 0xFF);
 }
 return output;
 }
 */

/*
 * Convert a raw string to an array of big-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function rstr2binb(input) {
    var output = [];
    var length = input.length >> 2;
    for (var i = 0; i < length; i++) {
        output[i] = 0;
    }
    for (var ii = 0; ii < input.length * 8; ii += 8) {
        output[ii >> 5] |= (input.charCodeAt(ii / 8) & 0xFF) << 24 - ii % 32;
    }
    return output;
}

/*
 * Convert an array of big-endian words to a string
 */
function binb2rstr(input) {
    var output = '';
    for (var i = 0; i < input.length * 32; i += 8) {
        output += String.fromCharCode(input[i >> 5] >>> 24 - i % 32 & 0xFF);
    }
    return output;
}

/*
 * Main sha256 function, with its support functions
 */
function sha256_S(X, n) {
    return X >>> n | X << 32 - n;
}

function sha256_R(X, n) {
    return X >>> n;
}

function sha256_Ch(x, y, z) {
    return x & y ^ ~x & z;
}

function sha256_Maj(x, y, z) {
    return x & y ^ x & z ^ y & z;
}

function sha256_Sigma0256(x) {
    return sha256_S(x, 2) ^ sha256_S(x, 13) ^ sha256_S(x, 22);
}

function sha256_Sigma1256(x) {
    return sha256_S(x, 6) ^ sha256_S(x, 11) ^ sha256_S(x, 25);
}

function sha256_Gamma0256(x) {
    return sha256_S(x, 7) ^ sha256_S(x, 18) ^ sha256_R(x, 3);
}

function sha256_Gamma1256(x) {
    return sha256_S(x, 17) ^ sha256_S(x, 19) ^ sha256_R(x, 10);
}

/*
 function sha256_Sigma0512(x) {
 return (sha256_S(x, 28) ^ sha256_S(x, 34) ^ sha256_S(x, 39));
 }

 function sha256_Sigma1512(x) {
 return (sha256_S(x, 14) ^ sha256_S(x, 18) ^ sha256_S(x, 41));
 }

 function sha256_Gamma0512(x) {
 return (sha256_S(x, 1) ^ sha256_S(x, 8) ^ sha256_R(x, 7));
 }

 function sha256_Gamma1512(x) {
 return (sha256_S(x, 19) ^ sha256_S(x, 61) ^ sha256_R(x, 6));
 }
 */

var sha256_K = [1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998];

function binb_sha256(m, l) {
    var HASH = [1779033703, -1150833019, 1013904242, -1521486534, 1359893119, -1694144372, 528734635, 1541459225];
    var W = []; // size = 64
    var a = void 0,
        b = void 0,
        c = void 0,
        d = void 0,
        e = void 0,
        f = void 0,
        g = void 0,
        h = void 0;
    var i = void 0,
        j = void 0,
        T1 = void 0,
        T2 = void 0;

    /* append padding */
    m[l >> 5] |= 0x80 << 24 - l % 32;
    m[(l + 64 >> 9 << 4) + 15] = l;

    for (i = 0; i < m.length; i += 16) {
        a = HASH[0];
        b = HASH[1];
        c = HASH[2];
        d = HASH[3];
        e = HASH[4];
        f = HASH[5];
        g = HASH[6];
        h = HASH[7];

        for (j = 0; j < 64; j++) {
            if (j < 16) {
                W[j] = m[j + i];
            } else {
                W[j] = safe_add(safe_add(safe_add(sha256_Gamma1256(W[j - 2]), W[j - 7]), sha256_Gamma0256(W[j - 15])), W[j - 16]);
            }

            T1 = safe_add(safe_add(safe_add(safe_add(h, sha256_Sigma1256(e)), sha256_Ch(e, f, g)), sha256_K[j]), W[j]);
            T2 = safe_add(sha256_Sigma0256(a), sha256_Maj(a, b, c));
            h = g;
            g = f;
            f = e;
            e = safe_add(d, T1);
            d = c;
            c = b;
            b = a;
            a = safe_add(T1, T2);
        }

        HASH[0] = safe_add(a, HASH[0]);
        HASH[1] = safe_add(b, HASH[1]);
        HASH[2] = safe_add(c, HASH[2]);
        HASH[3] = safe_add(d, HASH[3]);
        HASH[4] = safe_add(e, HASH[4]);
        HASH[5] = safe_add(f, HASH[5]);
        HASH[6] = safe_add(g, HASH[6]);
        HASH[7] = safe_add(h, HASH[7]);
    }
    return HASH;
}

function safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}

module.exports = {
    SHA256: {
        /*
             * These are the functions you'll usually want to call
             * They take string arguments and return either hex or base-64 encoded strings
             */
        hex_sha256: function hex_sha256(s) {
            return rstr2hex(rstr_sha256(str2rstr_utf8(s)));
        },
        b64_sha256: function b64_sha256(s) {
            return rstr2b64(rstr_sha256(str2rstr_utf8(s)));
        },
        any_sha256: function any_sha256(s, e) {
            return rstr2any(rstr_sha256(str2rstr_utf8(s)), e);
        },
        hex_hmac_sha256: function hex_hmac_sha256(k, d) {
            return rstr2hex(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)));
        },
        b64_hmac_sha256: function b64_hmac_sha256(k, d) {
            return rstr2b64(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)));
        },
        any_hmac_sha256: function any_hmac_sha256(k, d, e) {
            return rstr2any(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)), e);
        }
    }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Regular Expressions for parsing tags and attributes

var startTag = /^<([-A-Za-z0-9_?:]+)((?:\s+(?:x:)?[-A-Za-z0-9_]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/,
    endTag = /^<\/([-A-Za-z0-9_?:]+)[^>]*>/,
    attr = /((?:x:)?[-A-Za-z0-9_]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|([^>\s]+)))?/g;

// Empty Elements - HTML 4.01
var empty = makeMap('area,base,basefont,br,col,frame,hr,img,input,isindex,link,meta,param,embed');

// Block Elements - HTML 4.01
var block = makeMap('address,applet,blockquote,button,center,dd,del,dir,div,dl,dt,fieldset,form,frameset,hr,iframe,ins,isindex,li,map,menu,noframes,noscript,object,ol,p,pre,script,table,tbody,td,tfoot,th,thead,tr,ul');

// Inline Elements - HTML 4.01
var inline = makeMap('a,abbr,acronym,applet,b,basefont,bdo,big,br,button,cite,code,del,dfn,em,font,i,iframe,img,input,ins,kbd,label,map,object,q,s,samp,script,select,small,span,strike,strong,sub,sup,textarea,tt,u,var');

// Elements that you can, intentionally, leave open
// (and which close themselves)
var closeSelf = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr');

// Attributes that have their values filled in disabled="disabled"
var fillAttrs = makeMap('checked,compact,declare,defer,disabled,ismap,multiple,nohref,noresize,noshade,nowrap,readonly,selected');

// Special Elements (can contain anything)
var special = makeMap('script,style');

function handleChars(all, text) {
    text = text.replace(/<!--(.*?)-->/g, '$1').replace(/<!\[CDATA\[(.*?)]]>/g, '$1');

    if (this.chars) {
        this.chars(text);
    }
    return '';
}

var HTMLParser = function HTMLParser(html, handler) {
    var index = void 0,
        chars = void 0,
        match = void 0,
        last = html;
    var stack = [];
    stack.last = function () {
        return this[this.length - 1];
    };

    while (html) {
        chars = true;

        // Make sure we're not in a script or style element
        if (!stack.last() || !special[stack.last()]) {

            // Comment
            if (html.indexOf('<!--') === 0) {
                index = html.indexOf('-->');

                if (index >= 0) {
                    if (handler.comment) {
                        handler.comment(html.substring(4, index));
                    }
                    html = html.substring(index + 3);
                    chars = false;
                }

                // end tag
            } else if (html.indexOf('</') === 0) {
                match = html.match(endTag);

                if (match) {
                    html = html.substring(match[0].length);
                    match[0].replace(endTag, parseEndTag);
                    chars = false;
                }

                // start tag
            } else if (html.indexOf('<') === 0) {
                match = html.match(startTag);

                if (match) {
                    html = html.substring(match[0].length);
                    match[0].replace(startTag, parseStartTag);
                    chars = false;
                }
            }

            if (chars) {
                index = html.indexOf('<');

                var text = index < 0 ? html : html.substring(0, index);
                html = index < 0 ? '' : html.substring(index);

                if (handler.chars) {
                    handler.chars(text);
                }
            }
        } else {
            html = html.replace(new RegExp('(.*)</' + stack.last() + '[^>]*>', 'i'), handleChars.bind(handler));

            parseEndTag('', stack.last());
        }

        if (html === last) {
            throw 'Parse Error: ' + html;
        }
        last = html;
    }

    // Clean up any remaining tags
    parseEndTag();

    function parseStartTag(tag, tagName, rest, unary) {
        tagName = tagName.toLowerCase();

        if (block[tagName]) {
            while (stack.last() && inline[stack.last()]) {
                parseEndTag('', stack.last());
            }
        }

        if (closeSelf[tagName] && stack.last() === tagName) {
            parseEndTag('', tagName);
        }

        unary = empty[tagName] || !!unary;

        if (!unary) {
            stack.push(tagName);
        }

        if (handler.start) {
            var attrs = [];

            rest.replace(attr, function (mtch, name) {
                var value = null;
                for (var i = 2; i < 5; i++) {
                    if (value === null && arguments[i]) {
                        value = arguments[i];
                        break;
                    }
                }
                if (value === null && fillAttrs[name]) {
                    value = name;
                }
                if (value === null) {
                    value = '';
                }

                attrs.push({
                    name: name,
                    value: value,
                    escaped: value.replace(/(^|[^\\])"/g, '$1\\\"') //"
                });
            });

            if (handler.start) {
                handler.start(tagName, attrs, unary, tag);
            }
        }
    }

    function parseEndTag(tag, tagName) {
        // If no tag name is provided, clean shop
        var pos = void 0;
        if (!tagName) {
            pos = 0;
        } else {
            // Find the closest opened tag of the same type
            for (pos = stack.length - 1; pos >= 0; pos--) {
                if (stack[pos] === tagName) {
                    break;
                }
            }
        }

        if (pos >= 0) {
            // Close all the open elements, up the stack
            for (var i = stack.length - 1; i >= pos; i--) {
                if (handler.end) {
                    handler.end(stack[i]);
                }
            }

            // Remove the open elements from the stack
            stack.length = pos;
        }
    }
};

function makeMap(str) {
    var obj = {},
        items = str.split(',');
    for (var i = 0; i < items.length; i++) {
        obj[items[i]] = true;
    }
    return obj;
}
module.exports = HTMLParser;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var htmlParser = __webpack_require__(11);

/**
 * @param {object} attributes
 * @returns {string}
 */
function getAttributesString(attributes) {
    return _.reduce(attributes, function (result, attrObj) {
        return result + ' ' + attrObj.name + '="' + attrObj.escaped + '" ';
    }, '');
}

function transformHTMLString(html, handler) {
    var htmlResult = '';
    var currentTag = '';

    htmlParser(html, {
        start: function start(tag, attributes, selfClosing) {
            var result = {
                tag: tag,
                attributes: attributes,
                selfClosing: selfClosing
            };
            currentTag = selfClosing ? '' : tag;
            if (handler.start) {
                result = handler.start(tag, attributes, selfClosing);
            }
            if (result) {
                htmlResult += '<' + result.tag + getAttributesString(result.attributes) + (result.selfClosing ? '/>' : '>');
            }
        },
        end: function end(tag) {
            if (handler.end) {
                tag = handler.end(tag);
            }
            currentTag = '';
            if (tag) {
                htmlResult += '</' + tag + '>';
            }
        },
        chars: function chars(text) {
            if (handler.chars) {
                text = handler.chars(text, currentTag);
            }
            htmlResult += text;
        },
        comment: function comment(text) {
            if (handler.comment) {
                text = handler.comment(text);
            }
            if (text) {
                htmlResult += '<!--' + text + '-->';
            }
        }
    });

    return htmlResult;
}

module.exports = {
    /**
     * @param {string} html
     * @param {object} handler
     * @returns {*}
     */
    transformHTMLString: transformHTMLString
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint no-console:0*/


var _ = __webpack_require__(0);
var urlUtils = __webpack_require__(15);
var log = console.log.bind(console);
var BASE_DEPRECATION_MESSAGE = 'DocumentServices|Deprecated|';

var debugEnabled = isDebug();
var verbose = debugEnabled ? log : _.noop;

function isDebug() {
    return typeof window === 'undefined' ? true : urlUtils.parseUrl(_.get(window, ['location', 'href'], '')).query.debug === 'all';
}

module.exports = {
    isDebug: isDebug,
    verbose: verbose,
    info: log,
    warn: console.warn.bind(console),
    error: console.error.bind(console),
    warnDeprecation: function warnDeprecation(deprecationMessage) {
        if (debugEnabled) {
            console.error.call(console, BASE_DEPRECATION_MESSAGE + deprecationMessage);
        }
    }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function map(value, x1, x2, y1, y2) {
    return (value - x1) * ((y2 - y1) / (x2 - x1)) + y1;
}

function parseDegrees(x) {
    if (typeof x !== 'number') {
        return NaN;
    }
    return (x % 360 + 360) % 360;
}

function interpolateSegmentsFunction(couples) {
    var xys = _.unzip(couples);
    var xs = xys[0];
    var ys = xys[1];

    return function (val) {
        var seg = 0;

        while (seg < xs.length - 2 && val > xs[seg + 1]) {
            seg++;
        }

        var res = map(val, xs[seg], xs[seg + 1], ys[seg], ys[seg + 1]);
        return res;
    };
}

module.exports = {
    map: map,
    parseDegrees: parseDegrees,
    interpolateSegmentsFunction: interpolateSegmentsFunction
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var stringUtils = __webpack_require__(5);

function addProtocolIfMissing(url, protocol) {
    var beginsWithProtocol = /^(ftps|ftp|http|https):.*$/.test(url),
        beginsWithDoubleSlash = /^\/\//.test(url);

    if (beginsWithProtocol) {
        return url;
    }

    protocol = protocol || 'https:';
    if (beginsWithDoubleSlash) {
        return protocol + url;
    }

    return protocol + '//' + url;
}

function setProtocol(url, protocol) {
    if (!_.includes(['ftp:', 'http:', 'https:'], protocol)) {
        return url;
    }

    url = addProtocolIfMissing(url, protocol);

    if (!_.startsWith(url, protocol + '//')) {
        var splitUrl = url.split('//');
        url = [protocol, '//', splitUrl[1]].join('');
    }

    return url;
}

function toQueryString(jsonObj, convertBool) {
    return _.map(jsonObj, function (value, key) {
        return toQueryParam(key, value, convertBool);
    }).sort().join('&');
}

function toQueryParam(key, val, convertBool) {
    key = encodeURIComponent(key);
    if (!val && val !== 0 && val !== false) {
        return key;
    }
    key += '=';
    if (_.isArray(val)) {
        return _.map(val, function (innerVal) {
            return key + encodeURIComponent(innerVal);
        }).join('&');
    }
    if (convertBool && typeof val === 'boolean') {
        val = val ? '1' : '0';
    } else {
        val = encodeURIComponent(val);
    }
    return key + val;
}

function baseUrl(url) {
    var parsed = parseUrl(url);
    return parsed.protocol + '//' + parsed.host;
}

function getPath(url) {
    var parsed = parseUrl(url);
    return parsed.path;
}

function getBaseUrlWithPath(urlObj, pathPartsCount) {
    var path = urlObj.path || urlObj.pathname || '';
    var pathParts = path.split('/');
    var pathPartsToUse = _.compact(pathParts.slice(0, (pathPartsCount || 0) + 1));
    var url = urlObj.protocol + '//' + urlObj.hostname;
    if (!_.isEmpty(pathPartsToUse)) {
        url += '/' + pathPartsToUse.join('/');
    }
    return url;
}

var uniqueCounter = 0;

function cacheKiller() {
    return new Date().getTime().toString() + uniqueCounter++;
}
function resetCacheKiller() {
    uniqueCounter = 0;
}

var persistentCacheKillerValue = null;

function persistentCacheKiller() {
    persistentCacheKillerValue = persistentCacheKillerValue || new Date().getTime().toString();
    return persistentCacheKillerValue;
}

function resetPersistentCacheKiller() {
    persistentCacheKillerValue = null;
}

function setPersistentCacheKiller(k) {
    persistentCacheKillerValue = k;
}

var urlRe = /((https?\:)\/\/)?([^\?\:\/#]+)(\:([0-9]+))?(\/[^\?\#]*)?(\?([^#]*))?(#.*)?/i;

function parseUrl(url) {
    if (!url) {
        return {};
    }

    var match = url.match(urlRe);
    var port = match[5] || '';
    var search = match[8] ? '?' + match[8] : '';
    var ret = {
        full: url,
        protocol: match[2] || 'http:',
        host: match[3] + (port ? ':' + port : ''),
        hostname: match[3],
        port: port,
        path: match[6] || '/',
        search: search,
        hash: match[9] || ''

        // fix empty hash
    };if (ret.hash === '#' || ret.hash === '#!') {
        ret.hash = '';
    }

    ret.query = parseUrlParams(match[8]);
    return ret;
}

function safeDecodeURIComponent(encodedURIParam) {
    try {
        return decodeURIComponent(encodedURIParam);
    } catch (e) {
        return encodedURIParam;
    }
}

function parseUrlParams(queryString) {
    var re = /([^&=]+)=([^&]*)/g;
    var query = {};
    var param = void 0;

    while ((param = re.exec(queryString)) !== null) {
        var key = safeDecodeURIComponent(param[1]);
        var val = safeDecodeURIComponent(param[2]);
        if (!query[key]) {
            // first value for key, keep as string
            query[key] = val;
        } else if (_.isArray(query[key])) {
            // more than one value already, push to the array
            query[key].push(val);
        } else {
            // the 2nd value for the key, turn into an array
            query[key] = [query[key], val];
        }
    }

    return query;
}

function setUrlParam(url, paramName, value) {
    var urlParts = url.split('?');
    var paramList = [];
    var replaced = false;
    if (urlParts.length > 1) {
        paramList = urlParts[1].split('&');
        var paramIndex = _.findIndex(paramList, function (param) {
            return stringUtils.startsWith(param, paramName + '=');
        });
        if (paramIndex !== -1) {
            paramList[paramIndex] = paramName + '=' + String(value);
            replaced = true;
        }
    }

    if (!replaced) {
        paramList.push(paramName + '=' + String(value));
    }

    urlParts[1] = paramList.join('&');
    url = urlParts.join('?');
    return url;
}

function removeUrlParam(url, paramName) {
    var urlObj = parseUrl(url);
    delete urlObj.search;
    if (urlObj.query) {
        delete urlObj.query[paramName];
    }

    return buildFullUrl(urlObj);
}

function setUrlParams(url, params) {
    var urlObj = parseUrl(url);
    _.assign(urlObj.query, params);
    return buildFullUrl(urlObj, true);
}

function buildFullUrl(urlObj, ignoreSearch) {
    var search = ignoreSearch ? null : urlObj.search;
    if (search) {
        search = search.replace(/^[?]/, '');
    }

    var query = search || toQueryString(urlObj.query || {});

    if (query) {
        var queryPrefix = _.includes(urlObj.path, '?') ? '&' : '?';
        query = queryPrefix + query;
    }

    return isLocalUrl(urlObj.full) ? urlObj.full : urlObj.protocol + '//' + urlObj.hostname + (urlObj.port ? ':' + urlObj.port : '') + urlObj.path + (query || '') + urlObj.hash;
}

function isExternalUrl(url) {
    return (/(^https?)|(^data)|(^blob)|(^\/\/)/.test(url)
    );
}

function isRelativeUrl(url) {
    return (/^\/(.*)/.test(url)
    );
}

function isLocalUrl(url) {
    return (/(^data)|(^blob)/.test(url)
    );
}

function isUrlEmptyOrNone(url) {
    return !url || !url.trim() || url.toLowerCase() === 'none';
}

function simplifyUrl(url) {
    return url && url.replace(/[?&#/]+$/, '').toLowerCase();
}

function isSameUrl(url1, url2) {
    return simplifyUrl(url1) === simplifyUrl(url2);
}

function joinURL() {
    var url = arguments[0];
    for (var i = 1; i < arguments.length; ++i) {
        url = url.replace(/\/$/, '') + '/' + arguments[i].replace(/^\//, '');
    }
    return url;
}

function updateUrl(url) {
    if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', url);
    } else {
        console.error('window.history is not supported in this OLD browser!'); // eslint-disable-line no-console
        //Not supported only in IE9
    }
}

/**
 * builds URL and path by querying the image uri
 * @param imageUri
 * @param staticMediaUrl
 * @param mediaRootUrl
 * @returns {string}
 */
function getMediaUrlByContext(imageUri, staticMediaUrl, mediaRootUrl) {
    if (isExternalUrl(imageUri)) {
        return imageUri;
    }
    var path = staticMediaUrl + '/';
    if (imageUri) {
        if (/^micons\//.test(imageUri)) {
            path = mediaRootUrl;
        } else if (/[^.]+$/.exec(imageUri)[0] === 'ico') {
            //if the image is an icon then it's taken from a slightly different place
            path = path.replace('media', 'ficons');
        }
    }
    return path + imageUri;
}

/**
 * checks if query param is present in parsed URL
 * @param urlObj
 * @param queryParam
 * @returns {boolean}
 */
function isQueryParamOn(urlObj, queryParam) {
    return _.has(urlObj.query, queryParam) && urlObj.query[queryParam] !== 'false';
}

/**
 * returns true if the url has the param and it's value equals true
 * @param {string} name
 * @param {string?} urlQueries
 * @return {boolean}
 */
function isTrue(name, urlQueries) {
    return getParameterByName(name, urlQueries) === 'true';
}

/**
* A cross browser solution for window.location.origin for IE
* @return {string}
*/
function origin(currentUrlObj) {
    if (currentUrlObj) {
        return currentUrlObj.protocol + '//' + currentUrlObj.hostname + currentUrlObj.port;
    } else if (typeof window !== 'undefined') {
        if (window.location.origin) {
            //eslint-disable-line santa/no-window-location-origin
            return window.location.origin; //eslint-disable-line santa/no-window-location-origin
        }
        var port = window.location.port ? ':' + window.location.port : '';
        return window.location.protocol + '//' + window.location.hostname + port;
    }
}

// https://yandex.ru/support/metrika/general/counter-webvisor.xml
function isHostnameYandexWebvisor(hostname) {
    return (/^(.*\.)?(mtproxy|hghltd)\.yandex\.net$/.test(hostname)
    );
}

function getParameterByName(name, urlQueries) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i'),
        results = regex.exec(urlQueries || window.location.search);
    return results === null ? '' : safeDecodeURIComponent(results[1].replace(/\+/g, ' '));
}

module.exports = {
    addProtocolIfMissing: addProtocolIfMissing,
    toQueryString: toQueryString,
    toQueryParam: toQueryParam,
    baseUrl: baseUrl,
    getPath: getPath,
    cacheKiller: cacheKiller,
    resetCacheKiller: resetCacheKiller,
    setPersistentCacheKiller: setPersistentCacheKiller,
    persistentCacheKiller: persistentCacheKiller,
    resetPersistentCacheKiller: resetPersistentCacheKiller,
    removeUrlParam: removeUrlParam,
    setUrlParam: setUrlParam,
    setUrlParams: setUrlParams,
    isExternalUrl: isExternalUrl,
    isRelativeUrl: isRelativeUrl,
    isUrlEmptyOrNone: isUrlEmptyOrNone,
    updateUrl: updateUrl,

    /**
     * @typedef {object} ParseUrlReturnType
     * @property {string} full The whole URL that was passed
     * @property {string} protocol The protocol (http: or https:)
     * @property {string} host The host of the URL, including port
     * @property {string} hostname The host name of the URL, not including port
     * @property {string} port The port, or empty string
     * @property {string} path The path after the host
     * @property {object} query The query string as object containing string keys, and values will be the following:
     *  string, if there's one param
     *  array, if there's more than one value for the params
     * @property {string} search The full search string, including the question mark
     * @property {string} hash The hash that was passed, including the hash sign or empty string
     */

    /**
     * Parses a URL and returns an object with sliced down parameters
     * @returns {ParseUrlReturnType} The parsed object
     */
    parseUrl: parseUrl,
    parseUrlParams: parseUrlParams,
    buildFullUrl: buildFullUrl,

    isQueryParamOn: isQueryParamOn,
    isTrue: isTrue,

    isSame: isSameUrl,
    joinURL: joinURL,
    getMediaUrlByContext: getMediaUrlByContext,
    origin: origin,
    getBaseUrlWithPath: getBaseUrlWithPath,
    getParameterByName: getParameterByName,
    isHostnameYandexWebvisor: isHostnameYandexWebvisor,
    setProtocol: setProtocol
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cssUtils = __webpack_require__(6);
var _ = __webpack_require__(0);
var CONSTANTS = __webpack_require__(76);

var GOOGLE_FONT_SERVICE_URL = '//fonts.googleapis.com/css?family=';

var createFontUtils = function createFontUtils(fontsMetadata) {
    var parseFontStr = cssUtils.parseFontStr;

    function getFontsUrlWithParams(fontNamesObject, documentType, characterSets) {
        var fontsFamiliesArray = _.isArray(fontNamesObject) ? fontNamesObject : _.keys(fontNamesObject);
        var query = getFontsQuery(fontsFamiliesArray, documentType, characterSets);
        if (query) {
            return GOOGLE_FONT_SERVICE_URL + query;
        }

        return '';
    }

    function getFontsQuery(fontsFamiliesArray, documentType, characterSets) {
        var fontQuery = '';
        var permissions = getFontsPermissions(documentType);
        _.forEach(fontsFamiliesArray, function (fontFamily) {
            var font = fontsMetadata[fontFamily];
            if (font && font.cdnName && _.includes(permissions, font.permissions)) {
                fontQuery += font.cdnName + ':n,b,i,bi|';
            }
        });
        if (fontQuery === '') {
            return null;
        }
        if (characterSets) {
            fontQuery += '&subset=' + characterSets.join(',');
        }
        return fontQuery;
    }

    function getFontsPermissions(documentType) {
        var permissions = ['all', 'legacy'];
        if (documentType === 'WixSite') {
            permissions.push('studio');
        }
        return permissions;
    }

    function getWixStoredFontsCssUrlsWithParams(baseUrl, characterSets, altBaseUrl) {
        if (altBaseUrl && /localhost|127.0.0.\d/.test(baseUrl)) {
            baseUrl = altBaseUrl;
        }
        baseUrl = baseUrl.replace(/^http:/, '');
        var fontsCssBaseUrl = baseUrl.replace(/\/$/, '') + '/static/css/user-site-fonts/';
        return _.map(characterSets, function (cs) {
            return fontsCssBaseUrl + cs + '.css';
        });
    }

    function parseStyleFont(fontStyleName, themeFonts, themeColors) {
        if (themeFonts[fontStyleName]) {
            var fontObject = parseStringFont(themeFonts[fontStyleName]);
            return parseThemeFontColor(fontObject, themeColors);
        }
        return parseStringFont(fontStyleName);
    }

    function parseStringFont(fontValue) {
        var fontObject = parseFontStr(fontValue);
        fontObject.fontWithFallbacks = getFontFamilyWithFallbacks(fontObject.family);
        return fontObject;
    }

    function getFontFamilyWithFallbacks(fontName) {
        var font = fontsMetadata[fontName.toLowerCase()];
        var fontFamily = font && font.fontFamily;
        var fallbacks = void 0;

        if (font) {
            fallbacks = fontFamily;
            if (font.fallbacks !== '') {
                fallbacks += ',' + font.fallbacks;
            }
            fallbacks += ',' + font.genericFamily;
        } else {
            fallbacks = fontName;
        }

        return formatFallbackList(fallbacks);
    }

    function formatFallbackList(fallbacks) {
        //surround fonts with quotes if font name contains spaces or non-latin chars
        return _(fallbacks).split(',').invokeMap('replace', /.*[^\w\d\-].*/, '"$&"').join(',');
    }

    function parseThemeFontColor(fontObject, themeColors) {
        var fontColor = fontObject.color && fontObject.color.match(/{([^}]+)}/);
        if (themeColors && fontColor && themeColors[fontColor[1]]) {
            fontObject.cssColor = themeColors[fontColor[1]];
        } else {
            fontObject.cssColor = fontObject.color;
        }
        return fontObject;
    }

    function getFontFamily(fontStr) {
        return fontStr.split(' ')[4];
    }

    function fontToCSSWithColor(font, themeColors) {
        var fontVal = getFontVal(font);
        var fontCss = getFontCSSFromFontString(fontVal);
        var colorCss = getColorCSSFromFontString(fontVal, themeColors);

        return fontCss + colorCss;
    }

    function getFontVal(fontString, themeData) {
        if (_.startsWith(fontString, 'font_')) {
            var fontParts = fontString.split('font_');
            if (fontParts.length === 2) {
                return themeData.font[fontParts[1]];
            }
        }
        return fontString;
    }

    function getFontFallback(fontFamily) {
        var cleanFontName = fontFamily.replace(/\+/g, ' ').toLowerCase();
        var fontMeta = fontsMetadata[cleanFontName];
        if (fontMeta) {
            var fallback = fontMeta.fallbacks;
            if (fallback) {
                fallback += ',';
            }
            fallback += fontMeta.genericFamily;
            return fallback;
        }

        return '';
    }

    function getFontCSSFromFontString(fontVal) {
        var font = fontVal;
        if (_.includes(font, '#')) {
            font = font.slice(0, font.indexOf('#'));
        }
        font = font.replace(/\{color_\d+\}/, '');
        var fontFamily = getFontFamily(font);
        var fullFontFamily = getFullFontFamily(fontFamily);
        var childFont = font.replace(fontFamily, fullFontFamily);
        return childFont + ';';
    }

    function getFullFontFamily(fontFamily) {
        var fullFontFamily = fontFamily;
        var fallback = getFontFallback(fontFamily);
        if (fallback) {
            fullFontFamily = fullFontFamily + ',' + fallback;
        }

        //surround fonts with quotes if font name contains spaces or non-latin chars
        fullFontFamily = fullFontFamily.replace(/[^,]*[^\w,\d\-][^,]*/g, function (fontFamilyStr) {
            return '\'' + fontFamilyStr.replace(/\+/g, ' ') + '\'';
        });
        return fullFontFamily;
    }

    function getColorCSSFromFontString(fullFontString, themeColors) {
        var colorParts = fullFontString.match(/{color_(\d+)}/);
        if (!colorParts) {
            var colorFromFontString = fullFontString.match(/#[A-Z0-9]{3,6}/);
            if (colorFromFontString) {
                return 'color:' + colorFromFontString[0] + ';';
            }
            return '';
        }
        var colorIndexInTheme = colorParts[1];
        var colorFromTheme = themeColors[colorIndexInTheme];
        if (colorFromTheme.indexOf('#') === 0) {
            return 'color:' + colorFromTheme + ';';
        }
        return 'color:rgba(' + colorFromTheme + ');';
    }

    function getFontFamilyPermissions(fontFamily) {
        var fontDef = _.find(fontsMetadata, { fontFamily: fontFamily });
        return fontDef && fontDef.permissions;
    }

    function getFontsMetaData() {
        return fontsMetadata;
    }

    function collectFontsFromTextDataArray(textDataArray) {
        var fontOverridesRegex = /(<[^>]+["']font-family:\s*)([^,;]+)([,;])/g;

        return _.reduce(textDataArray, function (acc, textData) {
            fontOverridesRegex.lastIndex = 0;
            var match = void 0;
            while (match = fontOverridesRegex.exec(textData)) {
                acc.push(match[2].replace(/['"]/g, ''));
            }
            return acc;
        }, []);
    }

    function isUploadedFontFamily(fontFamilyStr) {
        return fontFamilyStr && _.startsWith(fontFamilyStr, CONSTANTS.LONG_UPLOADED_FONT_PREFIX);
    }

    function getUploadedId(uploadedFonStr) {
        if (uploadedFonStr) {
            uploadedFonStr = uploadedFonStr.split(',');
            var uploadedFontFamily = _.find(uploadedFonStr, function (font) {
                return isUploadedFontFamily(font);
            });
            if (uploadedFontFamily) {
                return uploadedFontFamily.replace(CONSTANTS.LONG_UPLOADED_FONT_PREFIX, '').trim();
            }
        }
        return '';
    }

    function getUploadedFontFaceStyles(uploadedFontsArr, mediaRootUrl) {
        var fixedMediaRootUrl = fixMediaRootUrl(mediaRootUrl);
        return _.reduce(uploadedFontsArr, function (accm, uploadedFont) {
            return accm + getUploadFontFace(getUploadedId(uploadedFont), fixedMediaRootUrl);
        }, '');
    }

    function fixMediaRootUrl(mediaRootUrl) {
        return _.startsWith(mediaRootUrl, 'http://') ? mediaRootUrl.replace('http://', 'https://') : mediaRootUrl;
    }

    function getUploadFontFace(fontGUID, mediaRootUrl) {
        var shortFontName = getShortUploadedFontFamily(fontGUID);

        var fontFaceString = '@font-face {\nfont-family: ' + CONSTANTS.UPLOADED_FONT_PREFIX + shortFontName + ';\nsrc: url("' + mediaRootUrl + 'ufonts/' + fontGUID + '/woff/file.woff") format("woff"),\nurl("' + mediaRootUrl + 'ufonts/' + fontGUID + '/woff2/file.woff2") format("woff2"),\nurl("' + mediaRootUrl + 'ufonts/' + fontGUID + '/ttf/file.ttf") format("ttf");\n}\n';

        return fontFaceString;
    }

    function getShortUploadedFontFamily(fontGUID) {
        return fontGUID.split('_')[1].substr(0, 25);
    }

    function getMetadata(fontNames) {
        return _.compact(_.map(fontNames, function (fontName) {
            return getFontsMetaData()[fontName];
        }));
    }

    function getUploadedFontValue(fontGUID) {
        return CONSTANTS.LONG_UPLOADED_FONT_PREFIX + fontGUID + ',' + CONSTANTS.UPLOADED_FONT_PREFIX + getShortUploadedFontFamily(fontGUID);
    }

    return {
        parseFontStr: parseFontStr,
        getFontsUrlWithParams: getFontsUrlWithParams,
        getWixStoredFontsCssUrlsWithParams: getWixStoredFontsCssUrlsWithParams,
        parseStyleFont: parseStyleFont,
        getFontFamilyWithFallbacks: getFontFamilyWithFallbacks,
        getFontFamily: getFontFamily,
        fontToCSSWithColor: fontToCSSWithColor,
        getFontFallback: getFontFallback,
        getFontFamilyPermissions: getFontFamilyPermissions,
        getFontsMetaData: getFontsMetaData,
        collectFontsFromTextDataArray: collectFontsFromTextDataArray,
        isUploadedFontFamily: isUploadedFontFamily,
        getUploadedId: getUploadedId,
        getUploadedFontFaceStyles: getUploadedFontFaceStyles,
        getMetadata: getMetadata,
        getUploadedFontValue: getUploadedFontValue
    };
};

module.exports = createFontUtils;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var appPartMediaInnerViewNameUtils = {
    getMediaInnerViewNames: function getMediaInnerViewNames() {
        return ['FeaturedInner', 'FeaturedInnerMobile', 'MediaInner', 'MediaInnerCustom', 'PostsListMediaInner', 'SinglePostMediaInner'];
    },
    isMediaInnerViewName: function isMediaInnerViewName(viewName) {
        var mediaInnerViewNames = appPartMediaInnerViewNameUtils.getMediaInnerViewNames();
        return _.includes(mediaInnerViewNames, viewName);
    }
};

module.exports = appPartMediaInnerViewNameUtils;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

/**
 * Inspired by https://www.youtube.com/watch?v=rmV-iVwvqwU
 * @param stringsArray
 * @returns {object<string, bool>}
 */
function toTrueObj(stringsArray) {
    return _.transform(stringsArray, function (acc, str) {
        acc[str] = true;
    }, {});
}

module.exports = {
    toTrueObj: toTrueObj
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ARCHIVE: '56ab6fa4-95ac-4391-9337-6702b8a77011',
    AUTHOR: 'c340212a-6e2e-45cd-9dc4-58d01a5b63a7',
    CATEGORIES: 'categories',
    CUSTOM_FEED: '31c0cede-09db-4ec7-b760-d375d62101e6',
    FEATURED_POSTS: 'c7f57b50-8940-4ff1-83c6-6756d6f0a1f4',
    FEED: '4de5abc5-6da2-4f97-acc3-94bb74285072',
    POSTS_GALLERY: '1b8c501f-ccc2-47e7-952a-47e264752614',
    POSTS_LIST: 'f72fe377-8abc-40f2-8656-89cfe00f3a22',
    SINGLE_POST: 'ea63bc0f-c09f-470c-ac9e-2a408b499f22',
    TAG_CLOUD: 'e000b4bf-9ff1-4e66-a0d3-d4b365ba3af5',
    TICKER: '33a9f5e0-b083-4ccc-b55d-3ca5d241a6eb',
    RELATED_POSTS: 'related-posts',
    HERO_IMAGE: 'hero-image'
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function roundToNearestHalf(num) {
    return Math.round(num * 2) / 2;
}

function degreesToRadians(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}

function getBoundingWidthWithRotation(layout, angleInRadians) {
    var boundingWidthWithRotation = Math.abs(layout.width * Math.cos(angleInRadians)) + Math.abs(layout.height * Math.sin(angleInRadians));
    return roundToNearestHalf(boundingWidthWithRotation);
}

/**
 * @returns {number} the bounding width according to given params.
 *  @param {layout} layout - layout object containing height,width,x,y,angle
 */
function getBoundingWidth(layout) {
    if (layout.rotationInDegrees === 0) {
        return layout.width;
    }
    var currentAngleInRadians = degreesToRadians(layout.rotationInDegrees);
    return getBoundingWidthWithRotation(layout, currentAngleInRadians);
}

function getBoundingHeightWithRotation(layout, angleInRadians) {
    var boundingHeightWithRotation = Math.abs(layout.width * Math.sin(angleInRadians)) + Math.abs(layout.height * Math.cos(angleInRadians));
    return roundToNearestHalf(boundingHeightWithRotation);
}
/**
 * @returns {number} the bounding height according to given params. If angleInRadians === 0, return value === height
 *  @param {layout} layout - layout object containing height,width,x,y,angle
 */
function getBoundingHeight(layout) {
    if (!layout.rotationInDegrees) {
        return layout.height;
    }
    var currentAngleInRadians = degreesToRadians(layout.rotationInDegrees);
    return getBoundingHeightWithRotation(layout, currentAngleInRadians);
}

/**
 * @returns {number} the bounding box's x according to given params. If the component isn't rotated boundingX === component.x
 *  @param {layout} layout - layout object containing height,width,x,y,angle
 */
function getBoundingX(layout) {
    if (layout.rotationInDegrees === 0) {
        return layout.x;
    }
    var boundingWidth = getBoundingWidth(layout);
    return getXAfterRotation(layout, boundingWidth);
}

/**
 * @returns {number} the bounding box's y according to given params. If the component isn't rotated boundingY === component.y
 *  @param {layout} layout - layout object containing height,width,x,y,angle
 */
function getBoundingY(layout) {
    if (!layout.rotationInDegrees) {
        return layout.y;
    }
    var boundingHeight = getBoundingHeight(layout);
    return getYAfterRotation(layout, boundingHeight);
}

function getXAfterRotation(layout, rotatedWidth) {
    return roundToNearestHalf(layout.x - (rotatedWidth - layout.width) / 2);
}

function getYAfterRotation(layout, rotatedHeight) {
    return roundToNearestHalf(layout.y - (rotatedHeight - layout.height) / 2);
}

function rotateAndGetBoundingLayout(layout, rotationInDegrees) {
    if (rotationInDegrees === 0) {
        return _.pick(layout, ['x', 'y', 'width', 'height']);
    }

    var angleInRadians = degreesToRadians(rotationInDegrees);
    var boundingWidth = getBoundingWidthWithRotation(layout, angleInRadians);
    var boundingHeight = getBoundingHeightWithRotation(layout, angleInRadians);
    return {
        x: getXAfterRotation(layout, boundingWidth),
        y: getYAfterRotation(layout, boundingHeight),
        width: boundingWidth,
        height: boundingHeight
    };
}

function getBoundingLayout(layout) {
    return rotateAndGetBoundingLayout(layout, layout.rotationInDegrees || 0);
}

function getLayoutFromBoundingLayout(boundingLayout, currentRotationInDegrees) {
    var layout = rotateAndGetBoundingLayout(boundingLayout, -currentRotationInDegrees); //we rotate it the reverse of the current rotations, and get the new bounding layout
    layout.rotationInDegrees = currentRotationInDegrees;
    return layout;
}

module.exports = {
    getBoundingY: getBoundingY,
    getBoundingX: getBoundingX,
    getBoundingHeight: getBoundingHeight,
    getBoundingWidth: getBoundingWidth,
    getBoundingLayout: getBoundingLayout,
    getLayoutFromBoundingLayout: getLayoutFromBoundingLayout
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint wix-editor/no-unneeded-match:0 complexity:0 */


// code from zepto detect module - https://github.com/madrobby/zepto/blob/master/src/detect.js#files
// note - I added MS Edge detection here, which zepto does not have. -Etai

function detect(ua) {
    if (!ua) {
        return {};
    }
    var os = {},
        browser = {},
        webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
        android = ua.match(/(Android);?[\s\/]+([\d.]+)?/),
        osx = !!ua.match(/\(Macintosh\; Intel /),
        ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/),
        iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
        wp = ua.match(/Windows Phone ([\d.]+)/),
        touchpad = webos && ua.match(/TouchPad/),
        kindle = ua.match(/Kindle\/([\d.]+)/),
        silk = ua.match(/Silk\/([\d._]+)/),
        blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/),
        bb10 = ua.match(/(BB10).*Version\/([\d.]+)/),
        rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
        playbook = ua.match(/PlayBook/),
        chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
        firefox = ua.match(/Firefox\/([\d.]+)/),
        ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
        webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
        safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/),
        edge = ua.match(/Edge\/\d{2,}\.[\d\w]+$/),
        operaMini = ua.match(/Opera Mini/);

    browser.webkit = webkit && !edge;
    if (browser.webkit) {
        browser.version = webkit[1];
    }

    if (android) {
        os.android = true;
        os.version = android[2];
    }
    if (iphone && !ipod) {
        os.ios = os.iphone = true;
        os.version = iphone[2].replace(/_/g, '.');
    }
    if (ipad) {
        os.ios = os.ipad = true;
        os.version = ipad[2].replace(/_/g, '.');
    }
    if (ipod) {
        os.ios = os.ipod = true;
        os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    }
    if (wp) {
        os.wp = true;
        os.version = wp[1];
    }
    if (webos) {
        os.webos = true;
        os.version = webos[2];
    }
    if (touchpad) {
        os.touchpad = true;
    }
    if (blackberry) {
        os.blackberry = true;
        os.version = blackberry[2];
    }
    if (bb10) {
        os.bb10 = true;
        os.version = bb10[2];
    }
    if (rimtabletos) {
        os.rimtabletos = true;
        os.version = rimtabletos[2];
    }
    if (playbook) {
        browser.playbook = true;
    }
    if (kindle) {
        os.kindle = true;
        os.version = kindle[1];
    }
    if (silk) {
        browser.silk = true;
        browser.version = silk[1];
    }
    if (!silk && os.android && ua.match(/Kindle Fire/)) {
        browser.silk = true;
    }
    if (chrome && !edge) {
        browser.chrome = true;
        browser.version = chrome[1];
    }
    if (firefox && !edge) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (safari && (osx || os.ios)) {
        browser.safari = true;
        if (osx) {
            browser.version = safari[1];
        }
    }
    if (webview) {
        browser.webview = true;
    }
    if (edge) {
        browser.edge = true;
    }
    if (operaMini) {
        browser.operaMini = true;
    }

    os.tablet = !!(ipad || playbook || android && !ua.match(/Mobile/) || firefox && ua.match(/Tablet/) || (ie || edge) && !ua.match(/Phone/) && ua.match(/Touch/));
    os.phone = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 || chrome && ua.match(/Android/) || chrome && ua.match(/CriOS\/([\d.]+)/) || firefox && ua.match(/Mobile/) || ie && ua.match(/Touch/)));
    os.mac = osx;
    return {
        browser: browser,
        os: os
    };
}

module.exports = detect;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = function (classNames) {
    return _.keys(_.pickBy(classNames, _.identity)).join(' ');
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var defaultParams = {
    position: 'absolute',
    isFullScreen: false,
    getHeight: function getCompHeight(measureMap, compHeight) {
        return compHeight;
    }
};

var fullScreenParams = {
    position: 'fixed',
    isFullScreen: true,
    getHeight: function getWindowOrCompHeight(measureMap, compHeight) {
        return Math.max(measureMap.height.screen, compHeight);
    }
};

var effectNameByBehaviors = {
    BackgroundParallax: ['BackgroundParallax'],
    BackgroundReveal: ['BackgroundReveal'],
    BackgroundParallaxZoom: ['BackgroundParallax', 'BackgroundZoom'],
    BackgroundFadeIn: ['BackgroundFadeIn'],
    BackgroundBlurIn: ['BackgroundBlurIn']
};

var paramsByEffectMap = {
    None: defaultParams,
    BackgroundFadeIn: defaultParams,
    BackgroundBlurIn: defaultParams,
    BackgroundReveal: fullScreenParams,
    BackgroundParallax: fullScreenParams,
    BackgroundParallaxZoom: fullScreenParams

    /**
     *
     * @param effectName
     * @returns {*|string}
     */
};function getPositionByEffect(effectName, renderFixedPositionBackgrounds) {
    if (paramsByEffectMap[effectName] && renderFixedPositionBackgrounds !== false) {
        return paramsByEffectMap[effectName].position;
    }
    return paramsByEffectMap.None.position;
}

/**
 *
 * @param effectName
 * @returns {*|string}
 */
function isFullScreenByEffect(effectName, renderFixedPositionBackgrounds) {
    if (paramsByEffectMap[effectName] && renderFixedPositionBackgrounds !== false) {
        return paramsByEffectMap[effectName].isFullScreen;
    }
    return paramsByEffectMap.None.isFullScreen;
}

/**
 *effectName
 * @param effectName
 * @param measureMap
 * @param compHeight
 * @returns {*}
 */
function getHeightByEffect(effectName, measureMap, compHeight) {
    return paramsByEffectMap[effectName] && paramsByEffectMap[effectName].getHeight(measureMap, compHeight) || paramsByEffectMap.None.getHeight(measureMap, compHeight);
}

/**
 * Get the current effect name of a component
 * @param {string|object|undefined} behaviors
 * @param {SiteData} siteData
 * @returns {string}
 */
function getBgEffectName(behaviors, isDesktopDevice, isMobileView) {
    if (!isDesktopDevice || isMobileView) {
        return '';
    }

    behaviors = _.isString(behaviors) ? JSON.parse(behaviors) : behaviors || [];
    var behaviorNames = _(behaviors).filter({ action: 'bgScrub' }).map('name').sortBy().value();
    return getEffectNameByBehaviors(behaviorNames);
}

/**
 * Return an effect name by list of behaviors
 * @param {array} behaviorNames
 */
function getEffectNameByBehaviors(behaviorNames) {
    return _.findKey(effectNameByBehaviors, function (effectBehaviors) {
        return _.isEqual(_.sortBy(effectBehaviors), behaviorNames);
    });
}

module.exports = {
    getPositionByEffect: getPositionByEffect,
    getHeightByEffect: getHeightByEffect,
    isFullScreenByEffect: isFullScreenByEffect,
    getBgEffectName: getBgEffectName
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Parse a cookie string into an object
 * @param {string} cookieStr - valid cookie string (; separated key=value pairs)
 */

function parseCookieString(cookieStr) {
    var cookieObj = {};
    var cookiesArr = cookieStr.split(/;\s*/);
    for (var i = 0, n = cookiesArr.length; i < n; i++) {
        var cookie = cookiesArr[i].split('=');
        cookieObj[cookie[0]] = cookie[1];
    }

    return cookieObj;
}

/**
 * Get a cookie by name
 * @param name
 * @returns {string}
 */
function getCookie(name) {
    if (typeof document === 'undefined') {
        return undefined;
    }
    var cookieAsObj = parseCookieString(window.document.cookie);
    return cookieAsObj[name];
}

/**
 * Set a cookie in the browser (client-side only)
 * @param name
 * @param value
 * @param time
 * @param domain
 * @param path
 * @param secure
 */
function setCookie(name, value, time, domain, path, secure) {
    if (typeof document === 'undefined') {
        return;
    }

    var cookie = name + '=' + value;
    if (time) {
        cookie += ';expires=';
        if (typeof time === 'number') {
            cookie += new Date(new Date().getTime() + time).toGMTString();
        } else {
            cookie += new Date(time).toGMTString();
        }
    }
    cookie += ';path=' + (path || '/');
    if (domain) {
        cookie += ';domain=' + domain;
    }
    if (secure) {
        cookie += ';secure';
    }
    window.document.cookie = cookie;
}

/**
 * Delete a cookie from the browser (client-side only)
 * @param {string} name - cookie name
 * @param {string} domain - should delete the cookie from the root domain and not the subdomain
 * @param {string} [path] - the path, if it exists
 */
function deleteCookie(name, domain, path) {
    if (typeof document === 'undefined') {
        return;
    }
    domain = domain || (window.document ? window.document.location.host : '');
    setCookie(name, '', 'Thu, 01-Jan-1970 00:00:01', domain, path || '/');
}

var cookieUtils = {
    parseCookieString: parseCookieString,
    setCookie: setCookie,
    getCookie: getCookie,
    deleteCookie: deleteCookie
};

var nop = function nop() {
    return undefined;
};
var nodeCookieUtils = {
    parseCookieString: parseCookieString,
    setCookie: nop,
    getCookie: nop,
    deleteCookie: nop
};

module.exports = typeof document === 'undefined' ? nodeCookieUtils : cookieUtils;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function getChildrenData(structure, isMobile) {
    var children = isMobile ? structure.mobileComponents : structure.children;
    return children || structure.components || [];
}

function getChildrenKey(data, isMobile) {
    if (isMobile && data.mobileComponents) {
        return 'mobileComponents';
    }

    return data.children ? 'children' : 'components';
}

function isMobileStructureExist(masterPageData) {
    return masterPageData.structure.mobileComponents && !_.isEmpty(masterPageData.structure.mobileComponents);
}

function findHierarchyInStructure(id, isMobile, structure) {
    if (structure.id === id) {
        return [structure];
    }
    var structureChildren = getChildrenData(structure, isMobile);
    if (_.isEmpty(structureChildren)) {
        return [];
    }

    var ret = [];
    _.forEach(structureChildren, function (child) {
        var childHierarchy = findHierarchyInStructure(id, isMobile, child);
        if (!_.isEmpty(childHierarchy)) {
            ret = [structure].concat(childHierarchy);
            return false;
        }
    });

    return ret;
}

function getAllCompsInStructure(compStructure, isMobile, filterFunc, breakCondition) {
    var queue = [[compStructure]];
    for (var i = 0; i < queue.length; i++) {
        var innerQueue = queue[i];
        for (var childIndex = 0; childIndex < innerQueue.length; childIndex++) {
            if (breakCondition && filterFunc(innerQueue[childIndex])) {
                return innerQueue[childIndex];
            }
            var childrenData = getChildrenData(innerQueue[childIndex], isMobile);
            if (childrenData.length) {
                queue.push(childrenData);
            }
        }
    }

    return breakCondition ? null : _(queue).flatten().remove(filterFunc).keyBy('id').value();
}

function findCompInStructure(compStructure, isMobile, predicate) {
    return getAllCompsInStructure(compStructure, isMobile, predicate, true);
}

module.exports = {
    getChildrenData: getChildrenData,
    getChildrenKey: getChildrenKey,
    isMobileStructureExist: isMobileStructureExist,
    findHierarchyInStructure: findHierarchyInStructure,
    findCompInStructure: findCompInStructure,
    getAllCompsInStructure: getAllCompsInStructure
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *
 * @param {number} monthIndex a zero-based month index (e.g Jan=0, Aug=7)
 * @returns {string}
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function getMonthName(monthIndex) {
    if (monthIndex < 0 || monthIndex > 11) {
        return '';
    }
    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][monthIndex];
}

/**
 *
 * @param dayIndex zero-based day index (e.g sunday=0)
 * @returns {string}
 */
function getDayName(dayIndex) {
    if (dayIndex < 0 || dayIndex > 6) {
        return '';
    }
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayIndex];
}

var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
    var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
    var timezoneClip = /[^-+\dA-Z]/g;

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc, gmt) {

        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
            mask = date;
            date = undefined;
        }

        date = date || new Date();

        if (!(date instanceof Date)) {
            date = new Date(date);
        }

        if (isNaN(date)) {
            throw TypeError('Invalid date'); // eslint-disable-line new-cap
        }

        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks.default);

        // Allow setting the utc/gmt argument via the mask
        var maskSlice = mask.slice(0, 4);
        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
            mask = mask.slice(4);
            utc = true;
            if (maskSlice === 'GMT:') {
                gmt = true;
            }
        }

        var _ = utc ? 'getUTC' : 'get';
        var d = date[_ + 'Date']();
        var D = date[_ + 'Day']();
        var m = date[_ + 'Month']();
        var y = date[_ + 'FullYear']();
        var H = date[_ + 'Hours']();
        var M = date[_ + 'Minutes']();
        var s = date[_ + 'Seconds']();
        var L = date[_ + 'Milliseconds']();
        var o = utc ? 0 : date.getTimezoneOffset();
        var W = getWeek(date);
        var N = getDayOfWeek(date);
        var flags = {
            d: d,
            dd: pad(d),
            ddd: dateFormat.i18n.dayNames[D],
            dddd: dateFormat.i18n.dayNames[D + 7],
            m: m + 1,
            mm: pad(m + 1),
            mmm: dateFormat.i18n.monthNames[m],
            mmmm: dateFormat.i18n.monthNames[m + 12],
            yy: String(y).slice(2),
            yyyy: y,
            h: H % 12 || 12,
            hh: pad(H % 12 || 12),
            H: H,
            HH: pad(H),
            M: M,
            MM: pad(M),
            s: s,
            ss: pad(s),
            l: pad(L, 3),
            L: pad(Math.round(L / 10)),
            t: H < 12 ? 'a' : 'p',
            tt: H < 12 ? 'am' : 'pm',
            T: H < 12 ? 'A' : 'P',
            TT: H < 12 ? 'AM' : 'PM',
            Z: gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''), // eslint-disable-line no-nested-ternary
            o: (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
            S: ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10], // eslint-disable-line eqeqeq
            W: W,
            N: N
        };

        return mask.replace(token, function (match) {
            if (match in flags) {
                return flags[match];
            }
            return match.slice(1, match.length - 1);
        });
    };
}();

dateFormat.masks = {
    'default': 'ddd mmm dd yyyy HH:MM:ss',
    'shortDate': 'm/d/yy',
    'mediumDate': 'mmm d, yyyy',
    'longDate': 'mmmm d, yyyy',
    'fullDate': 'dddd, mmmm d, yyyy',
    'shortTime': 'h:MM TT',
    'mediumTime': 'h:MM:ss TT',
    'longTime': 'h:MM:ss TT Z',
    'isoDate': 'yyyy-mm-dd',
    'isoTime': 'HH:MM:ss',
    'isoDateTime': 'yyyy-mm-dd\'T\'HH:MM:sso',
    'isoUtcDateTime': 'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
    'expiresHeaderFormat': 'ddd, dd mmm yyyy HH:MM:ss Z'

    // Internationalization strings
};dateFormat.i18n = {
    dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
        val = '0' + val;
    }
    return val;
}

/**
* Get the ISO 8601 week number
* Based on comments from
* http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
*
* @param  {Object} `date`
* @return {Number}
*/
function getWeek(date) {
    // Remove time components of date
    var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    // Change date to Thursday same week
    targetThursday.setDate(targetThursday.getDate() - (targetThursday.getDay() + 6) % 7 + 3);

    // Take January 4th as it is always in week 1 (see ISO 8601)
    var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);

    // Change date to Thursday same week
    firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);

    // Check if daylight-saving-time-switch occured and correct for it
    var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
    targetThursday.setHours(targetThursday.getHours() - ds);

    // Number of weeks between target Thursday and first Thursday
    var weekDiff = (targetThursday - firstThursday) / (86400000 * 7);
    return 1 + Math.floor(weekDiff);
}

/**
 * Get ISO-8601 numeric representation of the day of the week
 * 1 (for Monday) through 7 (for Sunday)
 *
 * @param  {Object} `date`
 * @return {Number}
 */
function getDayOfWeek(date) {
    var dow = date.getDay();
    if (dow === 0) {
        dow = 7;
    }
    return dow;
}

/**
 * kind-of shortcut
 * @param  {*} val
 * @return {String}
 */
function kindOf(val) {
    if (val === null) {
        return 'null';
    }

    if (val === undefined) {
        return 'undefined';
    }

    if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object') {
        return typeof val === 'undefined' ? 'undefined' : _typeof(val);
    }

    if (Array.isArray(val)) {
        return 'array';
    }

    return {}.toString.call(val).slice(8, -1).toLowerCase();
}

module.exports = {
    getMonthName: getMonthName,
    getDayName: getDayName,
    dateFormat: dateFormat
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var cssUtils = __webpack_require__(6);

function doubleAllValues(dockedObj) {
    return _.mapValues(dockedObj, function (v) {
        return v * 2;
    });
}

function addPageBottomMargin(dockedValueObj, pagePaddingBottom) {
    if (_.isNumber(dockedValueObj.px)) {
        dockedValueObj.px += pagePaddingBottom;
    } else {
        dockedValueObj.px = pagePaddingBottom;
    }
}

function isHorizontalDockToScreen(layout) {
    var dockedData = layout && layout.docked;
    var isDockToScreenFromLeft = dockedData && dockedData.left && _.isFinite(dockedData.left.vw);
    var isDockToScreenFromRight = dockedData && dockedData.right && _.isFinite(dockedData.right.vw);

    return Boolean(isDockToScreenFromLeft && isDockToScreenFromRight);
}

function isFullPageComponent(layout) {
    var dockedData = layout && layout.docked;
    var isDockToScreenFromLeft = _.get(dockedData, 'left.px') === 0;
    var isDockToScreenFromRight = _.get(dockedData, 'right.px') === 0;
    var isDockToScreenFromTop = _.get(dockedData, 'top.px') === 0;
    var isDockToScreenFromBottom = _.get(dockedData, 'bottom.px') === 0;

    return Boolean(isDockToScreenFromLeft && isDockToScreenFromRight && isDockToScreenFromTop && isDockToScreenFromBottom);
}

function isVerticallyDockToScreen(layout) {
    return _.has(layout, ['docked', 'top', 'vh']) && _.has(layout, ['docked', 'bottom', 'vh']);
}

function getScreenWidthCss(dockLeft, dockRight, screenWidth) {
    var widthUnitsData = {
        vw: 100 - dockLeft.vw - dockRight.vw
    };

    var offsetInPx = 0 - (dockLeft.px || 0) - (dockRight.px || 0);
    if (offsetInPx !== 0) {
        widthUnitsData.px = offsetInPx;
    }

    return cssUtils.convertUnitsDataToCssStringValue(widthUnitsData, screenWidth);
}

function getScreenHeightCss(dockTop, dockBottom, screenHeight) {
    var heightUnitsData = {
        vh: 100 - dockTop.vh - dockBottom.vh
    };

    var offsetInPx = 0 - (dockTop.px || 0) - (dockBottom.px || 0);
    if (offsetInPx !== 0) {
        heightUnitsData.px = offsetInPx;
    }

    return cssUtils.convertUnitsDataToCssStringValue(heightUnitsData, screenHeight);
}

function updateStyleObjectForHorizontalDockToScreen(dockedData, styleObject, screenWidth, siteX) {
    var leftDockData = _.clone(dockedData.left);
    leftDockData.px = (leftDockData.px || 0) + siteX;
    styleObject.left = cssUtils.convertUnitsDataToCssStringValue(leftDockData, screenWidth);
    styleObject.width = getScreenWidthCss(dockedData.left, dockedData.right, screenWidth);
}

function updateStyleObjectForVerticalDockToScreen(dockedData, styleObject, screenHeight, structureY, fixedPosition, pageBottomMargin) {
    var topDockData = _.clone(dockedData.top);
    topDockData.px = topDockData.px || 0;
    styleObject.top = cssUtils.convertUnitsDataToCssStringValue({ px: structureY }, screenHeight);
    styleObject.height = getScreenHeightCss(dockedData.top, dockedData.bottom, screenHeight);

    var dockedBottomObj = _.clone(dockedData.bottom);
    if (dockedBottomObj && fixedPosition) {
        addPageBottomMargin(dockedBottomObj, pageBottomMargin);
        styleObject.bottom = cssUtils.convertUnitsDataToCssStringValue(dockedBottomObj, screenHeight);
    }
}

function updateStyleAccordingToHorizontalDockedLayout(layout, style, screenWidth, siteX) {
    if (layout.docked.hCenter) {
        style.left = cssUtils.convertUnitsDataToCssStringValue(doubleAllValues(layout.docked.hCenter), screenWidth); //double values because in css, the margin is split to both sides when it has auto and left value
        style.right = 0;
        style.margin = 'auto';
        return;
    }

    if (isHorizontalDockToScreen(layout)) {
        updateStyleObjectForHorizontalDockToScreen(layout.docked, style, screenWidth, siteX);
        return;
    }

    if (layout.docked.left) {
        style.left = cssUtils.convertUnitsDataToCssStringValue(layout.docked.left, screenWidth);
    }

    if (layout.docked.right) {
        style.right = cssUtils.convertUnitsDataToCssStringValue(layout.docked.right, screenWidth);
    }
}

function updateStyleAccordingToVerticalDockedLayout(layout, style, pageBottomMargin, screenWidth, screenHeight) {
    if (layout.docked.vCenter) {
        style.top = cssUtils.convertUnitsDataToCssStringValue(doubleAllValues(layout.docked.vCenter), screenWidth); //double values because in css, the margin is split to both sides when it has auto and left value
        style.bottom = 0;
        style.margin = 'auto';
        return;
    }

    if (isVerticallyDockToScreen(layout)) {
        updateStyleObjectForVerticalDockToScreen(layout.docked, style, screenHeight, layout.y, layout.fixedPosition, pageBottomMargin);
        return;
    }

    if (isVerticallyStretched(layout)) {
        style.height = '';
    }

    if (layout.docked.top) {
        style.top = cssUtils.convertUnitsDataToCssStringValue(layout.docked.top, screenHeight);
    }

    if (layout.docked.bottom) {
        var dockedBottomObj = _.clone(layout.docked.bottom);
        if (layout.fixedPosition) {
            addPageBottomMargin(dockedBottomObj, pageBottomMargin);
        }
        style.bottom = cssUtils.convertUnitsDataToCssStringValue(dockedBottomObj, screenHeight);
    }
}

function updateStyleAccordingToDockedLayout(layout, style, pageBottomMargin, screenWidth, siteWidth, siteX, screenHeight) {
    screenWidth = Math.max(screenWidth, siteWidth);

    updateStyleAccordingToHorizontalDockedLayout(layout, style, screenWidth, siteX);
    updateStyleAccordingToVerticalDockedLayout(layout, style, pageBottomMargin, screenWidth, screenHeight);

    return style;
}

function isHorizontallyStretched(layout) {
    var dockedData = layout && layout.docked;

    return !!(dockedData && dockedData.left && dockedData.right);
}

function isVerticallyStretched(layout) {
    var dockedData = layout && layout.docked;

    return !!(dockedData && dockedData.top && dockedData.bottom);
}

function isStretched(layout) {
    return isHorizontallyStretched(layout) || isVerticallyStretched(layout);
}

module.exports = {
    isHorizontalDockToScreen: isHorizontalDockToScreen,
    isVerticallyDockToScreen: isVerticallyDockToScreen,
    isHorizontallyStretched: isHorizontallyStretched,
    isVerticallyStretched: isVerticallyStretched,
    isFullPageComponent: isFullPageComponent,
    isStretched: isStretched,
    getDockedStyle: function getDockedStyle(layout, pageBottomMargin, screenWidth, siteWidth, siteX) {
        if (!layout.docked) {
            throw new Error('Layout must have docked structure');
        }

        return updateStyleAccordingToDockedLayout(layout, {}, pageBottomMargin, screenWidth, siteWidth, siteX);
    },

    /**
     *
     * @param layout
     * @param style
     * @param pageBottomMargin
     * @param {number} [screenWidth]
     * @param {number} [siteX] only required for screen-width docked comps.. should probably refactor
     * @returns {*}
     */
    applyDockedStyle: function applyDockedStyle(layout, style, pageBottomMargin, screenWidth, siteWidth, siteX, screenHeight) {
        if (!layout.docked) {
            throw new Error('Layout must have docked structure');
        }

        return updateStyleAccordingToDockedLayout(layout, style, pageBottomMargin, screenWidth, siteWidth, siteX, screenHeight);
    }
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isSamePageNavigation(navigationInfo, prevNavigationInfo) {
    return navigationInfo.routerDefinition && prevNavigationInfo.routerDefinition && navigationInfo.routerDefinition.prefix === prevNavigationInfo.routerDefinition.prefix || navigationInfo.pageId && prevNavigationInfo.pageId && navigationInfo.pageId === prevNavigationInfo.pageId && (navigationInfo.routerDefinition || prevNavigationInfo.routerDefinition);
}

function isInnerRouteChanged(navigationInfo, prevNavigationInfo) {
    return prevNavigationInfo.innerRoute !== navigationInfo.innerRoute || navigationInfo.routerDefinition !== prevNavigationInfo.routerDefinition;
}

module.exports = {
    isSamePageNavigation: isSamePageNavigation,
    isInnerRouteChanged: isInnerRouteChanged
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint quotes:0*/


var _ = __webpack_require__(0);
var isFixingDisplayedMasterPage = false;
function createFakePageMasterData(id) {
    return {
        "type": "Page",
        id: id,
        "metaData": {
            "isPreset": false,
            "schemaVersion": "1.0",
            "isHidden": false
        },
        "title": "not found",
        "hideTitle": false,
        "icon": "",
        "descriptionSEO": "",
        "metaKeywordsSEO": "",
        "pageTitleSEO": "",
        "pageUriSEO": '@_' + id,
        "hidePage": true,
        "underConstruction": false,
        "tpaApplicationId": 0,
        "pageSecurity": {
            "requireLogin": false
        },
        "isPopup": false,
        "indexable": false,
        "isLandingPage": true,
        "pageBackgrounds": {
            "desktop": {
                "custom": true,
                "ref": "#customBgImg3vn",
                "isPreset": true
            },
            "mobile": {
                "custom": true,
                "ref": "#customBgImg24ta",
                "isPreset": true
            }
        },
        "translationData": {
            "uriSEOTranslated": false
        },
        "ignoreBottomBottomAnchors": true
    };
}

var errorPages = {
    '__403__dp': {
        json: '/static/errorPages/403.json',
        masterPageData: createFakePageMasterData('__403__dp'),
        themeData: {
            "__403__dp": {
                "type": "TopLevelStyle",
                "id": "__403__dp",
                "metaData": {
                    "isPreset": false,
                    "schemaVersion": "1.0",
                    "isHidden": false
                },
                "style": {
                    "properties": {
                        "alpha-bg": "1",
                        "bg": "#ffffff"
                    },
                    "propertiesSource": {
                        "bg": "value"
                    },
                    "groups": {}
                },
                "componentClassName": "mobile.core.components.Page",
                "pageId": "",
                "compId": "",
                "styleType": "custom",
                "skin": "wysiwyg.viewer.skins.page.BasicPageSkin"
            },
            "style-ivs76437": {
                "type": "TopLevelStyle",
                "id": "style-ivs76437",
                "metaData": {
                    "isPreset": false,
                    "schemaVersion": "1.0",
                    "isHidden": false
                },
                "style": {
                    "properties": {
                        "alpha-bg": "0",
                        "alpha-bgh": "1",
                        "alpha-brd": "1",
                        "alpha-brdh": "0",
                        "alpha-txt": "1",
                        "alpha-txth": "1",
                        "bg": "#3EB8EA",
                        "bgh": "#EF7E6B",
                        "boxShadowToggleOn-shd": "false",
                        "brd": "#EF7E6B",
                        "brdh": "#3D9BE9",
                        "brw": "2",
                        "fnt": "normal normal normal 22px/1.4em helvetica-w01-light",
                        "rd": "40px",
                        "shd": "0px 1px 4px 0px rgba(0,0,0,0.6)",
                        "txt": "#EF7E6B",
                        "txth": "#FFFFF1"
                    },
                    "propertiesSource": {
                        "alpha-bg": "value",
                        "alpha-brdh": "value",
                        "bg": "value",
                        "bgh": "value",
                        "brd": "value",
                        "brdh": "value",
                        "brw": "value",
                        "fnt": "value",
                        "rd": "value",
                        "shd": "value",
                        "txt": "value",
                        "txth": "value"
                    },
                    "groups": {}
                },
                "componentClassName": "wysiwyg.viewer.components.SiteButton",
                "pageId": "",
                "compId": "",
                "styleType": "custom",
                "skin": "wysiwyg.viewer.skins.button.BasicButton"
            }
        }
    },
    '__404__dp': {
        json: '/static/errorPages/404.json',
        masterPageData: createFakePageMasterData('__404__dp'),
        themeData: {
            "__404__dp_style": {
                "type": "TopLevelStyle",
                "id": "__404__dp_style",
                "metaData": {
                    "isPreset": false,
                    "schemaVersion": "1.0",
                    "isHidden": false
                },
                "style": {
                    "properties": {
                        "alpha-bg": "1",
                        "bg": "#ffffff"
                    },
                    "propertiesSource": {
                        "bg": "value"
                    },
                    "groups": {}
                },
                "componentClassName": "mobile.core.components.Page",
                "pageId": "",
                "compId": "",
                "styleType": "custom",
                "skin": "wysiwyg.viewer.skins.page.BasicPageSkin"
            },
            "style-ivs5pjao": {
                "type": "TopLevelStyle",
                "id": "style-ivs5pjao",
                "metaData": {
                    "isPreset": false,
                    "schemaVersion": "1.0",
                    "isHidden": false
                },
                "style": {
                    "properties": {
                        "alpha-bg": "0",
                        "alpha-bgh": "1",
                        "alpha-brd": "1",
                        "alpha-brdh": "0",
                        "alpha-txt": "1",
                        "alpha-txth": "1",
                        "bg": "#3EB8EA",
                        "bgh": "#4EB7F5",
                        "boxShadowToggleOn-shd": "false",
                        "brd": "#4EB7F5",
                        "brdh": "#3D9BE9",
                        "brw": "2",
                        "fnt": "normal normal normal 22px/1.4em helvetica-w01-light",
                        "rd": "40px",
                        "shd": "0px 1px 4px 0px rgba(0,0,0,0.6)",
                        "txt": "#4EB7F5",
                        "txth": "#FFFFF1"
                    },
                    "propertiesSource": {
                        "alpha-bg": "value",
                        "alpha-brdh": "value",
                        "bg": "value",
                        "bgh": "value",
                        "brd": "value",
                        "brdh": "value",
                        "brw": "value",
                        "fnt": "value",
                        "rd": "value",
                        "shd": "value",
                        "txt": "value",
                        "txth": "value"
                    },
                    "groups": {}
                },
                "componentClassName": "wysiwyg.viewer.components.SiteButton",
                "pageId": "",
                "compId": "",
                "styleType": "custom",
                "skin": "wysiwyg.viewer.skins.button.BasicButton"
            }
        }
    },
    '__500__dp': {
        json: '/static/errorPages/500.json',
        masterPageData: createFakePageMasterData('__500__dp'),
        themeData: {
            "__500__dp_style": {
                "type": "TopLevelStyle",
                "id": "__500__dp_style",
                "metaData": {
                    "isPreset": false,
                    "schemaVersion": "1.0",
                    "isHidden": false
                },
                "style": {
                    "properties": {
                        "alpha-bg": "1",
                        "bg": "#ffffff"
                    },
                    "propertiesSource": {
                        "bg": "value"
                    },
                    "groups": {}
                },
                "componentClassName": "mobile.core.components.Page",
                "pageId": "",
                "compId": "",
                "styleType": "custom",
                "skin": "wysiwyg.viewer.skins.page.BasicPageSkin"
            },
            "style-ivs7k3ls": {
                "type": "TopLevelStyle",
                "id": "style-ivs7k3ls",
                "metaData": {
                    "isPreset": false,
                    "schemaVersion": "1.0",
                    "isHidden": false
                },
                "style": {
                    "properties": {
                        "alpha-bg": "0",
                        "alpha-bgh": "1",
                        "alpha-brd": "1",
                        "alpha-brdh": "0",
                        "alpha-txt": "1",
                        "alpha-txth": "1",
                        "bg": "#3EB8EA",
                        "bgh": "#F6A23B",
                        "boxShadowToggleOn-shd": "false",
                        "brd": "#F6A23B",
                        "brdh": "#3D9BE9",
                        "brw": "2",
                        "fnt": "normal normal normal 22px/1.4em helvetica-w01-light",
                        "rd": "40px",
                        "shd": "0px 1px 4px 0px rgba(0,0,0,0.6)",
                        "txt": "#F6A23B",
                        "txth": "#FFFFF1"
                    },
                    "propertiesSource": {
                        "alpha-bg": "value",
                        "alpha-brdh": "value",
                        "bg": "value",
                        "bgh": "value",
                        "brd": "value",
                        "brdh": "value",
                        "brw": "value",
                        "fnt": "value",
                        "rd": "value",
                        "shd": "value",
                        "txt": "value",
                        "txth": "value"
                    },
                    "groups": {}
                },
                "componentClassName": "wysiwyg.viewer.components.SiteButton",
                "pageId": "",
                "compId": "",
                "styleType": "custom",
                "skin": "wysiwyg.viewer.skins.button.BasicButton"
            }
        }
    },
    '__uknown_error__dp': {
        json: '/static/errorPages/uknownError.json',
        masterPageData: createFakePageMasterData('__uknown_error__dp'),
        themeData: {
            "style-ivs5pjao": {
                "type": "TopLevelStyle",
                "id": "style-ivs5pjao",
                "metaData": {
                    "isPreset": false,
                    "schemaVersion": "1.0",
                    "isHidden": false
                },
                "style": {
                    "properties": {
                        "alpha-bg": "0",
                        "alpha-bgh": "1",
                        "alpha-brd": "1",
                        "alpha-brdh": "0",
                        "alpha-txt": "1",
                        "alpha-txth": "1",
                        "bg": "#3EB8EA",
                        "bgh": "#4EB7F5",
                        "boxShadowToggleOn-shd": "false",
                        "brd": "#4EB7F5",
                        "brdh": "#3D9BE9",
                        "brw": "2",
                        "fnt": "normal normal normal 22px/1.4em helvetica-w01-light",
                        "rd": "40px",
                        "shd": "0px 1px 4px 0px rgba(0,0,0,0.6)",
                        "txt": "#4EB7F5",
                        "txth": "#FFFFF1"
                    },
                    "propertiesSource": {
                        "alpha-bg": "value",
                        "alpha-brdh": "value",
                        "bg": "value",
                        "bgh": "value",
                        "brd": "value",
                        "brdh": "value",
                        "brw": "value",
                        "fnt": "value",
                        "rd": "value",
                        "shd": "value",
                        "txt": "value",
                        "txth": "value"
                    },
                    "groups": {}
                },
                "componentClassName": "wysiwyg.viewer.components.SiteButton",
                "pageId": "",
                "compId": "",
                "styleType": "custom",
                "skin": "wysiwyg.viewer.skins.button.BasicButton"
            }
        }
    }
};

function isErrorPage(pageId) {
    return _.includes(_.keys(errorPages), pageId);
}

function getJSONS(siteData, id) {
    return [siteData.santaBase + errorPages[id].json];
}
function setIsFixingDisplayedMasterPage() {
    isFixingDisplayedMasterPage = true;
}
function updateErrorPageMasterData(rootId, masterPage) {
    if (isFixingDisplayedMasterPage && rootId === 'masterPage') {
        _.forEach(errorPages, function (value, key) {
            masterPage.data.document_data[key] = value.masterPageData;
            _.assign(masterPage.data.theme_data, value.themeData);
        });
    }
}

module.exports = {
    updateErrorPageMasterData: updateErrorPageMasterData,
    isErrorPage: isErrorPage,
    getJSONS: getJSONS,
    setIsFixingDisplayedMasterPage: setIsFixingDisplayedMasterPage,
    IDS: {
        FORBIDDEN: '__403__dp',
        NOT_FOUND: '__404__dp',
        INTERNAL_ERROR: '__500__dp',
        UKNOWN_ERROR: '__uknown_error__dp'
    }
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof window === 'undefined') {
    module.exports = {}; // polyfilled in server side using jsdom
} else {
    module.exports = {
        document: {
            createDocumentFragment: window.document.createDocumentFragment.bind(window.document),
            createTextNode: window.document.createTextNode.bind(window.document),
            createElement: window.document.createElement.bind(window.document)
        },
        Node: {
            ELEMENT_NODE: window.Node.ELEMENT_NODE,
            ATTRIBUTE_NODE: window.Node.ATTRIBUTE_NODE,
            TEXT_NODE: window.Node.TEXT_NODE,
            CDATA_SECTION_NODE: window.Node.CDATA_SECTION_NODE,
            ENTITY_REFERENCE_NODE: window.Node.ENTITY_REFERENCE_NODE,
            ENTITY_NODE: window.Node.ENTITY_NODE,
            PROCESSING_INSTRUCTION_NODE: window.Node.PROCESSING_INSTRUCTION_NODE,
            COMMENT_NODE: window.Node.COMMENT_NODE,
            DOCUMENT_NODE: window.Node.DOCUMENT_NODE,
            DOCUMENT_TYPE_NODE: window.Node.DOCUMENT_TYPE_NODE,
            DOCUMENT_FRAGMENT_NODE: window.Node.DOCUMENT_FRAGMENT_NODE,
            NOTATION_NODE: window.Node.NOTATION_NODE,
            DOCUMENT_POSITION_DISCONNECTED: window.Node.DOCUMENT_POSITION_DISCONNECTED,
            DOCUMENT_POSITION_PRECEDING: window.Node.DOCUMENT_POSITION_PRECEDING,
            DOCUMENT_POSITION_FOLLOWING: window.Node.DOCUMENT_POSITION_FOLLOWING,
            DOCUMENT_POSITION_CONTAINS: window.Node.DOCUMENT_POSITION_CONTAINS,
            DOCUMENT_POSITION_CONTAINED_BY: window.Node.DOCUMENT_POSITION_CONTAINED_BY,
            DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC: window.Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC
        }
    };
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function runMultiple(callbacks) {
    return function () {
        var _this = this;

        var args = arguments;
        _.forEach(callbacks, function (callback) {
            callback.apply(_this, args);
        });
    };
}

module.exports = {
    runMultiple: runMultiple
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var stringUtils = __webpack_require__(5);

function getContainerSize(imageWrapperSize, displayerNode) {
    var $ = __webpack_require__(4);
    var $node = $(displayerNode);
    var containerWidth = imageWrapperSize.imageWrapperWidth - parseInt($node.attr('data-image-wrapper-right'), 10) - parseInt($node.attr('data-image-wrapper-left'), 10);
    var containerHeight = imageWrapperSize.imageWrapperHeight - parseInt($node.attr('data-image-wrapper-bottom'), 10) - parseInt($node.attr('data-image-wrapper-top'), 10);
    if (stringUtils.isTrue($node.attr('data-margin-to-container'))) {
        containerWidth += imageWrapperSize.imageWrapperMarginLeft + imageWrapperSize.imageWrapperMarginRight;
        containerHeight += imageWrapperSize.imageWrapperMarginTop + imageWrapperSize.imageWrapperMarginBottom;
    }
    return {
        width: containerWidth,
        height: containerHeight
    };
}

function updateImageWrapperSizes(patchers, imageWrapperId, sizeAfterScaling) {
    patchers.css(imageWrapperId, {
        'height': sizeAfterScaling.imageWrapperSize.imageWrapperHeight,
        'width': sizeAfterScaling.imageWrapperSize.imageWrapperWidth,
        'marginLeft': sizeAfterScaling.imageWrapperSize.imageWrapperMarginLeft,
        'marginRight': sizeAfterScaling.imageWrapperSize.imageWrapperMarginRight,
        'marginTop': sizeAfterScaling.imageWrapperSize.imageWrapperMarginTop,
        'marginBottom': sizeAfterScaling.imageWrapperSize.imageWrapperMarginBottom
    });
}

function updateSkinPropsForFlexibleHeightGallery(gallerySkinProps) {
    var attributesForLayout = { 'data-should-add-min-height': true };
    _.assign(gallerySkinProps[''], attributesForLayout);
}

function measureFlexibleHeightGallery(id, measureMap, nodesMap) {
    var $ = __webpack_require__(4);
    measureMap.height[id] = nodesMap[id].offsetHeight;
    var shouldAddMinHeight = $(nodesMap[id]).data('should-add-min-height');
    if (shouldAddMinHeight) {
        measureMap.minHeight[id] = measureMap.height[id];
    } else {
        delete measureMap.minHeight[id];
    }
}

module.exports = {
    getContainerSize: getContainerSize,
    updateImageWrapperSizes: updateImageWrapperSizes,
    updateSkinPropsForFlexibleHeightGallery: updateSkinPropsForFlexibleHeightGallery,
    measureFlexibleHeightGallery: measureFlexibleHeightGallery
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var GUID_FORMAT = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
var _state = { lastGeneratedId: undefined, counter: 0 };
var hashUtils = __webpack_require__(10);

function randomizeChar(c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
}

function getRandomLowercaseLetter() {
    return String.fromCharCode(97 + Math.floor(Math.random() * 26));
}

function _getUniqueId(state, prefix, prefixDelimiter, dateNow) {
    prefix = prefix || '';
    prefixDelimiter = prefixDelimiter || '';
    var value = dateNow;
    if (value === state.lastGeneratedId) {
        state.counter++;
    } else {
        state.lastGeneratedId = value;
        state.counter = 0;
    }
    return prefix + prefixDelimiter + Number(state.lastGeneratedId).toString(36) + (state.counter || '');
}

function getUniqueId(prefix, prefixDelimiter) {
    return _getUniqueId(_state, prefix, prefixDelimiter, Date.now());
}

/**
 * This is the same getGUID algorithm as in old client - we need this for BI, to keep a GUID in the normal GUID format
 * originally from http://stackoverflow.com/a/2117523
 */
function getGUID() {
    return GUID_FORMAT.replace(/[xy]/g, randomizeChar);
}

/**
 * Generate a page id
 *
 * @param {Array.string} existingPageIds array of existing page ids
 * @returns {*}
 */
function generateNewPageId(existingPageIds) {
    var generatedId = getRandomLowercaseLetter() + new Array(4).join().replace(/(.|$)/g, function () {
        return (Math.random() * 36 | 0).toString(36);
    });
    if (_.includes(existingPageIds, generatedId)) {
        return this.generateNewPageId(existingPageIds);
    }
    return generatedId;
}

/**
 * Generate a popup id
 *
 * @param {Array.string} existingPageIds array of existing page ids
 * @param {Array.string} popupIds array of existing popup ids
 * @returns {*}
 */
function generateNewPopupId(existingPageIds, popupIds) {
    var lastId = _(popupIds).sortBy().last();
    var newPopupId = void 0;

    if (lastId) {
        newPopupId = lastId;
        do {
            newPopupId = increaseId(newPopupId);
        } while (_.includes(existingPageIds, newPopupId));
        return newPopupId;
    }
    return this.generateNewPageId(existingPageIds);

    function increaseId(id, charPos) {
        charPos = _.isUndefined(charPos) ? id.length - 1 : charPos;
        var charCode = id.charCodeAt(charPos);

        if (charCode > 121) {
            id = increaseId(id, charPos - 1);
            charCode = 47;
        } else if (charCode > 56 && charCode < 96) {
            charCode = 96;
        }

        return id.substr(0, charPos) + String.fromCharCode(charCode + 1) + id.substr(charPos + 1);
    }
}

function nameUUIDFromString(str) {
    var digest = hashUtils.SHA256.hex_sha256(_.toString(str));
    return GUID_FORMAT.replace(/[xy]/g, function (match, offset) {
        return (//eslint-disable-line no-confusing-arrow
            match === 'x' ? digest[offset] : '89ab'[parseInt(digest[30], 16) % 4]
        );
    });
}

module.exports = {
    getUniqueId: getUniqueId,
    _getUniqueId: _getUniqueId,
    getGUID: getGUID,
    generateNewPageId: generateNewPageId,
    generateNewPopupId: generateNewPopupId,
    nameUUIDFromString: nameUUIDFromString
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var translatedKeys = {
    ALT: 18,
    ARROWDOWN: 40,
    ARROWLEFT: 37,
    ARROWRIGHT: 39,
    ARROWUP: 38,
    BACKSPACE: 8,
    CAPSLOCK: 20,
    CLEAR: 12,
    CONTROL: 17,
    DELETE: 46,
    END: 35,
    ENTER: 13,
    ESCAPE: 27,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    HOME: 36,
    INSERT: 45,
    META: 224,
    NUMLOCK: 144,
    PAGEDOWN: 34,
    PAGEUP: 33,
    PAUSE: 19,
    SCROLLLOCK: 145,
    SHIFT: 16,
    SPACEBAR: 32,
    TAB: 9

    /**
     * @param keyEvent native browser event
     * @return Normalized key code
     */
};function getKey(keyEvent) {
    return keyEvent.which || keyEvent.keyCode;
}

module.exports = {
    keys: translatedKeys,
    getKey: getKey
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var window = __webpack_require__(75);

var WIX_CODE_INTENT = 'WIX_CODE';
var WIX_CODE_CONSOLE_MESSAGE_TYPE = 'console';

function isPreview() {
    return window.parent && window.parent !== window;
}

function isWixCodeConsoleMessage(msg) {
    return msg.intent === WIX_CODE_INTENT && msg.type === WIX_CODE_CONSOLE_MESSAGE_TYPE;
}

function convertToWixCodeConsoleMessage(logLevel) {
    for (var _len = arguments.length, msg = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        msg[_key - 1] = arguments[_key];
    }

    return {
        intent: WIX_CODE_INTENT,
        type: WIX_CODE_CONSOLE_MESSAGE_TYPE,
        data: {
            logLevel: logLevel,
            args: [].concat(msg)
        }
    };
}

function logWixCodeConsoleMessage(msg) {
    if (!msg) {
        return;
    }

    if (_.isString(msg)) {
        msg = convertToWixCodeConsoleMessage('INFO', msg);
    }

    if (isWixCodeConsoleMessage(msg) && isPreview()) {
        window.parent.postMessage(JSON.stringify(msg), '*');
    }
}

function logWixCodeConsoleError(error) {
    if (isPreview()) {
        window.parent.postMessage(JSON.stringify(convertToWixCodeConsoleMessage('ERROR', error.name, error.message, error.stack)), '*');
    }
}

module.exports = {
    logWixCodeConsoleMessage: logWixCodeConsoleMessage,
    logWixCodeConsoleError: logWixCodeConsoleError
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matrixCalculations = {
    getItemPosition: function getItemPosition(itemIndex, itemWidth, itemHeight, margin, numCols) {
        var marginBetweenImages = margin;
        var numberOfColumns = numCols;
        var columnIndex = itemIndex % numberOfColumns;
        var rowIndex = Math.floor((itemIndex - columnIndex) / numberOfColumns);

        return {
            left: columnIndex * (itemWidth + marginBetweenImages),
            top: rowIndex * (itemHeight + marginBetweenImages)
        };
    },


    /**
     *
     * @param {number} requestedRows
     * @param numCols
     * @param numItems
     * @returns {number}
     */
    getAvailableRowsNumber: function getAvailableRowsNumber(requestedRows, numCols, numItems) {
        var calculatedNumOfRows = Math.ceil(numItems / numCols);
        return Math.min(requestedRows, calculatedNumOfRows);
    },
    getItemHeight: function getItemHeight(margin, height, numberOfRows, heightDiff) {
        var marginBetweenImages = margin;
        var containerHeight = height - heightDiff;
        return Math.max(Math.floor((containerHeight - (numberOfRows - 1) * marginBetweenImages) / numberOfRows), 0);
    },
    getItemWidth: function getItemWidth(margin, numCols, width, widthDiff) {
        var marginBetweenImages = margin;
        var numberOfColumns = numCols;
        var containerWidth = width - widthDiff;
        return Math.max(Math.floor((containerWidth - (numberOfColumns - 1) * marginBetweenImages) / numberOfColumns), 0);
    },
    getImageStyle: function getImageStyle(height, width, imgHeight, imgWidth) {
        var isWiderThanContainer = imgWidth > width;
        var isHigherThanContainer = imgHeight > height;
        var newHeight = isWiderThanContainer ? '100%' : 'auto';
        var newWidth = isHigherThanContainer ? '100%' : 'auto';
        var imgLeft = isHigherThanContainer ? 0 : (width - imgWidth * (height / imgHeight)) / 2.0;
        var imgTop = isWiderThanContainer ? 0 : (height - imgHeight * (width / imgWidth)) / 2.0;
        return {
            'width': newWidth,
            'height': newHeight,
            'margin-top': imgTop,
            'margin-left': imgLeft
        };
    }
};
module.exports = matrixCalculations;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matrixScalingCalculations = {
    getSizeAfterScaling: function getSizeAfterScaling(itemData) {
        var mode = itemData.imageMode || 'clipImage';
        var height = itemData.itemHeight - itemData.bottomGap;
        var widthDiff = itemData.widthDiff;
        var heightDiff = itemData.heightDiff;
        var galleryScalersMap = {
            clipImage: this.getClipImage,
            flexibleHeight: this.getFlexibleHeight,
            flexibleWidth: this.getFlexibleWidth,
            flexibleWidthFixed: this.getFlexibleWidth
        };
        return galleryScalersMap[mode].call(this, itemData.itemWidth, height, widthDiff, heightDiff, itemData.displayerData, mode);
    },
    getClipImage: function getClipImage(width, height, widthDiff, heightDiff) {
        return {
            displayerSize: {
                width: width,
                height: height
            },
            imageWrapperSize: this.getWrapperSize(width - widthDiff, height - heightDiff)
        };
    },
    getFlexibleHeight: function getFlexibleHeight(width, height, widthDiff, heightDiff, displayerData) {
        var newWidth = width - widthDiff;
        var newHeight = Math.floor(newWidth / this.getAspectRatio(displayerData));
        return {
            displayerSize: {
                width: width,
                height: newHeight
            },
            imageWrapperSize: this.getWrapperSize(newWidth, newHeight - heightDiff)
        };
    },
    getFlexibleWidth: function getFlexibleWidth(width, height, widthDiff, heightDiff, displayerData, mode) {
        var isFlexibleWidth = mode === 'flexibleWidth';
        var horizontalPadding = 0;
        var verticalPadding = 0;
        var newHeight = height - heightDiff;
        var newWidth = newHeight * this.getAspectRatio(displayerData);

        if (!isFlexibleWidth && newWidth > width - widthDiff) {
            if (newWidth > width - widthDiff) {
                var coef = (width - widthDiff) / newWidth;
                newWidth = width - widthDiff;
                newHeight = coef * newHeight;
            }
        }
        if (!isFlexibleWidth) {
            horizontalPadding = Math.floor((width - newWidth - widthDiff) / 2.0);
            verticalPadding = Math.floor((height - newHeight - heightDiff) / 2.0);
        }

        return {
            displayerSize: {
                width: isFlexibleWidth ? newWidth : width,
                height: height
            },
            imageWrapperSize: this.getWrapperSize(newWidth, newHeight, horizontalPadding, verticalPadding)
        };
    },
    getAspectRatio: function getAspectRatio(displayerData) {
        return displayerData.width / displayerData.height;
    },
    getWrapperSize: function getWrapperSize(newWidth, newHeight, horizontalPadding, verticalPadding) {
        var height = newHeight < 0 ? 0 : newHeight;
        var width = newWidth < 0 ? 0 : newWidth;
        return {
            imageWrapperHeight: height,
            imageWrapperWidth: width,
            imageWrapperMarginLeft: horizontalPadding || 0,
            imageWrapperMarginRight: horizontalPadding || 0,
            imageWrapperMarginTop: verticalPadding || 0,
            imageWrapperMarginBottom: verticalPadding || 0
        };
    }
};
module.exports = matrixScalingCalculations;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    errorTypes: {
        VIDEO_GENERAL_ERROR: 'generalError',
        NO_VIDEO_FOUND: 'noVideoError'
    },
    playbackTypes: {
        IDLE: 'idle',
        LOADING: 'loading',
        READY: 'ready',
        STOPPED: 'ready',
        PLAY_ENDED: 'ended',
        PLAYING: 'playing',
        PAUSED: 'paused',
        SEEK_PLAYING: 'seek_playing',
        SEEK_PAUSED: 'seek_paused',
        SEEKING: 'seeking',
        SEEKING_ENDED: 'seek_ended',
        WAITING: 'waiting',
        ERROR: 'error'
    },
    eventTypes: {
        MOUNT: 'mount',
        LOAD: 'load',
        PLAYSTATE: 'playstate',
        VOLUME: 'volume',
        RATE: 'rate',
        TIME_UPDATE: 'timeupdate',
        PROGRESS: 'progress',
        ERROR: 'error'
    },
    availabilityReadyStates: {
        IN_PROCESS: 'in_process',
        PLAYING_PREVIEW: 'playing_preview',
        IDLE: 'idle',
        NO_VIDEO: 'no_video'
    },
    playback: {
        SUPPORTED_MEDIA_ATTRIBUTES: ['autoplay', 'mute', 'loop']
    },
    balataConsts: {
        BALATA: 'balata',
        MEDIA: 'media',
        IMAGE: 'image',
        CONTENT: 'content',
        POSTER: 'poster',
        BG_IMAGE: 'bgimage',
        VIDEO: 'video',
        OVERLAY: 'overlay',
        UNDERLAY: 'underlay',
        BG_COLOR: 'bgcolor',
        ZOOM_SELECTORS: ['.bgImage', '.bgVideo'],
        PARALLAX_SELECTORS: ['.bgImage', '.bgVideo'],
        REVEAL_SELECTORS: ['.bgImage', '.bgVideo'],
        BLUR_SELECTORS: ['.bgImage', '.bgVideo'],
        FADE_SELECTORS: ['.bgImage', '.bgVideo', '.bgColor', '.bgOverlay'],
        overlay: 'overlayTransforms',
        media: 'mediaTransforms'
    },
    defaultMediaStyle: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    },
    popupMediaStyle: {
        position: 'fixed',
        pointerEvents: 'auto',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    },
    elementQueries: {
        controls: {
            width: [{ min: 0, max: 350, name: 'minimal' }, { min: 0, max: 450, name: 'small' }, { min: 450, max: 1200, name: 'normal' }, { min: 1200, max: Infinity, name: 'large' }]
        }
    }
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DIALOG_BOX_MIN_WIDTH = 600;
var MIN_PANEL_HEIGHT = 20;

var DESKTOP_VIEW_DEFAULTS = {
    marginTop: 0,
    paddingTop: 0,
    dialogBoxHeight: 600,
    imageContainerWidth: 500,
    imageContainerHeight: 500
};

var DESKTOP_DEFAULT_PADDING = {
    vertical: 10,
    horizontal: 20
};

var NON_OPTIMIZED_DEFAULT_PADDING = {
    vertical: 15,
    horizontal: 15
};

var MOBILE_VIEW_DEFAULTS = {
    marginTop: 0,
    paddingTop: 0,
    dialogBoxHeight: 400,
    imageContainerWidth: 320,
    imageContainerHeight: 400
};

function getImageContainerDimensions(imageData, maxImageWidth, maxImageHeight, minImageContainerWidth) {
    var wScale = maxImageWidth / imageData.width;
    var hScale = maxImageHeight / imageData.height;
    var targetScale = Math.min(wScale, hScale);
    return {
        width: Math.max(Math.round(imageData.width * targetScale), minImageContainerWidth),
        height: Math.round(imageData.height * targetScale)
    };
}

function getDimensionsForImageAndBox(imageData, maxImageWidth, maxImageHeight, panelHeight, minBoxWidth, screenHeight, screenWidth, dialogBoxPadding) {
    panelHeight = panelHeight || 0;
    dialogBoxPadding = dialogBoxPadding || {};

    var imageContainer = getImageContainerDimensions(imageData, maxImageWidth, maxImageHeight, minBoxWidth);

    var dialogBoxWidth = imageContainer.width + (dialogBoxPadding.horizontal || 0);
    var dialogBoxHeight = imageContainer.height + panelHeight + (dialogBoxPadding.vertical || 0);
    var marginLeft = Math.ceil(Math.max((screenWidth - dialogBoxWidth) / 2, 0));
    var distanceFromTop = Math.ceil(Math.max((screenHeight - dialogBoxHeight) / 2, 0));

    return {
        marginLeft: marginLeft,
        marginTop: distanceFromTop,
        paddingTop: distanceFromTop,
        dialogBoxHeight: dialogBoxHeight,
        dialogBoxWidth: dialogBoxWidth,
        imageContainerWidth: imageContainer.width,
        imageContainerHeight: imageContainer.height
    };
}

var mediaZoomCalculations = {

    /**
     * Calculates the correct measurements for media zoom component for desktop view and non optimized view
     * (mobile device in not mobile view or tablet device)
     *
     * @param compData
     * @param siteDataInformation
     * @param screenMeasures
     * @param spacers
     * @param panelHeight
     * @param dialogBoxPadding
     * @returns {{marginTop: (number),{paddingTop: (number), dialogBoxHeight: (number), imageContainerWidth: (number), imageContainerHeight: (number)}}
     */
    getDesktopViewDimensions: function getDesktopViewDimensions(compData, siteDataInformation, screenMeasures, spacers, panelHeight, dialogBoxPadding) {
        var maxImageWidth = void 0,
            maxImageHeight = void 0,
            screenWidth = void 0,
            screenHeight = void 0;
        dialogBoxPadding = dialogBoxPadding || DESKTOP_DEFAULT_PADDING;
        panelHeight = panelHeight || MIN_PANEL_HEIGHT;
        var dimensions = DESKTOP_VIEW_DEFAULTS;
        if (screenMeasures && compData.width && compData.height) {
            screenWidth = screenMeasures.width;
            screenHeight = screenMeasures.height;

            maxImageWidth = screenWidth - spacers.width - dialogBoxPadding.horizontal;
            maxImageHeight = screenHeight - spacers.height / 2 - panelHeight - dialogBoxPadding.vertical;

            if (!siteDataInformation.isMobileDevice && !siteDataInformation.isTabletDevice) {
                maxImageWidth = Math.min(compData.width, maxImageWidth);
                maxImageHeight = Math.min(compData.height, maxImageHeight);
            }

            dimensions = getDimensionsForImageAndBox(compData, maxImageWidth, maxImageHeight, panelHeight, DIALOG_BOX_MIN_WIDTH, screenHeight, screenWidth, dialogBoxPadding);
        }

        return dimensions;
    },


    // widthSpacer and heightSpacer are defined in mediaZoom and are 0 for non desktop devices
    getNonOptimizedViewDimensions: function getNonOptimizedViewDimensions(imageData, siteDataInformation, screenMeasures, spacers, panelHeight, dialogBoxPadding) {
        if (!screenMeasures) {
            return DESKTOP_VIEW_DEFAULTS;
        }

        dialogBoxPadding = dialogBoxPadding && (dialogBoxPadding.vertical || dialogBoxPadding.horizontal) ? dialogBoxPadding : NON_OPTIMIZED_DEFAULT_PADDING;
        panelHeight = panelHeight || 0;

        var screenWidth = screenMeasures.width;
        var screenHeight = screenMeasures.height;

        var maxImageWidth = Math.min(imageData.width, screenWidth - 2 * dialogBoxPadding.horizontal);
        var maxImageHeight = Math.min(imageData.height, screenHeight - 2 * dialogBoxPadding.vertical);

        var imageContainer = getImageContainerDimensions(imageData, maxImageWidth, maxImageHeight, DIALOG_BOX_MIN_WIDTH);

        var dialogBoxWidth = screenWidth - 2 * dialogBoxPadding.horizontal;
        var dialogBoxHeight = imageContainer.height + panelHeight;

        var marginLeft = dialogBoxPadding.horizontal;
        var distanceFromTop = Math.ceil(Math.max((screenHeight - dialogBoxHeight) / 2, dialogBoxPadding.vertical));

        return {
            marginLeft: marginLeft,
            marginTop: distanceFromTop,
            paddingTop: distanceFromTop,
            dialogBoxHeight: dialogBoxHeight,
            dialogBoxWidth: dialogBoxWidth,
            imageContainerWidth: imageContainer.width,
            imageContainerHeight: imageContainer.height
        };
    },
    getMobileViewDimensions: function getMobileViewDimensions(compData, siteData, measureMap) {
        var maxWidth = void 0,
            maxHeight = void 0,
            screenWidth = void 0,
            screenHeight = void 0,
            siteStructureWidth = void 0;

        var dimensions = MOBILE_VIEW_DEFAULTS;
        if (measureMap) {
            screenWidth = measureMap.width.screen;
            screenHeight = measureMap.innerHeight.screen;
            siteStructureWidth = siteData.getSiteWidth();

            maxWidth = Math.min(compData.width, Math.max(screenWidth, siteStructureWidth));
            maxHeight = Math.min(compData.height, screenHeight);

            dimensions = getDimensionsForImageAndBox(compData, maxWidth, maxHeight, 0, 0, screenHeight, screenWidth);
        }

        return dimensions;
    }
};

module.exports = mediaZoomCalculations;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function fixViewportTag(siteData, params) {
    var viewport = typeof document !== 'undefined' && window.document.getElementById('wixMobileViewport');
    if (!viewport) {
        return;
    }

    var browserFlags = siteData.browserFlags();
    var responsive = params && params.isResponsive;
    var width = responsive ? 'device-width' : siteData.getSiteWidth();
    var userScalable = responsive && browserFlags.forceOverflowScroll ? 'no' : 'yes';
    var finalizeViewport = function finalizeViewport() {
        return viewport.setAttribute('content', 'width=' + width + ', user-scalable=' + userScalable);
    };

    if (responsive || !browserFlags.doubleResetMobileViewport) {
        finalizeViewport();
        return;
    }

    viewport.setAttribute('content', 'width=' + width + ', user-scalable=yes, initial-scale=0');
    return window.requestAnimationFrame(function () {
        viewport.setAttribute('content', 'width=' + width + ', user-scalable=yes, initial-scale=' + window.screen.width / width);
        return window.requestAnimationFrame(finalizeViewport);
    });
}

module.exports = { fixViewportTag: fixViewportTag };

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function forceUpdate() {
    window.rendered.forceUpdate();
}

var data = void 0;

module.exports = {
    addGalleryDataToImageData: function addGalleryDataToImageData(imageData, galleryData, getImageDataFromGalleryByQuery) {
        // There's a problem with how imageZoom component works:
        // when the user clicks on the "next" button, imageZoom knows what's
        // the next image by examining the url, and accessing siteData
        // accordingly in order to retrieve the data.
        // In nonPageItemZoom's use case, we don't use the url nor the
        // siteData. So we have to save the gallery's data somehow so
        // imageZoom will be able to access it. So we save it in the
        // compData.
        galleryData = _.assign({
            getImageDataByQuery: getImageDataFromGalleryByQuery
        }, galleryData);
        return _.assign({ galleryData: galleryData }, imageData);
    },
    zoom: function zoom(zoomedImageData) {
        if (!zoomedImageData || zoomedImageData.type !== 'Image' || !zoomedImageData.galleryData) {
            throw 'nonPageItemZoom should be used only with Images which have been passed to nonPageItemZoom.addGalleryDataToImageData()';
        }
        data = zoomedImageData;
        forceUpdate();
    },
    unzoom: function unzoom() {
        data = undefined;
        forceUpdate();
    },
    getZoomedImageData: function getZoomedImageData() {
        return data;
    },
    getImageDataFromGalleryByQuery: function getImageDataFromGalleryByQuery(itemId) {
        if (data && data.galleryData) {
            return _.find(data.galleryData.items, { id: itemId });
        }
    },
    shouldImageBeZoomedAsNonPageItem: function shouldImageBeZoomedAsNonPageItem(imageData) {
        return imageData && imageData.galleryData !== undefined;
    }
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var MAX_CLONE_ITER = 500000;
var _ = __webpack_require__(0);

function resolvePath(source, path) {
    var ret = source;
    for (var i = 0; i < path.length; i++) {
        var prop = path[i];
        if (_.has(ret, prop)) {
            ret = ret[prop];
        } else {
            return null;
        }
    }
    return ret;
}

function ensurePath(source, path) {
    var ret = source;
    for (var i = 0; i < path.length; i++) {
        var prop = path[i];
        if (!_.has(ret, prop)) {
            ret[prop] = {};
        }
        ret = ret[prop];
    }
}

function setInPath(source, path, value) {
    var scope = resolvePath(source, _.initial(path));
    if (scope !== null) {
        scope[_.last(path)] = value;
    }
}

function filter(source, predicate, canEnterSubtreePredicate) {
    canEnterSubtreePredicate = canEnterSubtreePredicate || function () {
        return true;
    };
    var ret = [];
    var findInner = function findInner(obj) {
        if (_.isNil(obj)) {
            return;
        }

        if (predicate(obj)) {
            ret.push(obj);
        }

        if (!canEnterSubtreePredicate(obj)) {
            return;
        }

        if (_.isPlainObject(obj) || _.isArray(obj)) {
            _.forEach(obj, function (value) {
                findInner(value);
            });
        }
    };

    findInner(source);
    return ret;
}

function findPath(obj, predicate, path) {
    path = path || [];

    if (predicate(obj)) {
        return path;
    }

    var found = null;
    if (_.isPlainObject(obj) || _.isArray(obj)) {
        _.forEach(obj, function (val, key) {
            found = findPath(obj[key], predicate, path.concat(key));
            if (found) {
                return false;
            }
        });
    }

    return found;
}

//copied lodash implementation
function cloneDate(date) {
    return new Date(+date);
}

function cloneObject(object) {
    return _.isArray(object) ? [] : Object.create(Object.getPrototypeOf(object));
}

// Unlike _.cloneDeep, this has no protection against circular data structures
function cloneDeep(value, customizer) {
    var hasCustomizer = _.isFunction(customizer);
    if (hasCustomizer) {
        var customizerResult = customizer(value);
        if (!_.isUndefined(customizerResult)) {
            return customizerResult;
        }
    }

    if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
        return value;
    }

    if (_.isDate(value)) {
        return cloneDate(value);
    }

    var result = cloneObject(value);
    var stack = [result, value];
    var curr = void 0,
        count = 0;
    while (curr = stack.pop()) {
        if (++count > MAX_CLONE_ITER) {
            throw new Error('cloneDeep too big');
        }

        var base = stack.pop();
        var keys = Object.keys(curr);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            var v = curr[key];

            if (hasCustomizer) {
                var _customizerResult = customizer(v);
                if (!_.isUndefined(_customizerResult)) {
                    base[key] = _customizerResult;
                    continue;
                }
            }

            if (v && (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
                if (_.isDate(v)) {
                    base[key] = cloneDate(v);
                } else {
                    var newObj = cloneObject(v);
                    base[key] = newObj;
                    stack.push(newObj, v);
                }
            } else {
                base[key] = v;
            }
        }
    }
    return result;
}

function isDifferent(a, b) {
    return !_.isEqual(a || null, b || null);
}

/**
 * does not change the original objects
 * the function clones only if there might be a change that will change the object
 * @param {Object} object the object to clone and merge to
 * @param {Object} source the object to compare to and merge into object
 * @param {function(String|Number|Boolean, String|Number|Boolean, String) -> boolean} shouldTakeSourceValue
 * gets the value of object at key, the value of source at key and the key.
 * the function is called only on primitive fields, should return true if you want to take the source value
 * @returns {Object}
 */
function cloneAndConditionalMergeOfFields(object, source, shouldTakeSourceValue) {
    if (!_.isObject(object)) {
        return object;
    }
    var result = _.clone(object);

    _.forOwn(source, function (val, key) {
        if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object' && shouldTakeSourceValue(object[key], source[key], key)) {
            result[key] = source[key];
            return;
        }
        if (!object[key]) {
            return;
        }

        if (_.isPlainObject(val)) {
            result[key] = cloneAndConditionalMergeOfFields(object[key], val, shouldTakeSourceValue);
        } else if (_.isArray(val)) {
            result[key] = _.compact(_.map(val, function (item, index) {
                if (!object[key][index]) {
                    return undefined;
                }
                return cloneAndConditionalMergeOfFields(object[key][index], item, shouldTakeSourceValue);
            }));
            _.defaults(result[key], object[key]);
        }
    });
    return result;
}

module.exports = {
    resolvePath: resolvePath,
    ensurePath: ensurePath,
    setInPath: setInPath,
    filter: filter,
    findPath: findPath,
    cloneDeep: cloneDeep,
    isDifferent: isDifferent,
    cloneAndConditionalMergeOfFields: cloneAndConditionalMergeOfFields
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getRecursionArgs(firstArg, args, sliceStartIndex) {
    var newArgs = [firstArg];

    for (var i = sliceStartIndex; i < args.length; i++) {
        // not using Array.prototype.slice.call(arguments, sliceStartIndex), because of optimizations in JavaScript engines
        newArgs.push(args[i]); // fot details see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Functions/arguments
    }

    return newArgs;
}

var reactComponentUtils = {
    getRef: function getRef(component, refName) {
        if (component.refs) {
            var ref = component.refs[refName];

            if (ref && arguments.length > 2) {
                return reactComponentUtils.getRef.apply(reactComponentUtils, getRecursionArgs(ref, arguments, 2));
            }

            return ref;
        }
    }
};

module.exports = reactComponentUtils;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var pendingCallbacks = [];
var renderCounter = 0;
var renderToStringCounter = 0;

function flushPendingCallbacksIfNotRenderingAndHasPending() {
    if (pendingCallbacks.length && renderCounter === 0) {
        var copyOfPendingCallbacks = pendingCallbacks;
        pendingCallbacks = [];
        _.forEach(copyOfPendingCallbacks, function (callback) {
            callback();
        });
        flushPendingCallbacksIfNotRenderingAndHasPending();
    }
}

function finishedRendering() {
    if (renderToStringCounter === 0) {
        renderCounter--;
        flushPendingCallbacksIfNotRenderingAndHasPending();
    }
}

function startedRendering() {
    if (renderToStringCounter === 0) {
        renderCounter++;
    }
}

function toggleRenderToString(renderingToString) {
    renderToStringCounter += renderingToString ? 1 : -1;
}

function callAfterRenderDone(callback) {
    if (!this.isMounted()) {
        console.error('only invoke callAfterRenderDone if the component is mounted'); //eslint-disable-line no-console
        return;
    }
    if (renderCounter === 0) {
        callback();
    } else {
        pendingCallbacks.push(callback);
    }
}

module.exports = {
    componentDidMount: finishedRendering,
    componentDidUpdate: finishedRendering,
    componentWillMount: startedRendering,
    componentWillUpdate: startedRendering,
    toggleRenderToString: toggleRenderToString,
    callAfterRenderDone: callAfterRenderDone
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
/**
 * A cross browser fullscreen handler
 *
 * Fork of screenfull.js 3.1.0 (https://github.com/sindresorhus/screenfull.js/)
 * MIT © Sindre Sorhus (https://sindresorhus.com/)
 * Differences from original:
 * - ES6
 * - CommonJS only
 * - No self invoking functions, no global state. has to be initiated
 * - Removed support for Safari 5.1
 * - onchange and onerror return their remove function
 * @returns {*}
 */
module.exports = function Screenfull() {

    var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
    var fn = fnMap.find(function (item) {
        return item[1] in document;
    }).reduce(function (fnObj, value, index) {
        fnObj[fnMap[0][index]] = value;
        return fnObj;
    }, {});

    var publicAPI = {
        /**
         * Request browser to set an element into fullscreen
         * This method must be invoked within a user input event handler for the request to pass.
         * @param {HtmlElement} elem
         */
        request: function request(elem) {
            elem[fn.requestFullscreen](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
        },

        /**
         * Exit fullscreen mode
         */
        exit: function exit() {
            document[fn.exitFullscreen]();
        },

        /**
         * Toggle fullscreen mode for an element
         * @param {HtmlElement} elem
         */
        toggle: function toggle(elem) {
            if (this.isFullscreen) {
                this.exit();
            } else {
                this.request(elem);
            }
        },

        /**
         * Listen to fullscreen mode change
         * @param {function} callback
         * @returns {function} The remove function for this listener
         */
        onchange: function onchange(callback) {
            document.addEventListener(fn.fullscreenchange, callback, false);
            return function () {
                return document.removeEventListener(fn.fullscreenchange, callback);
            };
        },

        /**
         * Listen to fullscreen request error
         * @param {function} callback
         * @returns {function} The remove function for this listener
         */
        onerror: function onerror(callback) {
            document.addEventListener(fn.fullscreenerror, callback, false);
            return function () {
                return document.removeEventListener(fn.fullscreenerror, callback);
            };
        },

        raw: fn
    };

    Object.defineProperties(publicAPI, {
        isFullscreen: {
            /**
             * Is in fullscreen mode?
             * @returns {boolean}
             */
            get: function get() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            /**
             * Get the fullscreen element node
             * @returns {HtmlElement}
             */
            get: function get() {
                return document[fn.fullscreenElement];
            }
        },
        enabled: {
            enumerable: true,
            /**
             * Check if fullscreen enabled for this session
             * @returns {boolean}
             */
            get: function get() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });

    return publicAPI;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var math = __webpack_require__(14);

var scrollDurationByDistance = {
    desktop: math.interpolateSegmentsFunction([[0, 0.6], [360, 0.8], [720, 1], [1440, 1.2], [7200, 2.8], [9600, 3], [10000, 3]]),
    mobile: math.interpolateSegmentsFunction([[0, 0.5], [360, 0.7], [720, 0.9], [1440, 1.1], [7200, 2.7], [9600, 2.9], [10000, 2.9]])
};

function calcScrollDuration(currentY, targetY, isMobile) {
    var delta = Math.abs(targetY - currentY);
    return scrollDurationByDistance[isMobile ? 'mobile' : 'desktop'](delta);
}

module.exports = {
    calcScrollDuration: calcScrollDuration
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var eventMap = {
    'mousedown': { endEventSource: 'window', endEventName: 'mouseup' },
    'mouseenter': { endEventSource: 'eventSource', endEventName: 'mouseleave' }

    /**
     * Set the drag state on drag start
     *
     * @param {MouseEvent} event mouse event
     * @param {{
     *      minX: number = 0,
     *      maxX: number = MAX_SAFE_INTEGER,
     *      offsetX: number = 0,
     *      minY: number = 0,
     *      maxY: number = MAX_SAFE_INTEGER,
     *      offsetY: number = 0
     * }} options
     *
     * @returns {{
     *      endX: number,
     *      minX: number,
     *      maxX: number,
     *      moveX: number,
     *      clientX: number,
     *      endY: number,
     *      minY: number,
     *      maxY: number,
     *      moveY: number,
     *      clientY: number,
     *      dragging: boolean
     * }}
     */
};function getInitialDragState(event, options) {
    var _options$minX = options.minX,
        minX = _options$minX === undefined ? 0 : _options$minX,
        _options$maxX = options.maxX,
        maxX = _options$maxX === undefined ? Number.MAX_SAFE_INTEGER : _options$maxX,
        _options$offsetX = options.offsetX,
        endX = _options$offsetX === undefined ? 0 : _options$offsetX,
        _options$minY = options.minY,
        minY = _options$minY === undefined ? 0 : _options$minY,
        _options$maxY = options.maxY,
        maxY = _options$maxY === undefined ? Number.MAX_SAFE_INTEGER : _options$maxY,
        _options$offsetY = options.offsetY,
        endY = _options$offsetY === undefined ? 0 : _options$offsetY;

    var moveX = endX;
    var moveY = endY;
    var clientX = event.clientX,
        clientY = event.clientY;

    var eventName = event.type;
    var eventSource = event.currentTarget;
    return {
        endX: endX,
        minX: minX,
        maxX: maxX,
        moveX: moveX,
        clientX: clientX,
        endY: endY,
        minY: minY,
        maxY: maxY,
        moveY: moveY,
        clientY: clientY,
        eventName: eventName,
        eventSource: eventSource,
        dragging: true
    };
}

/**
 * A simple drag utility.
 * Initiate it with some params and callbacks and call start()
 * This utility does not actually drag things, rather than creates the mouse event and distances infrastructure
 *
 * @example
 *   var drag = SimpleDrag({
 *      minX: 0,
 *      maxX: 100,
 *      onDrag: (event, state) => event.target.left = `${state.endX}px`
 *      onDragEnd: (event, state) => console.log(`moved ${event.target.id} to x ${state.endX}`)
 *   })
 *   someDomElement.addEventListener('mousedown', drag.start)
 *
 * @param {{
 *      onDragStart: (function(event:MouseEvent, state:object)),
 *      onDragEnd: (function(event:MouseEvent, state:object)),
 *      onDrag: (function(event:MouseEvent, state:object)),
 *      minX: number = 0,
 *      maxX: number = MAX_SAFE_INTEGER,
 *      offsetX: number = 0,
 *      minY: number = 0,
 *      maxY: number = MAX_SAFE_INTEGER,
 *      offsetY: number = 0
 * }} options
 *
 * @returns {{
 *      start: (function(event:MouseEvent)) Start dragging,
 *      kill: (function()) Force removal of window events and reset drag state
 * }}
 */
module.exports = function SimpleDrag(options) {

    // Set callbacks
    var onDragStart = options.onDragStart,
        onDragEnd = options.onDragEnd,
        onDrag = options.onDrag;

    // Create empty State

    var state = {};

    /**
     * Invoke to start dragging
     *
     * @param {MouseEvent} event
     */
    var dragStart = function dragStart(event) {
        state = getInitialDragState(event, options);

        var endEventName = eventMap[state.eventName].endEventName;
        var endEventSource = eventMap[state.eventName].endEventSource === 'window' ? window : state.eventSource;

        window.addEventListener('mousemove', dragging);
        endEventSource.addEventListener(endEventName, dragEnd);

        onDragStart && onDragStart(event, state);
        event.stopPropagation();
        event.preventDefault();
    };

    /**
     * Invoke on mouse move while dragging
     *
     * @private
     * @param {MouseEvent} event
     */
    var dragEnd = function dragEnd(event) {
        onDragEnd && onDragEnd(event, state);

        kill(state);

        event.stopPropagation();
        event.preventDefault();
    };

    /**
     * Invoke on mouse up while dragging
     *
     * @private
     * @param {MouseEvent} event
     */
    var dragging = function dragging(event) {
        var movementX = event.clientX - state.clientX;
        var movementY = event.clientY - state.clientY;

        state.moveX = movementX + state.moveX;
        state.moveY = movementY + state.moveY;

        state.endX = Math.min(Math.max(state.moveX, state.minX), state.maxX);
        state.endY = Math.min(Math.max(state.moveY, state.minY), state.maxY);

        state.clientX = event.clientX;
        state.clientY = event.clientY;

        onDrag && onDrag(event, state);

        event.stopPropagation();
        event.preventDefault();
    };

    /**
     * Force removal of window events and reset drag state
     */
    var kill = function kill(currentState) {
        // Reset state
        state = {};

        var endEventName = eventMap[currentState.eventName].endEventName;
        var endEventSource = eventMap[currentState.eventName].endEventSource === 'window' ? window : currentState.eventSource;

        window.removeEventListener('mousemove', dragging);
        endEventSource.removeEventListener(endEventName, dragEnd);
    };

    return {
        start: dragStart,
        kill: kill
    };
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pageAnchors = {
    TOP_ANCHOR_ID: 'SCROLL_TO_TOP',
    TOP_ANCHOR_COMP_ID: 'PAGE_TOP_ANCHOR',
    BOTTOM_ANCHOR_ID: 'SCROLL_TO_BOTTOM',
    BOTTOM_ANCHOR_COMP_ID: 'PAGE_BOTTOM_ANCHOR'
};

module.exports = {
    GLOBAL_IMAGE_QUALITY: 'IMAGE_QUALITY',
    GLOBAL_IMAGE_QUALITY_PROPERTIES: ['quality', 'unsharpMask'],
    MASTER_PAGE_ID: 'masterPage',
    HEADER_ID: 'SITE_HEADER',
    FOOTER_ID: 'SITE_FOOTER',
    SITE_STRUCTURE_ID: 'masterPage',
    SAME_PAGE_SCROLL_ANCHORS: [pageAnchors.TOP_ANCHOR_ID, pageAnchors.BOTTOM_ANCHOR_ID],
    PAGE_ANCHORS: pageAnchors,
    PAGES_CONTAINER_ID: 'PAGES_CONTAINER',
    SITE_PAGES_ID: 'SITE_PAGES',
    COMP_SIZE: {
        MIN_WIDTH: 5,
        MIN_HEIGHT: 5,
        MAX_WIDTH: 2500,
        MAX_HEIGHT: 15000
    },
    COMP_MODES_TYPES: {
        'HOVER': 'HOVER',
        'SCROLL': 'SCROLL',
        'WIDTH': 'WIDTH',
        'DEFAULT': 'DEFAULT',
        'APPLICATIVE': 'APPLICATIVE',
        'SHOW_ON_SOME_PAGES': 'SHOW_ON_SOME_PAGES'
    },
    URL_FORMATS: {
        SLASH: 'slash',
        HASH_BANG: 'hashBang'
    },
    DEFAULT_PAGE_URI_SEO: 'untitled',
    DEFAULT_POPUP_URI_SEO_PREFIX: 'popup-',
    BRIGHTNESS_DIFF_THRESHOLD: 20,
    FREE_DOMAIN: {
        WIXSITE: 'wixsite.com',
        WIX: 'wix.com'
    },
    Animations: {
        Modes: {
            AnimationType: {
                ENTER: 'enter',
                LEAVE: 'leave',
                TRANSITION: 'transition'
            }
        },
        TimingFunctions: {
            EaseInOut: 'cubic-bezier(0.420, 0.000, 0.580, 1.000)'
        },
        TransitionType: {
            SCALE: 'Scale',
            NO_SCALE: 'NoScale',
            NO_DIMESIONS: 'NoDimensions'
        }
    }
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *
 * @param win
 * @returns {{local: (.requestModel.localStorage|*|exports.browser.localStorage|defaultSiteModel.requestModel.localStorage|Storage|localStorage), session: (exports.browser.sessionStorage|*|Storage|defined.sessionStorage|sessionStorage)}}
 */

function init(win) {
    win = win || {};

    function Storage() {}

    // Missing definitions for length and key
    Storage.prototype = {
        getItem: function getItem(key) {
            return key in this ? this[key] : null;
        },
        setItem: function setItem(key, value) {
            this[key] = '' + value;
        },
        removeItem: function removeItem(key) {
            delete this[key];
        },
        clear: function clear() {
            for (var p in this) {
                if (this.hasOwnProperty(p)) {
                    delete this[p];
                }
            }
        }
    };

    function canUse(name) {
        var unique = 'testStorage' + Date.now();
        try {
            var storage = win[name];
            storage.setItem(unique, unique);
            var value = storage.getItem(unique);
            storage.removeItem(unique);
            if (value !== unique) {
                throw 'not equal';
            }
        } catch (e) {
            return false;
        }
        return true;
    }

    return {
        local: canUse('localStorage') ? win.localStorage : new Storage(),
        session: canUse('sessionStorage') ? win.sessionStorage : new Storage()
    };
}

module.exports = init;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var requestsUtil = __webpack_require__(7);

var TIMEDOUT_DEBOUNCE = 50;

function resolvePath(dataContainer, path) {
    return _.get(dataContainer, path) || null;
}

function ensurePath(dataContainer, path) {
    if (_.isArray(path) && _.size(path) > 0) {
        var nestedValueInDataContainer = _.get(dataContainer, path) || {};
        _.set(dataContainer, path, nestedValueInDataContainer);
    }
}

/**
 * here we transform the response and stick it in the right place in the fullPagesData
 * @param {utils.Store.requestDescriptor} request
 * @param {object} response
 * @param {object} dataContainer
 */
function requestDoneCallback(request, response, dataContainer) {
    var transform = request.transformFunc || _.identity;
    ensurePath(dataContainer, request.destination);
    var currentValue = resolvePath(dataContainer, request.destination);

    var newValue = transform(response, currentValue);
    _.set(dataContainer, request.destination, newValue);
}

/**
 * request the store to load a resource (resource details are in requestObject) and place that resource
 * in its data container under the given path after it was transformed by the transformationFunction (_.identity by default)
 * @param {utils.Store.requestDescriptor} request
 * @param {object} dataContainer
 * @param {object} pendingRequests
 * @param {function} fetchFunc
 * @param dataLoadedCallbacks
 */
function loadRequestDescriptor(request, dataContainer, pendingRequests, fetchFunc, dataLoadedCallbacks) {
    // look for the requested data in the fullPagesData (might have been requested before)
    var targetData = resolvePath(dataContainer, request.destination);
    if (targetData && !request.force) {
        // data was already fetched - call the complete callback
        request.callback(targetData);
        request.done();
    } else if (pendingRequests[request.key] && !request.force) {
        pendingRequests[request.key].push(request);
    } else {
        // when request.force is true we should always get here
        pendingRequests[request.key] = pendingRequests[request.key] || [];

        // this callback will be called only once as the callback of the actual request
        // doesn't matter if the request was successful or failed we need to cleanup the pendingRequest map
        // to make sure future request will get through
        var updatePendingAndCallRequestDone = function updatePendingAndCallRequestDone(response, err) {
            var isWixServiceError = _.has(response, 'errorCode') && response.errorCode !== 0;
            if (!err && !isWixServiceError) {
                requestDoneCallback(request, response, dataContainer);
                var currentValue = resolvePath(dataContainer, request.destination);
                // first call the request callback
                request.callback(currentValue, response);
                // then all the rest
                _.forEach(pendingRequests[request.key], function (req) {
                    req.callback(currentValue, response);
                });
                _.forEach(dataLoadedCallbacks, function (dataLoadedCallback) {
                    dataLoadedCallback(request.destination, resolvePath(dataContainer, request.destination));
                });
            } else {
                // first call the request error callback
                request.error(err, response);
                // then all the rest
                _.forEach(pendingRequests[request.key], function (req) {
                    req.error(err, response);
                });
            }
            // first call the request callback
            request.done();
            // then all the rest
            _.forEach(pendingRequests[request.key], function (req) {
                req.done();
            });
            delete pendingRequests[request.key];
        };

        requestsUtil.createAndSendRequest(request, updatePendingAndCallRequestDone, fetchFunc);
    }
}

/**
 * @typedef {Store} utils.Store
 *
 * @property {object} dataContainer
 * @property {function} fetchFunc
 * @property {object} pendingRequests
 */

/**
 * @typedef {object} utils.Store.requestDescriptor
 *
 * @property {string[]} destination         	- array of strings representing the path to where we need the response to be.
 * @property {string} url                   	- where to get the data from
 * @property {?boolean} force               	- when true, will disregard the already existing data in the destination and a request will go to the server
 * @property {?string[]} urls               	- fallback urls for the request
 * @property {?object} data                 	- json object of the data to be serialized and sent with the request
 * @property {?string} dataType             	- request data type, default to JSON
 * @property {?function} onUrlRequestFailure	- a callback that will be invoked for each failed url request
 * @property {?function} callback          	 	- callback for the request, will be called for cache hits and real requests
 * @property {?function} error              	- error callback for the request, will be called for real requests that had and error
 * @property {?function} transformFunc      	- transformation function on the response data, will be called only on real requests. transformFunc will receive the response data and the current value in the destination.
 */

/**
 * @constructor
 */
function Store(dataContainer, fetchFunc) {
    this.dataContainer = dataContainer;
    this.fetchFunc = fetchFunc;
    this.pendingRequests = {};
    this.isClientSideRender = typeof window !== 'undefined' && window.clientSideRender;
    this.dataLoadedCallbacks = [];
}

Store.prototype = {
    /**
     * load a batch of requests and call doneCallback when they all arrived.
     * @param {utils.Store.requestDescriptor[]} requestDescriptors
     * @param {function} doneCallback
     */
    loadBatch: function loadBatch(requestDescriptors, doneCallback) {
        var _this = this;

        doneCallback = doneCallback || _.noop;
        if (!requestDescriptors || requestDescriptors.length === 0) {
            _.defer(doneCallback);
        }

        var numOfDone = 0;
        var numOfTimedOut = 0;
        var origCallback = null;
        function requestDone(reqDesc, timedOut) {
            // reqDesc.timerId is undefined if no timeout, 0 if timeout already occurred, otherwise timeout still pending
            if (timedOut) {
                numOfTimedOut++;
                if (!origCallback) {
                    origCallback = doneCallback;
                    doneCallback = _.debounce(doneCallback, TIMEDOUT_DEBOUNCE);
                }
                reqDesc.timerId = 0;
            } else if (reqDesc.timerId) {
                clearTimeout(reqDesc.timerId);
            } else if (reqDesc.timerId === 0) {
                numOfTimedOut--;
                numOfDone--;
            }
            numOfDone++;
            if (numOfDone === requestDescriptors.length) {
                if (numOfTimedOut === 0 && origCallback) {
                    doneCallback.cancel();
                    doneCallback = origCallback;
                    origCallback = null;
                }
                doneCallback(numOfTimedOut > 0);
            }
        }

        _.forEach(requestDescriptors, function (reqDesc) {
            reqDesc.force = reqDesc.force === true;
            reqDesc.callback = reqDesc.callback || _.noop;
            reqDesc.error = reqDesc.error || _.noop;
            reqDesc.done = requestDone.bind(_this, reqDesc, false);
            var data = reqDesc.data ? JSON.stringify(reqDesc.data) : '';
            reqDesc.key = reqDesc.destination.join('.');
            var mainUrl = reqDesc.url;
            if (!mainUrl) {
                mainUrl = reqDesc.urls ? reqDesc.urls[0] : '';
            }
            reqDesc.fullKey = reqDesc.key + '|' + mainUrl + '|' + data;
            if (_this.isClientSideRender && _.isNumber(reqDesc.timeout)) {
                reqDesc.timerId = setTimeout(requestDone.bind(_this, reqDesc, true), reqDesc.timeout);
            }
            reqDesc.start = _.now();
            loadRequestDescriptor(reqDesc, _this.dataContainer, _this.pendingRequests, _this.fetchFunc, _this.dataLoadedCallbacks);
        });
    },
    registerDataLoadedCallback: function registerDataLoadedCallback(dataLoadedFn) {
        this.dataLoadedCallbacks.push(dataLoadedFn);
    },


    /**
     * @returns {object}
     */
    getData: function getData() {
        return this.dataContainer;
    }
};

module.exports = Store;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var requestsUtil = __webpack_require__(7);

var TIMEDOUT_DEBOUNCE = 50;

/**
 * here we transform the response and stick it in the right place in the fullPagesData
 * @param {utils.Store.requestDescriptor} request
 * @param {object} response
 * @param {*} currentData
 */
function transformResponseIfNeeded(request, response, getDataFunc) {
    if (request.transformFunc) {
        var currentData = getDataFunc(request.destination);
        currentData = _.isUndefined(currentData) ? {} : currentData;
        return request.transformFunc(response, currentData);
    }

    return response;
}

/**
 * request the store to load a resource (resource details are in requestObject) and place that resource
 * in its data container under the given path after it was transformed by the transformationFunction (_.identity by default)
 * @param {utils.Store.requestDescriptor} request
 * @param {function} getDataFunc
 * @param {object} pendingRequests
 * @param {function} fetchFunc
 * @param dataLoadedCallbacks
 */
function loadRequestDescriptor(request, getDataFunc, pendingRequests, fetchFunc, dataLoadedCallbacks) {
    // look for the requested data in the fullPagesData (might have been requested before)
    var currentData = getDataFunc(request.destination);
    if (currentData && !request.force) {
        // data was already fetched - call the complete callback
        request.callback(currentData);
        request.done();
    } else if (pendingRequests[request.key] && !request.force) {
        pendingRequests[request.key].push(request);
    } else {
        // when request.force is true we should always get here
        pendingRequests[request.key] = pendingRequests[request.key] || [];

        // this callback will be called only once as the callback of the actual request
        // doesn't matter if the request was successful or failed we need to cleanup the pendingRequest map
        // to make sure future request will get through
        var updatePendingAndCallRequestDone = function updatePendingAndCallRequestDone(response, err) {
            var isWixServiceError = _.has(response, 'errorCode') && response.errorCode !== 0;
            if (!err && !isWixServiceError) {
                var transformedResponse = transformResponseIfNeeded(request, response, getDataFunc);
                // first call the request callback
                request.callback(transformedResponse, response);
                // then all the rest
                _.forEach(pendingRequests[request.key], function (req) {
                    req.callback(transformedResponse, response);
                });
                _.forEach(dataLoadedCallbacks, function (dataLoadedCallback) {
                    dataLoadedCallback(request.destination, transformedResponse);
                });
            } else {
                // first call the request error callback
                request.error(err, response);
                // then all the rest
                _.forEach(pendingRequests[request.key], function (req) {
                    req.error(err, response);
                });
            }
            // first call the request callback
            request.done();
            // then all the rest
            _.forEach(pendingRequests[request.key], function (req) {
                req.done();
            });
            delete pendingRequests[request.key];
        };

        requestsUtil.createAndSendRequest(request, updatePendingAndCallRequestDone, fetchFunc);
    }
}

/**
 * @typedef {Store} utils.Store
 *
 * @property {function} getDataFunc
 * @property {function} fetchFunc
 * @property {object} pendingRequests
 */

/**
 * @typedef {object} utils.Store.requestDescriptor
 *
 * @property {string[]} destination         	- array of strings representing the path to where we need the response to be.
 * @property {string} url                   	- where to get the data from
 * @property {?boolean} force               	- when true, will disregard the already existing data in the destination and a request will go to the server
 * @property {?string[]} urls               	- fallback urls for the request
 * @property {?object} data                 	- json object of the data to be serialized and sent with the request
 * @property {?string} dataType             	- request data type, default to JSON
 * @property {?function} onUrlRequestFailure	- a callback that will be invoked for each failed url request
 * @property {?function} callback          	 	- callback for the request, will be called for cache hits and real requests
 * @property {?function} error              	- error callback for the request, will be called for real requests that had and error
 * @property {?function} transformFunc      	- transformation function on the response data, will be called only on real requests. transformFunc will receive the response data and the current value in the destination.
 */

/**
 * @constructor
 */
function Store(getDataFunc, fetchFunc) {
    this.getDataFunc = getDataFunc;
    this.fetchFunc = fetchFunc;
    this.pendingRequests = {};
    this.dataLoadedCallbacks = [];
}

Store.prototype = {
    /**
     * load a batch of requests and call doneCallback when they all arrived.
     * @param {utils.Store.requestDescriptor[]} requestDescriptors
     * @param {function} doneCallback
     */
    loadBatch: function loadBatch(requestDescriptors, doneCallback) {
        doneCallback = doneCallback || _.noop;
        if (!requestDescriptors || requestDescriptors.length === 0) {
            _.defer(doneCallback);
        }

        var numOfDone = 0;
        var numOfTimedOut = 0;
        var origCallback = null;
        function requestDone(reqDesc, timedOut) {
            // reqDesc.timerId is undefined if no timeout, 0 if timeout already occurred, otherwise timeout still pending
            if (timedOut) {
                numOfTimedOut++;
                if (!origCallback) {
                    origCallback = doneCallback;
                    doneCallback = _.debounce(doneCallback, TIMEDOUT_DEBOUNCE);
                }
                reqDesc.timerId = 0;
            } else if (reqDesc.timerId) {
                clearTimeout(reqDesc.timerId);
            } else if (reqDesc.timerId === 0) {
                numOfTimedOut--;
                numOfDone--;
            }
            numOfDone++;
            if (numOfDone === requestDescriptors.length) {
                if (numOfTimedOut === 0 && origCallback) {
                    doneCallback.cancel();
                    doneCallback = origCallback;
                    origCallback = null;
                }
                doneCallback(numOfTimedOut > 0);
            }
        }

        _.forEach(requestDescriptors, function (reqDesc) {
            reqDesc.force = reqDesc.force === true;
            reqDesc.callback = reqDesc.callback || _.noop;
            reqDesc.error = reqDesc.error || _.noop;
            reqDesc.done = requestDone.bind(this, reqDesc, false);
            if (reqDesc.customDownload) {
                reqDesc.customDownload(this.pendingRequests, this.dataLoadedCallbacks);
            } else {
                var data = reqDesc.data ? JSON.stringify(reqDesc.data) : '';
                reqDesc.key = reqDesc.destination.join('.');
                var mainUrl = reqDesc.url;
                if (!mainUrl) {
                    mainUrl = reqDesc.urls ? reqDesc.urls[0] : '';
                }
                reqDesc.fullKey = reqDesc.key + '|' + mainUrl + '|' + data;
                if (_.isNumber(reqDesc.timeout)) {
                    reqDesc.timerId = setTimeout(requestDone.bind(this, reqDesc, true), reqDesc.timeout);
                }
                reqDesc.start = _.now();
                loadRequestDescriptor(reqDesc, this.getDataFunc, this.pendingRequests, this.fetchFunc, this.dataLoadedCallbacks);
            }
        }.bind(this));
    },
    registerDataLoadedCallback: function registerDataLoadedCallback(dataLoadedFn) {
        this.dataLoadedCallbacks.push(dataLoadedFn);
    }
};

module.exports = Store;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var PREFIXES = ['Webkit', 'Moz', 'ms'];

function prefix(styles) {
    return _.reduce(styles, function (prefixed, value, key) {
        prefixed[key] = value;
        key = _.upperFirst(key);
        return PREFIXES.reduce(function (prefixedSoFar, pre) {
            prefixedSoFar[pre + key] = value;
            return prefixedSoFar;
        }, prefixed);
    }, {});
}

function unitize(value, unit) {
    if (typeof value === 'number') {
        unit = unit || 'px';
        value += unit;
    }
    return value;
}

function assignStyle(elem, src) {
    if (elem) {
        return _.assignWith(elem.style, src, function (u, v) {
            return unitize(v);
        });
    }
}

module.exports = {
    MAX_Z_INDEX: Math.pow(2, 31) - 1,

    /**
     *
     * @param {Object} styles
     * @param {Object} target
     * @returns {Object}
     */
    prefix: prefix,

    /**
     *  Get the correct prefixed CSS transform attribute for the current browser
     *  Based on Modernizr
     *  @returns {String}
     */
    getPrefixedTransform: function getPrefixedTransform() {
        if (!this._prefixedTransform) {
            // if we are on server side rendering, don't look for document
            var el = { style: { transform: '' } };
            if (typeof document !== 'undefined') {
                el = window.document.createElement('fakeelement');
            }

            var transforms = ['transform', 'WebkitTransform', 'MSTransform'];
            this._prefixedTransform = _.find(transforms, function (transform) {
                return el.style[transform] !== undefined;
            });
        }
        return this._prefixedTransform;
    },


    /**
     *
     * @param {{number|string}} value
     * @param {?string} unit
     * @returns {string}
     */
    unitize: unitize,

    /**
     * Assign new size to HTML element
     * @param {Object} elem
     * @param {{number|string}} width
     * @param {{number|string}} height
     */
    assignStyle: assignStyle
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var filters = __webpack_require__(74);
var getters = __webpack_require__(72);

module.exports = {
    getFilter: getters.getFilter.bind(null, filters),
    getFilterNames: getters.getFilterNames.bind(null, filters),
    getFilterDefaults: getters.getFilterDefaults.bind(null, filters),
    isFilterExists: getters.isFilterExists.bind(null, filters)
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var candidatePhoneNumberPattern = /(?:\+|\()?\d(?:[\-\.\(\) \t\u00a0\u1680\u180e\u2000\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]{0,5}\d){6,16}\)?|\*\d{4}/g;
var emailPattern = /(^|[\s:;,<>])([A-Z0-9][A-Z0-9._%+-]+@[A-Z0-9][A-Z0-9.-]+\.[A-Z]{2,})(?=$|[\s:;,<>])/ig; //http://www.regular-expressions.info/email.html
var urlPattern = /(^|[\s:;,<>])((?:https?:\/\/|www\.)[a-z0-9](?:\.?[a-z0-9\-%_])*(?:(?:\\|\/)[a-z0-9\-._~:/\\?#\[\]@!$&'()*+,;=%]*)?)(?=$|[^a-z0-9\-._~:/\\?#\[\]@!$&'()*+,;=%])/ig;

var Pattern = {
    'PHONE': 'PHONE',
    'MAIL': 'MAIL',
    'URL': 'URL'
};

function findAll(text, includedPatterns) {
    var results = _.flatten([_.get(includedPatterns, 'PHONE') ? findPhoneNumbers(text) : [], _.get(includedPatterns, 'MAIL') ? findEmails(text) : [], _.get(includedPatterns, 'URL') ? findUrls(text) : []]);

    return resolveCollisions(results);
}

function findPhoneNumbers(text) {
    var results = [];
    var singleRegexExec = void 0;
    while (singleRegexExec = candidatePhoneNumberPattern.exec(text)) {
        var value = singleRegexExec[0].match(/[*\d]/g).join('');
        results.push({
            key: singleRegexExec[0],
            value: value,
            index: singleRegexExec.index,
            pattern: Pattern.PHONE
        });
    }

    return results;
}

function findEmails(text) {
    var results = [];
    var singleRegexExec = void 0;
    while (singleRegexExec = emailPattern.exec(text)) {
        var mainCapture = singleRegexExec[2];
        var prefixSize = singleRegexExec[1].length;
        results.push({
            key: mainCapture,
            value: mainCapture,
            index: singleRegexExec.index + prefixSize,
            pattern: Pattern.MAIL
        });
    }
    return results;
}

function findUrls(text) {
    var results = [];
    var singleRegexExec = void 0;
    while (singleRegexExec = urlPattern.exec(text)) {
        var mainCapture = singleRegexExec[2];
        var prefixSize = singleRegexExec[1].length;
        var beginsWithHttp = singleRegexExec[2].toLowerCase().indexOf('http') === 0;
        var value = beginsWithHttp ? mainCapture : 'http://' + mainCapture;
        results.push({
            key: mainCapture,
            value: value,
            index: singleRegexExec.index + prefixSize,
            pattern: Pattern.URL
        });
    }
    return results;
}

function resolveCollisions(resultList) {
    return _(resultList).orderBy('index', 'asc').transform(function (result, item) {
        var lastItem = _.last(result);
        if (!lastItem || item.index > lastItem.index + lastItem.key.length) {
            result.push(item);
        }
    }, []).value();
}

module.exports = {
    Pattern: Pattern,
    findAll: findAll
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var htmlTransformer = __webpack_require__(12);

var IMAGE_WHITE_LIST_ATTRIBUTES = ['src', 'style', 'wix-comp'];
var FORBIDDEN_TAGS = ['script', 'iframe', 'embed', 'object', 'meta'];
var SENSITIVE_ATTRIBUTES = ['href', 'src', 'style'];
var FORBIDDEN_TAGS_AND_ATTRIBUTES = ['script', 'iframe', 'embed', 'object', 'meta', 'expression', 'id', 'comp', 'dataquery', 'propertyquery', 'styleid', 'skin', 'skinpart', 'y', 'x', 'scale', 'angle', 'idprefix', 'state', 'container', 'listposition', 'hasproxy', 'vcfield', 'vcview', 'vctype', 'pos', 'onabort', 'onactivate', 'onafterprint', 'onafterupdate', 'onbeforeactivate', 'onbeforecopy', 'onbeforecut', 'onbeforedeactivate', 'onbeforeeditfocus', 'onbeforepaste', 'onbeforeprint', 'onbeforeunload', 'onbeforeupdate', 'onbegin', 'onblur', 'onbounce', 'oncellchange', 'onchange', 'onclick', 'oncontextmenu', 'oncontrolselect', 'oncopy', 'oncut', 'ondataavailable', 'ondatasetchanged', 'ondatasetcomplete', 'ondblclick', 'ondeactivate', 'ondrag', 'ondragend', 'ondragleave', 'ondragenter', 'ondragover', 'ondragdrop', 'ondragstart', 'ondrop', 'onend', 'onerror', 'onerrorupdate', 'onfilterchange', 'onfinish', 'onfocus', 'onfocusIn', 'onfocusout', 'onhashchange', 'onhelp', 'oninput', 'onkeydown', 'onkeypress', 'onkeyup', 'onlayoutcomplete', 'onload', 'onlosecapture', 'onmediacomplete', 'onmediaerror', 'onmessage', 'onmousedown', 'onmouseenter', 'onmouseleave', 'onmousemove', 'onmouseout', 'onmouseover', 'onmouseup', 'onmousewheel', 'onmove', 'onmoveend', 'onmovestart', 'onoffline', 'ononline', 'onoutofsync', 'onpaste', 'onpause', 'onpopstate', 'onprogress', 'onpropertychange', 'onreadystatechange', 'onredo', 'onrepeat', 'onreset', 'onresize', 'onresizeend', 'onresizestart', 'onresume', 'onreverse', 'onrowsenter', 'onrowexit', 'onrowdelete', 'onrowinserted', 'onscroll', 'onseek', 'onselect', 'onselectionchange', 'onselectstart', 'onstart', 'onstop', 'onstorage', 'onsyncrestored', 'onsubmit', 'ontimeerror', 'ontrackchange', 'onundo', 'onunload', 'onurlflip', 'seeksegmenttime'];

function shouldTagBeRemoved(tag) {
    return _.some(FORBIDDEN_TAGS, function (v) {
        return tag.toLowerCase() === v;
    });
}

function getAttributesNames(attributes) {
    return _.map(attributes, function (a) {
        return a.name.toLowerCase();
    });
}

function getForbiddenImageAttributesNames(attributes) {
    var attributesNames = getAttributesNames(attributes);
    return _.difference(attributesNames, IMAGE_WHITE_LIST_ATTRIBUTES);
}

function getForbiddenBaseAttributesNames(tag) {
    if (tag.toLowerCase() === 'a') {
        return _.without(FORBIDDEN_TAGS_AND_ATTRIBUTES, 'dataquery');
    }
    return FORBIDDEN_TAGS_AND_ATTRIBUTES;
}

function isImageNode(tag) {
    return tag.toLowerCase() === 'img';
}

function removeForbiddenValuesFromSensitiveAttributes(attributes) {
    return _.reject(attributes, function (attribute) {
        return _.includes(SENSITIVE_ATTRIBUTES, attribute.name.toLowerCase()) && !!/script|expression/.test(attribute.escaped.toLowerCase());
    });
}

function removeForbiddenAttributes(tag, attributes) {
    var attrs2remove = isImageNode(tag) ? getForbiddenImageAttributesNames(attributes) : getForbiddenBaseAttributesNames(tag);
    return _.reject(attributes, function (attribute) {
        return _.includes(attrs2remove, attribute.name.toLowerCase());
    });
}

function normalizeStartTag(tag, attributes, selfClosing) {
    if (shouldTagBeRemoved(tag)) {
        return null;
    }
    attributes = removeForbiddenAttributes(tag, attributes);
    attributes = removeForbiddenValuesFromSensitiveAttributes(attributes);
    return {
        tag: tag,
        attributes: attributes,
        selfClosing: selfClosing
    };
}

/**
 * @param {string} tag
 * @return {null|string}
 */
function normalizeEndTag(tag) {
    return shouldTagBeRemoved(tag) ? null : tag;
}

function removeComment() {
    return '';
}

/**
 * @param {string} text
 * @param {string} startTag
 * @return {string}
 */
function handleChars(text, startTag) {
    return _.includes(FORBIDDEN_TAGS, startTag.toLowerCase()) ? '' : text;
}

function fixSecurityIssuesInText(textData) {
    var handler = {
        start: normalizeStartTag,
        end: normalizeEndTag,
        comment: removeComment,
        chars: handleChars
    };
    textData.text = htmlTransformer.transformHTMLString(textData.text, handler);
    return textData;
}

module.exports = {
    /**
     * @param {object} textData
     * @returns {*}
     */
    fixSecurityIssuesInText: fixSecurityIssuesInText
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function throttledForEach(queue, processElement, chunkSize, timeout) {
    function processChunk() {
        queue.splice(0, chunkSize).forEach(processElement);
        if (queue.length) {
            setTimeout(processChunk, timeout);
        }
    }

    processChunk();
}

module.exports = {
    throttledForEach: throttledForEach
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var throttle = function throttle(callback, wait) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var leading = options.leading === false ? false : true;
    var isWait = false;
    var args = void 0,
        pending = void 0,
        leadingCalled = void 0;
    return function () {
        args = arguments;
        if (leading) {
            if (!leadingCalled) {
                callback.apply(null, args);
                leadingCalled = true;
                args = [];
                window.setTimeout(function () {
                    if (pending) {
                        callback.apply(null, args);
                        pending = false;
                    }
                    leadingCalled = false;
                }, wait);
            } else {
                pending = true;
            }
        } else if (!isWait) {
            window.setTimeout(function () {
                callback.apply(null, args);
                isWait = false;
            }, wait);
            isWait = true;
        }
    };
};

var debounce = function debounce(callback, wait) {
    var timer = void 0;
    return function () {
        var args = arguments;
        if (timer) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(function () {
            callback.apply(null, args);
        }, wait);
    };
};

module.exports = {
    throttle: throttle,
    debounce: debounce
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
/**
 * @class core.intervalsMixin
 */
var intervalsMixin = {
    componentWillMount: function componentWillMount() {
        this.intervals = {};
    },
    componentWillUnmount: function componentWillUnmount() {
        var _this = this;

        _.forEach(this.intervals, function (timerId, timerName) {
            _this.clearIntervalNamed(timerName);
        });
    },
    setIntervalNamed: function setIntervalNamed(timerName, callback, timeout) {
        var _this2 = this;

        if (this.intervals.hasOwnProperty(timerName)) {
            this.clearIntervalNamed(timerName);
        }
        this.intervals[timerName] = setInterval(function () {
            delete _this2.intervals[timerName];
            callback();
        }, timeout);
    },
    setInterval: function setInterval(callback, timeout) {
        this.setIntervalNamed('default', callback, timeout);
    },
    clearIntervalNamed: function clearIntervalNamed(timerName) {
        clearInterval(this.intervals[timerName]);
        delete this.intervals[timerName];
    },
    clearInterval: function clearInterval() {
        this.clearIntervalNamed('default');
    }
};

/**
 * @class core.timeoutsMixin
 */
var timeoutsMixin = {
    componentWillMount: function componentWillMount() {
        this.timeouts = {};
    },
    componentWillUnmount: function componentWillUnmount() {
        var _this3 = this;

        _.forEach(this.timeouts, function (timerId, timerName) {
            _this3.clearTimeoutNamed(timerName);
        });
    },
    setTimeoutNamed: function setTimeoutNamed(timerName, callback, timeout) {
        var _this4 = this;

        if (this.timeouts.hasOwnProperty(timerName)) {
            this.clearTimeoutNamed(timerName);
        }
        this.timeouts[timerName] = setTimeout(function () {
            delete _this4.timeouts[timerName];
            callback();
        }, timeout);
    },
    setTimeout: function setTimeout(callback, timeout) {
        this.setTimeoutNamed('default', callback, timeout);
    },
    clearTimeoutNamed: function clearTimeoutNamed(timerName) {
        if (this.timeouts[timerName]) {
            clearTimeout(this.timeouts[timerName]);
            delete this.timeouts[timerName];
        }
    },
    clearTimeout: function clearTimeout() {
        this.clearTimeoutNamed('default');
    }
};

module.exports = {
    timeoutsMixin: timeoutsMixin,
    intervalsMixin: intervalsMixin
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var animationFrame = __webpack_require__(8);
var activeTweens = [];

function killAll() {
    while (activeTweens.length > 0) {
        killTween(activeTweens[0]);
    }
}

function killTweensOf(target) {
    if (typeof this.killTween === 'function') {
        _(activeTweens).filter({ _target: target }).forEach(this.killTween);
    }
}

function killTween(tween) {
    tween.dispose();
    var index = activeTweens.indexOf(tween);
    if (index !== -1) {
        activeTweens.splice(index, 1);
    }
}

function parseUnit(propValue) {
    var regex = /[^0-9-]+$/;
    if (regex.test(propValue) === true) {
        return String(String(propValue).match(regex)[0]);
    }
    return '';
}

function parseParameter(paramObj, paramName, defaultValue) {
    var result = void 0;
    if (paramObj[paramName] !== undefined) {
        result = paramObj[paramName];
        delete paramObj[paramName];
    } else {
        result = defaultValue;
    }
    return result;
}

function setStyle(propName, value, unit) {
    var $ = __webpack_require__(4);
    $(this._target).css(propName, String(value) + unit);
}

function setTargetProperty(propName, value) {
    this._target[propName] = value;
}

var easeFuncs = {
    linear: function linear(t, b, c, d) {
        return c * t / d + b;
    },
    strong_easeIn: function strong_easeIn(t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },

    strong_easeOut: function strong_easeOut(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },

    strong_easeInOut: function strong_easeInOut(t, b, c, d) {
        if ((t /= d * 0.5) < 1) {
            return c * 0.5 * t * t * t * t * t + b;
        }
        return c * 0.5 * ((t -= 2) * t * t * t * t + 2) + b;
    },

    swing: function swing(t, b, c, d) {
        return -Math.cos((c * t / d + b) * Math.PI) / 2 + 0.5;
    }
};

var render = function render() {
    var obj = void 0;
    var value = void 0;
    if (this._isAlive) {
        var currentT = _.now();
        this._tStep = currentT - this._t0;
        this._t0 = currentT;
        this._t += this._tStep;
        for (var i = 0; i < this._easeParams.length; i++) {
            obj = this._easeParams[i];
            if (this._t < this._duration) {
                value = this._easeFunc(this._t, 0, 1, this._duration) * (obj.targetValue - obj.origValue) + obj.origValue;
            } else {
                value = obj.targetValue;
            }

            if (obj.unit) {
                if (obj.unit === 'px') {
                    value = Math.round(value);
                }
            }
            this._setValueFunc(obj.propName, value, obj.unit);
            if (this._onUpdateCallback !== null) {
                this._onUpdateCallback(value, this._target, obj.propName);
            }
        }

        if (this._t < this._duration) {
            animationFrame.request(render.bind(this));
        } else {
            if (this._onCompleteCallback !== null) {
                this._onCompleteCallback(this);
            }
            killTween(this);
        }
    }
};

function startTween() {
    killTweensOf(this._target);
    activeTweens.push(this);
    this._t0 = _.now();
    animationFrame.request(render.bind(this));
}

function Tween(target, duration, params) {
    var $ = __webpack_require__(4);
    var easeParamObj = void 0,
        styleValue = void 0;
    this._target = target;
    this._duration = Math.floor(duration * 1000);
    this._easeParams = [];
    this._t = 0;
    this._tStep = null;
    this._isAlive = true;
    var isElement = target instanceof window.HTMLElement;

    if (isElement) {
        this._setValueFunc = setStyle;
    } else {
        this._setValueFunc = setTargetProperty;
    }

    this._easeFunc = this.linear;
    var easeFuncName = parseParameter(params, 'ease', 'linear');
    if (easeFuncs[easeFuncName] !== undefined && typeof easeFuncs[easeFuncName] === 'function') {
        this._easeFunc = easeFuncs[easeFuncName];
    }

    this._onCompleteCallback = parseParameter(params, 'onComplete', null);
    this._onUpdateCallback = parseParameter(params, 'onUpdate', null);
    var delay = parseParameter(params, 'delay', 0);

    for (var propName in params) {
        if (isElement || target[propName] !== undefined) {
            easeParamObj = {};
            easeParamObj.propName = propName;

            if (isElement) {
                styleValue = $(target).css(propName);
                easeParamObj.origValue = parseFloat(styleValue);
                easeParamObj.unit = parseUnit(styleValue);
                if (isNaN(easeParamObj.origValue)) {
                    // TODO: What if this is 'auto' ?
                    easeParamObj.origValue = 0;
                    easeParamObj.unit = 'px';
                }
            } else {
                easeParamObj.origValue = parseFloat(target[propName]);
            }

            easeParamObj.targetValue = parseFloat(params[propName]);
            this._easeParams.push(easeParamObj);
        }
    }

    if (delay === 0) {
        startTween.apply(this);
    } else {
        delay = parseInt(delay * 1000, 10);
        setTimeout(startTween.bind(this), delay);
    }
}

Tween.prototype.dispose = function () {
    this._isAlive = false;
    this._target = null;
    this._onCompleteCallback = null;
    this._onUpdateCallback = null;
};

module.exports = {
    killAll: killAll,
    killTweensOf: killTweensOf,
    killTween: killTween,
    Tween: Tween
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  Function: validateUrl
 *      checks if the urlToTest is a valid URL. NOTE: existence (404 check) is not tested for!.
 *
 *  Parameters:
 *      urlToTest - (string) a url to validate.
 *
 *  Returns:
 *      true if valid.
 */

function isValidUrl(urlToTest) {
    var regexp = /^(?:(?:ftps?:|https?:)?\/\/)?(?:(?:[\u0400-\uA69F\w][\u0400-\uA69F\w-]*)?[\u0400-\uA69F\w]\.)+(?:[\u0400-\uA69Fa-z]+|\d{1,3})(?::[\d]{1,5})?(?:[/?#].*)?$/i;
    return regexp.test(urlToTest);
}

function isValidEmail(emailToTest) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(emailToTest);
}

function isValidUrlNoProtocol(urlToTest) {
    var regexp = new RegExp('^[\\w\\-_]+(\\.[\\w\\-_]+)+([\\w\\-\\.,@?^=%&*;:/~\\+#!|]*[\\w\\-\\@?^=%&*;/~\\+#!|])?$');
    return regexp.test(urlToTest);
}

function isValidTwitterUser(twitterUser) {
    var re = /^@?[a-zA-Z0-9_%]+$/;
    return re.test(twitterUser);
}

module.exports = {
    isValidEmail: isValidEmail,
    isValidUrl: isValidUrl,
    isValidUrlNoProtocol: isValidUrlNoProtocol,
    isValidTwitterUser: isValidTwitterUser
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function getFixedHeight(originalHeight, separator, separatorNotIncluded, borderNotIncluded, menuItemsCount) {
    return originalHeight + (borderNotIncluded ? 1 : menuItemsCount) * separator + (separatorNotIncluded ? 2 : 0);
}

function getLineHeight(itemHeight, separator, border, skinExports) {
    var borderNotIncludedInLineHeight = skinExports && skinExports.borderNotIncludedInLineHeight;
    var separatorNotIncludedInLineHeight = skinExports && skinExports.separatorNotIncludedInLineHeight;

    var calcBorder = borderNotIncludedInLineHeight ? border * 2 : 0;
    var calcSeparator = separatorNotIncludedInLineHeight ? separator : 0;
    var lineHeight = itemHeight - calcBorder - calcSeparator;

    return lineHeight + 2;
}

function getItemHeight(compHeight, separatorHeight, length, skinExports) {
    var borderNotIncludedInLineHeight = skinExports && skinExports.borderNotIncludedInLineHeight;
    var separatorNotIncludedInLineHeight = skinExports && skinExports.separatorNotIncludedInLineHeight;

    return Math.floor((compHeight - separatorHeight * (borderNotIncludedInLineHeight ? 0 : length - 1) - (separatorNotIncludedInLineHeight ? 2 : 0)) / length);
}

function getVisibleItemsCount(siteMenu) {
    return _.filter(siteMenu, 'isVisible').length;
}

module.exports = {
    getFixedHeight: getFixedHeight,
    getLineHeight: getLineHeight,
    getItemHeight: getItemHeight,
    getVisibleItemsCount: getVisibleItemsCount
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var alwaysInViewportList = ['siteBackground'];

/**
 * Test if a component should be always in viewport
 * @param {string} compId
 * @returns {boolean}
 */
function isAlwaysInViewport(siteAPI, compId) {
    return _.includes(alwaysInViewportList, compId);
}

/**
 * Test if a component is in the viewport
 * "In viewport" means that either the top position of the component is in screen bounds,
 * or bottom of component is in screen bounds
 * or bottom is under the screen and top is above the screen, meaning the component "wraps" the viewport
 * @param {SiteAPI} siteAPI
 * @param {{x: number, y:number}} scroll
 * @param {string} compId
 * @param {number} [componentHeightThreshold=0] a number between 0 to 1 represents the percentage of the component that should be in the screen before it counts as "in viewport", normalized to window height
 * @returns {boolean}
 */
function isInViewport(siteAPI, scroll, compId, componentHeightThreshold) {
    var siteData = siteAPI.getSiteData();
    var windowHeight = _.get(siteData, 'measureMap.height.screen');
    var compAbsTop = _.get(siteData, ['measureMap', 'absoluteTop', compId]);
    var compHeight = _.get(siteData, ['measureMap', 'height', compId]);
    var normalizedThreshold = (componentHeightThreshold || 0) * Math.min(compHeight, windowHeight);

    if (_.isUndefined(compAbsTop) || _.isUndefined(compHeight)) {
        return false; //throw new Error('utils.isInViewport: Component ' + compId + ' is not registered in SiteData.measureMap heights or absoluteTops');
    }

    var targetTop = Math.max(compAbsTop + normalizedThreshold, 0);
    var targetBottom = Math.max(compAbsTop + compHeight - normalizedThreshold, 0);

    var isTopInViewPort = scroll.y <= targetTop && targetTop < scroll.y + windowHeight;
    var isBottomInViewPort = scroll.y < targetBottom && targetBottom <= scroll.y + windowHeight;
    var isWrappingViewPort = targetTop <= scroll.y && targetBottom > scroll.y + windowHeight;

    return isTopInViewPort || isBottomInViewPort || isWrappingViewPort;
}

module.exports = {
    isInViewport: isInViewport,
    isAlwaysInViewport: isAlwaysInViewport
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fontMetaData = __webpack_require__(77);
var fontUtils = __webpack_require__(16);

module.exports = fontUtils(fontMetaData);

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var animationsFactory = __webpack_require__(78);
var tweenEngineGreenSock = __webpack_require__(79);

/**
 * Constructor for a local tween engine.
 * @returns {{factory: {animate: (exports.animate|*), transition: (exports.transition|*), sequence: (exports.sequence|*), registerAnimation: *, registerTransition: *, getProperties: (exports.getProperties|*), getAnimationsDefs: *, getTransitionsDefs: *}, engine: {timeline: *, tween: (exports.tween|*), set: exports.set, kill: (exports.kill|*), addTickerEvent: (exports.addTickerEvent|*), removeTickerEvent: (exports.removeTickerEvent|*), isTweening: exports.isTweening, getBoundingRect: exports.getBoundingRect, getBoundingContentRect: *, delayedCall: (exports.delayedCall|*), animateTimeScale: (exports.animateTimeScale|*)}}}
 * @constructor
 * @class core.animations.tweenEngine
 */
function create(tweenMax, TimelineMax) {
    /** core.animations.tweenEngineGreenSock */
    var engine = tweenEngineGreenSock.create(tweenMax, TimelineMax);

    /** core.animationsFactory */
    var factory = animationsFactory.create();

    return {
        factory: {
            animate: factory.animate,
            transition: factory.transition,
            sequence: factory.sequence,
            registerAnimation: factory.registerAnimation,
            registerTransition: factory.registerTransition,
            getProperties: factory.getProperties,
            getAnimationsDefs: factory.getAnimationsDefs,
            getTransitionsDefs: factory.getTransitionsDefs
        },
        engine: {
            timeline: engine.timeline,
            tween: engine.tween,
            set: engine.set,
            kill: engine.kill,
            addTickerEvent: engine.addTickerEvent,
            removeTickerEvent: engine.removeTickerEvent,
            isTweening: engine.isTweening,
            getElementRect: engine.getElementRect,
            getContentRect: engine.getContentRect,
            getBoundingRect: engine.getBoundingRect,
            getBoundingContentRect: engine.getBoundingContentRect,
            delayedCall: engine.delayedCall,
            animateTimeScale: engine.animateTimeScale,
            adjustLagSmoothing: engine.adjustLagSmoothing,
            useRAF: engine.useRAF
        }
    };
}

module.exports = {
    create: create
};

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var r=n();for(var e in r)("object"==typeof exports?exports:t)[e]=r[e]}}(this,function(){return function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.i=function(t){return t},n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=84)}([function(t,n){var r=Array.isArray;t.exports=r},function(t,n,r){var e=r(47),o="object"==typeof self&&self&&self.Object===Object&&self,i=e||o||Function("return this")();t.exports=i},function(t,n){function r(t){var n=typeof t;return null!=t&&("object"==n||"function"==n)}t.exports=r},function(t,n,r){function e(t,n){var r=i(t,n);return o(r)?r:void 0}var o=r(98),i=r(122);t.exports=e},function(t,n,r){function e(t){return u(t)?o(t):i(t)}var o=r(61),i=r(100),u=r(6);t.exports=e},function(t,n,r){function e(t){return null==t?void 0===t?a:c:f&&f in Object(t)?i(t):u(t)}var o=r(8),i=r(121),u=r(144),c="[object Null]",a="[object Undefined]",f=o?o.toStringTag:void 0;t.exports=e},function(t,n,r){function e(t){return null!=t&&i(t.length)&&!o(t)}var o=r(36),i=r(29);t.exports=e},function(t,n){function r(t){return null!=t&&"object"==typeof t}t.exports=r},function(t,n,r){var e=r(1),o=e.Symbol;t.exports=o},function(t,n,r){function e(t){if("string"==typeof t||o(t))return t;var n=t+"";return"0"==n&&1/t==-i?"-0":n}var o=r(21),i=1/0;t.exports=e},function(t,n){function r(t,n){return t===n||t!==t&&n!==n}t.exports=r},function(t,n,r){function e(t){var n=-1,r=null==t?0:t.length;for(this.clear();++n<r;){var e=t[n];this.set(e[0],e[1])}}var o=r(131),i=r(132),u=r(133),c=r(134),a=r(135);e.prototype.clear=o,e.prototype.delete=i,e.prototype.get=u,e.prototype.has=c,e.prototype.set=a,t.exports=e},function(t,n,r){function e(t,n,r){var e=t[n];c.call(t,n)&&i(e,r)&&(void 0!==r||n in t)||o(t,n,r)}var o=r(42),i=r(10),u=Object.prototype,c=u.hasOwnProperty;t.exports=e},function(t,n,r){function e(t,n){for(var r=t.length;r--;)if(o(t[r][0],n))return r;return-1}var o=r(10);t.exports=e},function(t,n,r){function e(t,n){return o(t)?t:i(t,n)?[t]:u(c(t))}var o=r(0),i=r(26),u=r(153),c=r(37);t.exports=e},function(t,n,r){function e(t,n){var r=t.__data__;return o(n)?r["string"==typeof n?"string":"hash"]:r.map}var o=r(129);t.exports=e},function(t,n){function r(t,n){return!!(n=null==n?e:n)&&("number"==typeof t||o.test(t))&&t>-1&&t%1==0&&t<n}var e=9007199254740991,o=/^(?:0|[1-9]\d*)$/;t.exports=r},function(t,n,r){var e=r(3),o=e(Object,"create");t.exports=o},function(t,n,r){function e(t){return"function"==typeof t?t:null==t?u:"object"==typeof t?c(t)?i(t[0],t[1]):o(t):a(t)}var o=r(102),i=r(103),u=r(20),c=r(0),a=r(157);t.exports=e},function(t,n,r){function e(t,n,r,e){var u=!r;r||(r={});for(var c=-1,a=n.length;++c<a;){var f=n[c],s=e?e(r[f],t[f],f,r,t):void 0;void 0===s&&(s=t[f]),u?i(r,f,s):o(r,f,s)}return r}var o=r(12),i=r(42);t.exports=e},function(t,n){function r(t){return t}t.exports=r},function(t,n,r){function e(t){return"symbol"==typeof t||i(t)&&o(t)==u}var o=r(5),i=r(7),u="[object Symbol]";t.exports=e},function(t,n,r){function e(t,n,r){var e=null==t?void 0:o(t,n);return void 0===e?r:e}var o=r(25);t.exports=e},function(t,n,r){var e=r(3),o=r(1),i=e(o,"Map");t.exports=i},function(t,n,r){function e(t){var n=-1,r=null==t?0:t.length;for(this.clear();++n<r;){var e=t[n];this.set(e[0],e[1])}}var o=r(136),i=r(137),u=r(138),c=r(139),a=r(140);e.prototype.clear=o,e.prototype.delete=i,e.prototype.get=u,e.prototype.has=c,e.prototype.set=a,t.exports=e},function(t,n,r){function e(t,n){n=o(n,t);for(var r=0,e=n.length;null!=t&&r<e;)t=t[i(n[r++])];return r&&r==e?t:void 0}var o=r(14),i=r(9);t.exports=e},function(t,n,r){function e(t,n){if(o(t))return!1;var r=typeof t;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=t&&!i(t))||(c.test(t)||!u.test(t)||null!=n&&t in Object(n))}var o=r(0),i=r(21),u=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,c=/^\w*$/;t.exports=e},function(t,n){function r(t){var n=t&&t.constructor;return t===("function"==typeof n&&n.prototype||e)}var e=Object.prototype;t.exports=r},function(t,n,r){var e=r(95),o=r(7),i=Object.prototype,u=i.hasOwnProperty,c=i.propertyIsEnumerable,a=e(function(){return arguments}())?e:function(t){return o(t)&&u.call(t,"callee")&&!c.call(t,"callee")};t.exports=a},function(t,n){function r(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=e}var e=9007199254740991;t.exports=r},function(t,n,r){function e(t){var n=this.__data__=new o(t);this.size=n.size}var o=r(11),i=r(148),u=r(149),c=r(150),a=r(151),f=r(152);e.prototype.clear=i,e.prototype.delete=u,e.prototype.get=c,e.prototype.has=a,e.prototype.set=f,t.exports=e},function(t,n){function r(t,n){for(var r=-1,e=null==t?0:t.length,o=Array(e);++r<e;)o[r]=n(t[r],r,t);return o}t.exports=r},function(t,n){function r(t,n){for(var r=-1,e=n.length,o=t.length;++r<e;)t[o+r]=n[r];return t}t.exports=r},function(t,n,r){var e=r(63),o=r(114),i=o(e);t.exports=i},function(t,n){function r(t){var n=-1,r=Array(t.size);return t.forEach(function(t){r[++n]=t}),r}t.exports=r},function(t,n,r){(function(t){var e=r(1),o=r(158),i="object"==typeof n&&n&&!n.nodeType&&n,u=i&&"object"==typeof t&&t&&!t.nodeType&&t,c=u&&u.exports===i,a=c?e.Buffer:void 0,f=a?a.isBuffer:void 0,s=f||o;t.exports=s}).call(n,r(38)(t))},function(t,n,r){function e(t){if(!i(t))return!1;var n=o(t);return n==c||n==a||n==u||n==f}var o=r(5),i=r(2),u="[object AsyncFunction]",c="[object Function]",a="[object GeneratorFunction]",f="[object Proxy]";t.exports=e},function(t,n,r){function e(t){return null==t?"":o(t)}var o=r(65);t.exports=e},function(t,n){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,n,r){var e=r(12),o=r(19),i=r(67),u=r(6),c=r(27),a=r(4),f=Object.prototype,s=f.hasOwnProperty,p=i(function(t,n){if(c(n)||u(n))return void o(n,a(n),t);for(var r in n)s.call(n,r)&&e(t,r,n[r])});t.exports=p},function(t,n){function r(t,n,r){switch(r.length){case 0:return t.call(n);case 1:return t.call(n,r[0]);case 2:return t.call(n,r[0],r[1]);case 3:return t.call(n,r[0],r[1],r[2])}return t.apply(n,r)}t.exports=r},function(t,n){function r(t,n){for(var r=-1,e=null==t?0:t.length,o=0,i=[];++r<e;){var u=t[r];n(u,r,t)&&(i[o++]=u)}return i}t.exports=r},function(t,n,r){function e(t,n,r){"__proto__"==n&&o?o(t,n,{configurable:!0,enumerable:!0,value:r,writable:!0}):t[n]=r}var o=r(45);t.exports=e},function(t,n,r){function e(t,n,r,u,c){return t===n||(null==t||null==n||!i(t)&&!i(n)?t!==t&&n!==n:o(t,n,r,u,e,c))}var o=r(96),i=r(7);t.exports=e},function(t,n,r){function e(t,n){return u(i(t,n,o),t+"")}var o=r(20),i=r(51),u=r(52);t.exports=e},function(t,n,r){var e=r(3),o=function(){try{var t=e(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();t.exports=o},function(t,n,r){function e(t,n,r,e,f,s){var p=r&c,l=t.length,v=n.length;if(l!=v&&!(p&&v>l))return!1;var h=s.get(t);if(h&&s.get(n))return h==n;var x=-1,d=!0,y=r&a?new o:void 0;for(s.set(t,n),s.set(n,t);++x<l;){var b=t[x],_=n[x];if(e)var g=p?e(_,b,x,n,t,s):e(b,_,x,t,n,s);if(void 0!==g){if(g)continue;d=!1;break}if(y){if(!i(n,function(t,n){if(!u(y,n)&&(b===t||f(b,t,r,e,s)))return y.push(n)})){d=!1;break}}else if(b!==_&&!f(b,_,r,e,s)){d=!1;break}}return s.delete(t),s.delete(n),d}var o=r(59),i=r(91),u=r(66),c=1,a=2;t.exports=e},function(t,n,r){(function(n){var r="object"==typeof n&&n&&n.Object===Object&&n;t.exports=r}).call(n,r(159))},function(t,n,r){var e=r(41),o=r(75),i=Object.prototype,u=i.propertyIsEnumerable,c=Object.getOwnPropertySymbols,a=c?function(t){return null==t?[]:(t=Object(t),e(c(t),function(n){return u.call(t,n)}))}:o;t.exports=a},function(t,n,r){function e(t){return t===t&&!o(t)}var o=r(2);t.exports=e},function(t,n){function r(t,n){return function(r){return null!=r&&(r[t]===n&&(void 0!==n||t in Object(r)))}}t.exports=r},function(t,n,r){function e(t,n,r){return n=i(void 0===n?t.length-1:n,0),function(){for(var e=arguments,u=-1,c=i(e.length-n,0),a=Array(c);++u<c;)a[u]=e[n+u];u=-1;for(var f=Array(n+1);++u<n;)f[u]=e[u];return f[n]=r(a),o(t,this,f)}}var o=r(40),i=Math.max;t.exports=e},function(t,n,r){var e=r(109),o=r(147),i=o(e);t.exports=i},function(t,n){function r(t){if(null!=t){try{return o.call(t)}catch(t){}try{return t+""}catch(t){}}return""}var e=Function.prototype,o=e.toString;t.exports=r},function(t,n,r){function e(t,n){return null!=t&&i(t,n,o)}var o=r(94),i=r(70);t.exports=e},function(t,n,r){var e=r(99),o=r(111),i=r(143),u=i&&i.isTypedArray,c=u?o(u):e;t.exports=c},,function(t,n,r){function e(t,n){return(c(t)?o:u)(t,i(n,3))}var o=r(31),i=r(18),u=r(101),c=r(0);t.exports=e},function(t,n,r){var e=r(3),o=r(1),i=e(o,"Set");t.exports=i},function(t,n,r){function e(t){var n=-1,r=null==t?0:t.length;for(this.__data__=new o;++n<r;)this.add(t[n])}var o=r(24),i=r(145),u=r(146);e.prototype.add=e.prototype.push=i,e.prototype.has=u,t.exports=e},function(t,n,r){var e=r(1),o=e.Uint8Array;t.exports=o},function(t,n,r){function e(t,n){var r=u(t),e=!r&&i(t),s=!r&&!e&&c(t),l=!r&&!e&&!s&&f(t),v=r||e||s||l,h=v?o(t.length,String):[],x=h.length;for(var d in t)!n&&!p.call(t,d)||v&&("length"==d||s&&("offset"==d||"parent"==d)||l&&("buffer"==d||"byteLength"==d||"byteOffset"==d)||a(d,x))||h.push(d);return h}var o=r(110),i=r(28),u=r(0),c=r(35),a=r(16),f=r(55),s=Object.prototype,p=s.hasOwnProperty;t.exports=e},function(t,n,r){function e(t,n,r,u,c){var a=-1,f=t.length;for(r||(r=i),c||(c=[]);++a<f;){var s=t[a];n>0&&r(s)?n>1?e(s,n-1,r,u,c):o(c,s):u||(c[c.length]=s)}return c}var o=r(32),i=r(128);t.exports=e},function(t,n,r){function e(t,n){return t&&o(t,n,i)}var o=r(93),i=r(4);t.exports=e},function(t,n,r){function e(t,n,r){var e=n(t);return i(t)?e:o(e,r(t))}var o=r(32),i=r(0);t.exports=e},function(t,n,r){function e(t){if("string"==typeof t)return t;if(u(t))return i(t,e)+"";if(c(t))return s?s.call(t):"";var n=t+"";return"0"==n&&1/t==-a?"-0":n}var o=r(8),i=r(31),u=r(0),c=r(21),a=1/0,f=o?o.prototype:void 0,s=f?f.toString:void 0;t.exports=e},function(t,n){function r(t,n){return t.has(n)}t.exports=r},function(t,n,r){function e(t){return o(function(n,r){var e=-1,o=r.length,u=o>1?r[o-1]:void 0,c=o>2?r[2]:void 0;for(u=t.length>3&&"function"==typeof u?(o--,u):void 0,c&&i(r[0],r[1],c)&&(u=o<3?void 0:u,o=1),n=Object(n);++e<o;){var a=r[e];a&&t(n,a,e,u)}return n})}var o=r(44),i=r(71);t.exports=e},function(t,n,r){function e(t){return o(t,u,i)}var o=r(64),i=r(48),u=r(4);t.exports=e},function(t,n,r){var e=r(86),o=r(23),i=r(88),u=r(58),c=r(89),a=r(5),f=r(53),s="[object Map]",p="[object Promise]",l="[object Set]",v="[object WeakMap]",h="[object DataView]",x=f(e),d=f(o),y=f(i),b=f(u),_=f(c),g=a;(e&&g(new e(new ArrayBuffer(1)))!=h||o&&g(new o)!=s||i&&g(i.resolve())!=p||u&&g(new u)!=l||c&&g(new c)!=v)&&(g=function(t){var n=a(t),r="[object Object]"==n?t.constructor:void 0,e=r?f(r):"";if(e)switch(e){case x:return h;case d:return s;case y:return p;case b:return l;case _:return v}return n}),t.exports=g},function(t,n,r){function e(t,n,r){n=o(n,t);for(var e=-1,s=n.length,p=!1;++e<s;){var l=f(n[e]);if(!(p=null!=t&&r(t,l)))break;t=t[l]}return p||++e!=s?p:!!(s=null==t?0:t.length)&&a(s)&&c(l,s)&&(u(t)||i(t))}var o=r(14),i=r(28),u=r(0),c=r(16),a=r(29),f=r(9);t.exports=e},function(t,n,r){function e(t,n,r){if(!c(r))return!1;var e=typeof n;return!!("number"==e?i(r)&&u(n,r.length):"string"==e&&n in r)&&o(r[n],t)}var o=r(10),i=r(6),u=r(16),c=r(2);t.exports=e},function(t,n){function r(t){var n=-1,r=Array(t.size);return t.forEach(function(t,e){r[++n]=[e,t]}),r}t.exports=r},function(t,n){function r(t,n){return function(r){return t(n(r))}}t.exports=r},function(t,n){function r(t){return function(){return t}}t.exports=r},function(t,n){function r(){return[]}t.exports=r},,,,,function(t,n,r){function e(t,n){return(c(t)?o:i)(t,u(n,3))}var o=r(41),i=r(92),u=r(18),c=r(0);t.exports=e},function(t,n){function r(t){return t&&t.length?t[0]:void 0}t.exports=r},function(t,n,r){var e=r(104),o=r(118),i=o(function(t,n){return null==t?{}:e(t,n)});t.exports=i},,function(t,n,r){"use strict";function e(t,n){if(t.length<=n)return t;var r=t.split(""),e=t.length-n+y.length,o=t.lastIndexOf(".")>t.length-e-b,i=o?t.lastIndexOf("."):t.length-1,u=i-e-b;return r.splice(u,e,y),r.join("")}function o(t){var n=t.fileOutput||t.file_output;return p(n.image,function(t){return t.url.replace(/^(.*[\/])/,"")})}function i(t){var n=t.fileOutput||t.file_output,r=d(n.video,{format:"mp4"});return p(r,function(t){return h(t,["width","height","quality","url"])})}function u(t,n){var r=t.fileInput||t.file_input,u=t.fileOutput||t.file_output,c=e(t.title,O),a=x(u.image),f=h(a,["width","height","url"]);f.type="Image",f.uri=f.url.replace(/^(.*[\/])/,""),delete f.url,f.description=n.path?n.path:void 0;var s={type:"WixVideo",title:c,videoId:t.id||t.file_name,duration:+(r.duration/1e3).toFixed(2),posterImageRef:f,generatedPosters:o(t),qualities:i(t),artist:{name:t.vendor||"",id:t.reference||""},hasAudio:-1!==x(u.video).audio_bitrate};return s.fps=v(x(u.video),"fps","").toString(),s}function c(t){var n=t.fileOutput||t.file_output,r=x(v(n,"storyboard"));return r&&l({quality:"storyboard"},h(r,["width","height","url"]))}function a(t,n){var r=u(t,n);return l(r,g)}function f(t,n,r){var e=u(t,n),o=c(t);return o&&e.qualities.push(o),_.assign(e,j,r)}function s(t,n){var r=e(t.title,O);return{type:"Image",uri:t.fileName,title:r,description:n.path,width:t.width,height:t.height,artist:{name:t.vendor||"",id:t.reference||""}}}var p=r(57),l=r(39),v=r(22),h=r(82),x=r(81),d=r(80),y="...",b=3,g={opacity:1,autoplay:!0,loop:!0,preload:"auto",mute:!0},j={opacity:1,autoplay:!1,loop:!1,preload:"none",mute:!1},O=100;t.exports={getVideoBackgroundObject:a,getMediaPlayerVideoProperties:f,getImageBackgroundObject:s,fixMediaTitleLength:e}},,function(t,n,r){var e=r(3),o=r(1),i=e(o,"DataView");t.exports=i},function(t,n,r){function e(t){var n=-1,r=null==t?0:t.length;for(this.clear();++n<r;){var e=t[n];this.set(e[0],e[1])}}var o=r(123),i=r(124),u=r(125),c=r(126),a=r(127);e.prototype.clear=o,e.prototype.delete=i,e.prototype.get=u,e.prototype.has=c,e.prototype.set=a,t.exports=e},function(t,n,r){var e=r(3),o=r(1),i=e(o,"Promise");t.exports=i},function(t,n,r){var e=r(3),o=r(1),i=e(o,"WeakMap");t.exports=i},,function(t,n){function r(t,n){for(var r=-1,e=null==t?0:t.length;++r<e;)if(n(t[r],r,t))return!0;return!1}t.exports=r},function(t,n,r){function e(t,n){var r=[];return o(t,function(t,e,o){n(t,e,o)&&r.push(t)}),r}var o=r(33);t.exports=e},function(t,n,r){var e=r(115),o=e();t.exports=o},function(t,n){function r(t,n){return null!=t&&n in Object(t)}t.exports=r},function(t,n,r){function e(t){return i(t)&&o(t)==u}var o=r(5),i=r(7),u="[object Arguments]";t.exports=e},function(t,n,r){function e(t,n,r,e,d,b){var _=f(t),g=f(n),j=_?h:a(t),O=g?h:a(n);j=j==v?x:j,O=O==v?x:O;var w=j==x,m=O==x,A=j==O;if(A&&s(t)){if(!s(n))return!1;_=!0,w=!1}if(A&&!w)return b||(b=new o),_||p(t)?i(t,n,r,e,d,b):u(t,n,j,r,e,d,b);if(!(r&l)){var P=w&&y.call(t,"__wrapped__"),z=m&&y.call(n,"__wrapped__");if(P||z){var S=P?t.value():t,k=z?n.value():n;return b||(b=new o),d(S,k,r,e,b)}}return!!A&&(b||(b=new o),c(t,n,r,e,d,b))}var o=r(30),i=r(46),u=r(116),c=r(117),a=r(69),f=r(0),s=r(35),p=r(55),l=1,v="[object Arguments]",h="[object Array]",x="[object Object]",d=Object.prototype,y=d.hasOwnProperty;t.exports=e},function(t,n,r){function e(t,n,r,e){var a=r.length,f=a,s=!e;if(null==t)return!f;for(t=Object(t);a--;){var p=r[a];if(s&&p[2]?p[1]!==t[p[0]]:!(p[0]in t))return!1}for(;++a<f;){p=r[a];var l=p[0],v=t[l],h=p[1];if(s&&p[2]){if(void 0===v&&!(l in t))return!1}else{var x=new o;if(e)var d=e(v,h,l,t,n,x);if(!(void 0===d?i(h,v,u|c,e,x):d))return!1}}return!0}var o=r(30),i=r(43),u=1,c=2;t.exports=e},function(t,n,r){function e(t){return!(!u(t)||i(t))&&(o(t)?h:f).test(c(t))}var o=r(36),i=r(130),u=r(2),c=r(53),a=/[\\^$.*+?()[\]{}|]/g,f=/^\[object .+?Constructor\]$/,s=Function.prototype,p=Object.prototype,l=s.toString,v=p.hasOwnProperty,h=RegExp("^"+l.call(v).replace(a,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=e},function(t,n,r){function e(t){return u(t)&&i(t.length)&&!!c[o(t)]}var o=r(5),i=r(29),u=r(7),c={};c["[object Float32Array]"]=c["[object Float64Array]"]=c["[object Int8Array]"]=c["[object Int16Array]"]=c["[object Int32Array]"]=c["[object Uint8Array]"]=c["[object Uint8ClampedArray]"]=c["[object Uint16Array]"]=c["[object Uint32Array]"]=!0,c["[object Arguments]"]=c["[object Array]"]=c["[object ArrayBuffer]"]=c["[object Boolean]"]=c["[object DataView]"]=c["[object Date]"]=c["[object Error]"]=c["[object Function]"]=c["[object Map]"]=c["[object Number]"]=c["[object Object]"]=c["[object RegExp]"]=c["[object Set]"]=c["[object String]"]=c["[object WeakMap]"]=!1,t.exports=e},function(t,n,r){function e(t){if(!o(t))return i(t);var n=[];for(var r in Object(t))c.call(t,r)&&"constructor"!=r&&n.push(r);return n}var o=r(27),i=r(142),u=Object.prototype,c=u.hasOwnProperty;t.exports=e},function(t,n,r){function e(t,n){var r=-1,e=i(t)?Array(t.length):[];return o(t,function(t,o,i){e[++r]=n(t,o,i)}),e}var o=r(33),i=r(6);t.exports=e},function(t,n,r){function e(t){var n=i(t);return 1==n.length&&n[0][2]?u(n[0][0],n[0][1]):function(r){return r===t||o(r,t,n)}}var o=r(97),i=r(119),u=r(50);t.exports=e},function(t,n,r){function e(t,n){return c(t)&&a(n)?f(s(t),n):function(r){var e=i(r,t);return void 0===e&&e===n?u(r,t):o(n,e,p|l)}}var o=r(43),i=r(22),u=r(54),c=r(26),a=r(49),f=r(50),s=r(9),p=1,l=2;t.exports=e},function(t,n,r){function e(t,n){return o(t,n,function(n,r){return i(t,r)})}var o=r(105),i=r(54);t.exports=e},function(t,n,r){function e(t,n,r){for(var e=-1,c=n.length,a={};++e<c;){var f=n[e],s=o(t,f);r(s,f)&&i(a,u(f,t),s)}return a}var o=r(25),i=r(108),u=r(14);t.exports=e},function(t,n){function r(t){return function(n){return null==n?void 0:n[t]}}t.exports=r},function(t,n,r){function e(t){return function(n){return o(n,t)}}var o=r(25);t.exports=e},function(t,n,r){function e(t,n,r,e){if(!c(t))return t;n=i(n,t);for(var f=-1,s=n.length,p=s-1,l=t;null!=l&&++f<s;){var v=a(n[f]),h=r;if(f!=p){var x=l[v];h=e?e(x,v,l):void 0,void 0===h&&(h=c(x)?x:u(n[f+1])?[]:{})}o(l,v,h),l=l[v]}return t}var o=r(12),i=r(14),u=r(16),c=r(2),a=r(9);t.exports=e},function(t,n,r){var e=r(74),o=r(45),i=r(20),u=o?function(t,n){return o(t,"toString",{configurable:!0,enumerable:!1,value:e(n),writable:!0})}:i;t.exports=u},function(t,n){function r(t,n){for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);return e}t.exports=r},function(t,n){function r(t){return function(n){return t(n)}}t.exports=r},,function(t,n,r){var e=r(1),o=e["__core-js_shared__"];t.exports=o},function(t,n,r){function e(t,n){return function(r,e){if(null==r)return r;if(!o(r))return t(r,e);for(var i=r.length,u=n?i:-1,c=Object(r);(n?u--:++u<i)&&!1!==e(c[u],u,c););return r}}var o=r(6);t.exports=e},function(t,n){function r(t){return function(n,r,e){for(var o=-1,i=Object(n),u=e(n),c=u.length;c--;){var a=u[t?c:++o];if(!1===r(i[a],a,i))break}return n}}t.exports=r},function(t,n,r){function e(t,n,r,e,o,w,A){switch(r){case O:if(t.byteLength!=n.byteLength||t.byteOffset!=n.byteOffset)return!1;t=t.buffer,n=n.buffer;case j:return!(t.byteLength!=n.byteLength||!w(new i(t),new i(n)));case l:case v:case d:return u(+t,+n);case h:return t.name==n.name&&t.message==n.message;case y:case _:return t==n+"";case x:var P=a;case b:var z=e&s;if(P||(P=f),t.size!=n.size&&!z)return!1;var S=A.get(t);if(S)return S==n;e|=p,A.set(t,n);var k=c(P(t),P(n),e,o,w,A);return A.delete(t),k;case g:if(m)return m.call(t)==m.call(n)}return!1}var o=r(8),i=r(60),u=r(10),c=r(46),a=r(72),f=r(34),s=1,p=2,l="[object Boolean]",v="[object Date]",h="[object Error]",x="[object Map]",d="[object Number]",y="[object RegExp]",b="[object Set]",_="[object String]",g="[object Symbol]",j="[object ArrayBuffer]",O="[object DataView]",w=o?o.prototype:void 0,m=w?w.valueOf:void 0;t.exports=e},function(t,n,r){function e(t,n,r,e,u,a){var f=r&i,s=o(t),p=s.length;if(p!=o(n).length&&!f)return!1;for(var l=p;l--;){var v=s[l];if(!(f?v in n:c.call(n,v)))return!1}var h=a.get(t);if(h&&a.get(n))return h==n;var x=!0;a.set(t,n),a.set(n,t);for(var d=f;++l<p;){v=s[l];var y=t[v],b=n[v];if(e)var _=f?e(b,y,v,n,t,a):e(y,b,v,t,n,a);if(!(void 0===_?y===b||u(y,b,r,e,a):_)){x=!1;break}d||(d="constructor"==v)}if(x&&!d){var g=t.constructor,j=n.constructor;g!=j&&"constructor"in t&&"constructor"in n&&!("function"==typeof g&&g instanceof g&&"function"==typeof j&&j instanceof j)&&(x=!1)}return a.delete(t),a.delete(n),x}var o=r(68),i=1,u=Object.prototype,c=u.hasOwnProperty;t.exports=e},function(t,n,r){function e(t){return u(i(t,void 0,o),t+"")}var o=r(154),i=r(51),u=r(52);t.exports=e},function(t,n,r){function e(t){for(var n=i(t),r=n.length;r--;){var e=n[r],u=t[e];n[r]=[e,u,o(u)]}return n}var o=r(49),i=r(4);t.exports=e},,function(t,n,r){function e(t){var n=u.call(t,a),r=t[a];try{t[a]=void 0;var e=!0}catch(t){}var o=c.call(t);return e&&(n?t[a]=r:delete t[a]),o}var o=r(8),i=Object.prototype,u=i.hasOwnProperty,c=i.toString,a=o?o.toStringTag:void 0;t.exports=e},function(t,n){function r(t,n){return null==t?void 0:t[n]}t.exports=r},function(t,n,r){function e(){this.__data__=o?o(null):{},this.size=0}var o=r(17);t.exports=e},function(t,n){function r(t){var n=this.has(t)&&delete this.__data__[t];return this.size-=n?1:0,n}t.exports=r},function(t,n,r){function e(t){var n=this.__data__;if(o){var r=n[t];return r===i?void 0:r}return c.call(n,t)?n[t]:void 0}var o=r(17),i="__lodash_hash_undefined__",u=Object.prototype,c=u.hasOwnProperty;t.exports=e},function(t,n,r){function e(t){var n=this.__data__;return o?void 0!==n[t]:u.call(n,t)}var o=r(17),i=Object.prototype,u=i.hasOwnProperty;t.exports=e},function(t,n,r){function e(t,n){var r=this.__data__;return this.size+=this.has(t)?0:1,r[t]=o&&void 0===n?i:n,this}var o=r(17),i="__lodash_hash_undefined__";t.exports=e},function(t,n,r){function e(t){return u(t)||i(t)||!!(c&&t&&t[c])}var o=r(8),i=r(28),u=r(0),c=o?o.isConcatSpreadable:void 0;t.exports=e},function(t,n){function r(t){var n=typeof t;return"string"==n||"number"==n||"symbol"==n||"boolean"==n?"__proto__"!==t:null===t}t.exports=r},function(t,n,r){function e(t){return!!i&&i in t}var o=r(113),i=function(){var t=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}();t.exports=e},function(t,n){function r(){this.__data__=[],this.size=0}t.exports=r},function(t,n,r){function e(t){var n=this.__data__,r=o(n,t);return!(r<0)&&(r==n.length-1?n.pop():u.call(n,r,1),--this.size,!0)}var o=r(13),i=Array.prototype,u=i.splice;t.exports=e},function(t,n,r){function e(t){var n=this.__data__,r=o(n,t);return r<0?void 0:n[r][1]}var o=r(13);t.exports=e},function(t,n,r){function e(t){return o(this.__data__,t)>-1}var o=r(13);t.exports=e},function(t,n,r){function e(t,n){var r=this.__data__,e=o(r,t);return e<0?(++this.size,r.push([t,n])):r[e][1]=n,this}var o=r(13);t.exports=e},function(t,n,r){function e(){this.size=0,this.__data__={hash:new o,map:new(u||i),string:new o}}var o=r(87),i=r(11),u=r(23);t.exports=e},function(t,n,r){function e(t){var n=o(this,t).delete(t);return this.size-=n?1:0,n}var o=r(15);t.exports=e},function(t,n,r){function e(t){return o(this,t).get(t)}var o=r(15);t.exports=e},function(t,n,r){function e(t){return o(this,t).has(t)}var o=r(15);t.exports=e},function(t,n,r){function e(t,n){var r=o(this,t),e=r.size;return r.set(t,n),this.size+=r.size==e?0:1,this}var o=r(15);t.exports=e},function(t,n,r){function e(t){var n=o(t,function(t){return r.size===i&&r.clear(),t}),r=n.cache;return n}var o=r(156),i=500;t.exports=e},function(t,n,r){var e=r(73),o=e(Object.keys,Object);t.exports=o},function(t,n,r){(function(t){var e=r(47),o="object"==typeof n&&n&&!n.nodeType&&n,i=o&&"object"==typeof t&&t&&!t.nodeType&&t,u=i&&i.exports===o,c=u&&e.process,a=function(){try{return c&&c.binding&&c.binding("util")}catch(t){}}();t.exports=a}).call(n,r(38)(t))},function(t,n){function r(t){return o.call(t)}var e=Object.prototype,o=e.toString;t.exports=r},function(t,n){function r(t){return this.__data__.set(t,e),this}var e="__lodash_hash_undefined__";t.exports=r},function(t,n){function r(t){return this.__data__.has(t)}t.exports=r},function(t,n){function r(t){var n=0,r=0;return function(){var u=i(),c=o-(u-r);if(r=u,c>0){if(++n>=e)return arguments[0]}else n=0;return t.apply(void 0,arguments)}}var e=800,o=16,i=Date.now;t.exports=r},function(t,n,r){function e(){this.__data__=new o,this.size=0}var o=r(11);t.exports=e},function(t,n){function r(t){var n=this.__data__,r=n.delete(t);return this.size=n.size,r}t.exports=r},function(t,n){function r(t){return this.__data__.get(t)}t.exports=r},function(t,n){function r(t){return this.__data__.has(t)}t.exports=r},function(t,n,r){function e(t,n){var r=this.__data__;if(r instanceof o){var e=r.__data__;if(!i||e.length<c-1)return e.push([t,n]),this.size=++r.size,this;r=this.__data__=new u(e)}return r.set(t,n),this.size=r.size,this}var o=r(11),i=r(23),u=r(24),c=200;t.exports=e},function(t,n,r){var e=r(141),o=/^\./,i=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,u=/\\(\\)?/g,c=e(function(t){var n=[];return o.test(t)&&n.push(""),t.replace(i,function(t,r,e,o){n.push(e?o.replace(u,"$1"):r||t)}),n});t.exports=c},function(t,n,r){function e(t){return(null==t?0:t.length)?o(t,1):[]}var o=r(62);t.exports=e},,function(t,n,r){function e(t,n){if("function"!=typeof t||null!=n&&"function"!=typeof n)throw new TypeError(i);var r=function(){var e=arguments,o=n?n.apply(this,e):e[0],i=r.cache;if(i.has(o))return i.get(o);var u=t.apply(this,e);return r.cache=i.set(o,u)||i,u};return r.cache=new(e.Cache||o),r}var o=r(24),i="Expected a function";e.Cache=o,t.exports=e},function(t,n,r){function e(t){return u(t)?o(c(t)):i(t)}var o=r(106),i=r(107),u=r(26),c=r(9);t.exports=e},function(t,n){function r(){return!1}t.exports=r},function(t,n){var r;r=function(){return this}();try{r=r||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(r=window)}t.exports=r}])});
//# sourceMappingURL=backgroundUtils.js.map

/***/ }),
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

/**
 * @private
 * @param name
 * @returns {{}}
 */
function findFilter(filters, name) {
    var filter = _.find(filters.templates, { name: name });
    return filter || {};
}

/**
 * Get an filter (SVG filter) string from filters list
 * @param {string} id
 * @param {string} name
 * @param {object} [overrides]
 * @returns {string} a compiled filter template
 */
function getFilter(filters, id, name, overrides) {
    var filter = findFilter(filters, name);
    var params = {
        id: id,
        content: filter.template(_.assign({}, filter.defaults, overrides || {}))
    };
    return filters.masterTemplate(params);
}

/**
 * checks if filter key exists
 * @param effectName
 * @returns {boolean}
 */
function isFilterExists(filters, effectName) {
    return !_.isEmpty(_.find(filters.templates, { name: effectName }));
}

/**
 * Get the list of supported filter names
 * @returns {Array}
 */
function getFilterNames(filters) {
    return _.map(filters.templates, 'name');
}

/**
 * Get the defaults (== the dynamic values) of a filter
 * @param {string} name
 * @returns {{}}
 */
function getFilterDefaults(filters, name) {
    return _.clone(findFilter(filters, name).defaults || {});
}

module.exports = {
    getFilter: getFilter,
    getFilterNames: getFilterNames,
    getFilterDefaults: getFilterDefaults,
    isFilterExists: isFilterExists
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable prefer-template */


function getSepia(amount) {
    return 0.393 + 0.607 * (1 - amount) + ' ' + (0.769 - 0.769 * (1 - amount)) + ' ' + (0.189 - 0.189 * (1 - amount)) + ' 0 0 ' + (0.349 - 0.349 * (1 - amount)) + ' ' + (0.686 + 0.314 * (1 - amount)) + ' ' + (0.168 - 0.168 * (1 - amount)) + ' 0 0 ' + (0.272 - 0.272 * (1 - amount)) + ' ' + (0.534 - 0.534 * (1 - amount)) + ' ' + (0.131 + 0.869 * (1 - amount)) + ' 0 0 ' + '0 0 0 1 0';
}

function getContrast(amount) {
    return '<feFuncR type="linear" slope="' + amount + '" intercept="' + Math.round((-0.5 * amount + 0.5) * 100) / 100 + '"/>' + '<feFuncG type="linear" slope="' + amount + '" intercept="' + Math.round((-0.5 * amount + 0.5) * 100) / 100 + '"/>' + '<feFuncB type="linear" slope="' + amount + '" intercept="' + Math.round((-0.5 * amount + 0.5) * 100) / 100 + '"/>';
}

function getBrightness(amount) {
    return '<feFuncR type="linear" slope="' + amount + '" />' + '<feFuncG type="linear" slope="' + amount + '" />' + '<feFuncB type="linear" slope="' + amount + '" />';
}

/**
 * @param {{r: number, g: number, b: number}} color
 * @returns {string}
 */
function getTint(color) {
    return 1 - color.r / 255 + ' 0 0 0 ' + color.r / 255 + ' ' + (1 - color.g / 255) + ' 0 0 0 ' + color.g / 255 + ' ' + (1 - color.b / 255) + ' 0 0 0 ' + color.b / 255 + ' ' + '0 0 0 1 0';
}

/**
 * lighten darken by color
 * @param {{r: number, g: number, b: number}}  whiteParams
 * @param {{r: number, g: number, b: number}}  blackParams
 * @returns {string}
 */
function getLumaMatrix(whiteParams, blackParams) {
    return whiteParams.r + ' 0 0 0 ' + blackParams.r + ' ' + whiteParams.g + ' 1 0 0 ' + blackParams.g + ' ' + whiteParams.b + ' 0 1 0 ' + blackParams.b + ' ' + '0 0 0 1 0';
}

/**
 * @param {{r: number, g: number, b: number}} color
 * @returns {string}
 */
function getColor(color) {
    return '0 0 0 0 ' + color.r / 255 + ' ' + '0 0 0 0 ' + color.g / 255 + ' ' + '0 0 0 0 ' + color.b / 255 + ' ' + '0 0 0 1 0';
}

/**
 * colors the source to 2 colors , input should be gray scale
 * @param {{r: number, g: number, b: number}} whiteColor
 * @param {{r: number, g: number, b: number}} blackColor
 * @returns {string} color matrix
 */
function getDoutone(whiteColor, blackColor) {
    var r_diff = whiteColor.r / 255 - blackColor.r / 255;
    var g_diff = whiteColor.g / 255 - blackColor.g / 255;
    var b_diff = whiteColor.b / 255 - blackColor.b / 255;

    return r_diff + ' 0 0 0 ' + blackColor.r / 255 + ' ' + g_diff + ' 0 0 0 ' + blackColor.g / 255 + ' ' + b_diff + ' 0 0 0 ' + blackColor.b / 255 + ' ' + '0 0 0 1 0';
}

function getAlpha(amount) {
    return '<feFuncA type="linear" slope="' + amount + '" />';
}

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

module.exports = { hexToRgb: hexToRgb, getAlpha: getAlpha, getDoutone: getDoutone, getColor: getColor, getTint: getTint, getLumaMatrix: getLumaMatrix, getBrightness: getBrightness, getSepia: getSepia, getContrast: getContrast };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable prefer-template */


var _ = __webpack_require__(0);

var _require = __webpack_require__(73),
    hexToRgb = _require.hexToRgb,
    getAlpha = _require.getAlpha,
    getDoutone = _require.getDoutone,
    getColor = _require.getColor,
    getTint = _require.getTint,
    getLumaMatrix = _require.getLumaMatrix,
    getBrightness = _require.getBrightness,
    getSepia = _require.getSepia,
    getContrast = _require.getContrast;

var filterTemplates = {
    masterTemplate: _.template('<filter id="${id}" color-interpolation="sRGB" color-interpolation-filters="sRGB"> \
            <feComponentTransfer result="srcRGB"/>${content}<feComponentTransfer/></filter>'),
    templates: [{
        name: 'normal',
        template: _.template('<feColorMatrix in="SourceGraphic" />') //does nothing, but we have to have content for nothing to happen...
    }, {
        name: 'ink',
        defaults: {
            contrast: 1.5,
            brightness: 1.1,
            sepia: 0.3,
            saturate: 0
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var sepia = getSepia(params.sepia);
            var saturate = params.saturate;

            return '<feColorMatrix type="matrix" values="' + sepia + '"/> \n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' />';
        }
    }, {
        name: 'kennedy',
        defaults: {
            saturate: 0,
            contrast: 1.1,
            brightness: 0.9
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;

            return '<feColorMatrix type="saturate" values=' + saturate + ' />\n<feComponentTransfer >' + contrast + '</feComponentTransfer>\n<feComponentTransfer >' + brightness + '</feComponentTransfer>';
        }
    }, {
        name: 'feathered',
        defaults: {
            contrast: 0.85,
            brightness: 0.9,
            color: '#171212',
            saturate: 0.2
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var tint = getTint(hexToRgb(params.color));

            return '<feColorMatrix type="saturate" values=' + saturate + ' />\n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feColorMatrix type="matrix" values="' + tint + '"/>';
        }
    }, {
        name: 'blur',
        defaults: {
            blur: 2
        },
        template: _.template('<feGaussianBlur in="SourceGraphic" stdDeviation=${blur} />')
    }, {
        name: 'whistler',
        defaults: {
            blur: 1.8,
            alpha1: 0.6,
            alpha2: 0.4,
            color: '#ffffff',
            contrast: 0.9,
            brightness: 1.1,
            saturate: 0.6
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));
            var blur = params.blur;
            var alpha1 = getAlpha(params.alpha1);
            var alpha2 = getAlpha(params.alpha2);

            return '<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color" />\n<feComponentTransfer  in="color" result="flood_alpha">' + alpha2 + '</feComponentTransfer>\n<feGaussianBlur in="srcRGB" stdDeviation=' + blur + ' />\n<feComponentTransfer  result="blur_alpha">' + alpha1 + '</feComponentTransfer>\n<feBlend  in="blur_alpha" in2="srcRGB" mode="normal" result="source_blur" />\n<feBlend  in2="source_blur" in="flood_alpha" mode="overlay" />\n<feComponentTransfer >' + brightness + '</feComponentTransfer>\n<feComponentTransfer  result="contrast">' + contrast + '</feComponentTransfer>\n<feColorMatrix  type="saturate" values=' + saturate + ' />';
        }
    }, {
        name: '3d',
        defaults: {
            color1: '#00ffff',
            color2: '#ff0000',
            offset_x: '3',
            offset_y: '0'
        },
        template: function template(params) {
            var color1 = getColor(hexToRgb(params.color1));
            var color2 = getColor(hexToRgb(params.color2));
            var offset_x = params.offset_x;
            var offset_y = params.offset_y;

            return '<feColorMatrix in="srcRGB" type="matrix" values="' + color1 + '" result="color1" /> \n<feBlend  in="color1" in2="srcRGB" mode="lighten" result="image_color1"/> \n<feOffset dx=' + -offset_x + ' dy=' + offset_y + ' in="image_color1" result="image_color1_offset"/> \n<feColorMatrix in="srcRGB" type="matrix" values="' + color2 + '" result="color2" /> \n<feBlend  in="color2" in2="srcRGB" mode="lighten" result="image_color2"/> \n<feOffset dx=' + offset_x + ' dy=' + offset_y + ' in="image_color2" result="image_color2_offset"/> \n<feBlend  in2="image_color2_offset" in="image_color1_offset" mode="darken" />';
        }
    }, {
        name: 'blueray',
        defaults: {
            color: '#1b00ff',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/> \n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color1" /> \n<feBlend  in="color1" in2="grayscale" mode="multiply" />';
        }
    }, {
        name: 'lighten',
        defaults: {
            color: '#ffffff',
            alpha: 0.46
        },
        template: function template(params) {
            var color = getColor(hexToRgb(params.color));
            var alpha = getAlpha(params.alpha);

            return '<feColorMatrix in="srcRGB" type="matrix" values="' + color + '" result="color" /> \n<feComponentTransfer in="color" result="color_alpha" >' + alpha + '</feComponentTransfer> \n<feComposite in2="srcRGB" in="color_alpha" operator="over"/>';
        }
    }, {
        name: 'darken',
        defaults: {
            brightness: 0.4
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);

            return '<feComponentTransfer result="brightness">' + brightness + '</feComponentTransfer>\n<feBlend  in="brightness" in2="SourceGraphic" mode="darken" />';
        }
    }, {
        name: 'pinkrinse',
        defaults: {
            saturate: 0,
            color: '#9a1a77'
        },
        template: function template(params) {
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color" />\n<feBlend  in="grayscale" in2="color" mode="multiply" />';
        }
    }, {
        name: 'redrum',
        defaults: {
            saturate: 0,
            contrast: 0.75,
            brightness: 1.2,
            color: '#f26552'
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer> \n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color" />\n<feBlend  in="grayscale" in2="color" mode="multiply" />';
        }
    }, {
        name: 'greenwash',
        defaults: {
            saturate: 0,
            color: '#1c9784'
        },
        template: function template(params) {
            var color = getColor(hexToRgb(params.color));
            var saturate = params.saturate;

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color1" /> \n<feBlend  in="grayscale" in2="color1" mode="multiply" />';
        }
    }, {
        name: 'yellowstreak',
        defaults: {
            saturate: 0,
            color: '#ffd200',
            contrast: 2,
            brightness: 1.1
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color1" />\n<feBlend  in="grayscale" in2="color1" mode="multiply" />';
        }
    }, {
        name: 'neonsky',
        defaults: {
            saturate: 0,
            doutoneBlackColor: '#800033',
            doutoneWhiteColor: '#fff200',
            doutoneLumaWhiteColor: { r: 1.2, g: 0, b: 0 },
            doutoneLumaBlackColor: { r: 0, g: -0.1, b: 0 },
            contrast: 0.8
        },
        template: function template(params) {
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));
            var luma = getLumaMatrix(params.doutoneLumaWhiteColor, params.doutoneLumaBlackColor);
            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/> \n<feColorMatrix type="matrix" values="' + doutone + '" />\n<feColorMatrix type="matrix" values="' + luma + '" />';
        }
    }, {
        name: 'seaweed',
        defaults: {
            doutoneBlackColor: '#0b00e9',
            doutoneWhiteColor: '#00d980',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'soledad',
        defaults: {
            brightness: 1.1,
            contrast: 0.9,
            saturate: 0.8,
            color1: '#fce8d3',
            color2: '#fc9f1a',
            alpha1: 0.15,
            alpha2: 0.23
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color1 = getColor(hexToRgb(params.color1));
            var color2 = getColor(hexToRgb(params.color2));
            var alpha1 = getAlpha(params.alpha1);
            var alpha2 = getAlpha(params.alpha2);

            return '<feComponentTransfer  result="brightness">' + brightness + '</feComponentTransfer>\n<feComponentTransfer  in="brightness" result="contrast">' + contrast + '</feComponentTransfer>\n<feColorMatrix  type="saturate" in="contrast" values=' + saturate + ' result="saturate"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color1 + '" result="color1" />\n<feComponentTransfer  in="color1" result="color_alpha" >' + alpha1 + '</feComponentTransfer>\n<feBlend  in="color_alpha" in2="saturate" mode="multiply" result="source" />\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color2 + '" result="color2" />\n<feComponentTransfer  in="color2" result="color_alpha2" >' + alpha2 + '</feComponentTransfer>\n<feBlend  in="color_alpha2" in2="source" mode="multiply" />';
        }
    }, {
        name: 'sangria',
        defaults: {
            brightness: 0.95,
            contrast: 1.35,
            saturate: 0.5,
            color: '#c712e2',
            alpha: 0.08
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color1 = getColor(hexToRgb(params.color));
            var alpha = getAlpha(params.alpha);

            return '<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' result="saturate"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color1 + '" result="color1" />\n<feComponentTransfer in="color1" result="color_alpha" >' + alpha + '</feComponentTransfer>\n<feBlend  in="color_alpha" in2="saturate" mode="multiply" result="source" />';
        }

    },
    // new filters Jira WEED-1038
    {
        name: 'malibu',
        defaults: {
            saturate: 0,
            doutoneBlackColor: '#0045d6',
            doutoneWhiteColor: '#ffdbc0',
            contrast: 0.8
        },
        template: function template(params) {
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/> \n <feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'candyfloss',
        defaults: {
            saturate: 0,
            doutoneBlackColor: '#ff0000',
            doutoneWhiteColor: '#ff9bff',
            contrast: 0.8
        },
        template: function template(params) {
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/> \n <feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'elmo',
        defaults: {
            saturate: 0,
            doutoneBlackColor: '#ff0000',
            doutoneWhiteColor: '#cadccc',
            contrast: 0.8
        },
        template: function template(params) {
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/> \n <feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'unicorn',
        defaults: {
            saturate: 0,
            doutoneBlackColor: '#409ca5',
            doutoneWhiteColor: '#dfb1bd',
            contrast: 0.8
        },
        template: function template(params) {
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/> \n <feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'kerouac',
        defaults: {
            doutoneBlackColor: '#37312e',
            doutoneWhiteColor: '#b5a8a2',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'koolaid',
        defaults: {
            doutoneBlackColor: '#5f00ad',
            doutoneWhiteColor: '#fdcec1',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'hydra',
        defaults: {
            doutoneBlackColor: '#f72b3e',
            doutoneWhiteColor: '#ffeced',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'pixie',
        defaults: {
            doutoneBlackColor: '#85d3de',
            doutoneWhiteColor: '#ffe1d5',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'nightrain',
        defaults: {
            doutoneBlackColor: '#2f3c6d',
            doutoneWhiteColor: '#8e96b5',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'bauhaus',
        defaults: {
            doutoneBlackColor: '#002787',
            doutoneWhiteColor: '#e8e8e8',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'neptune',
        defaults: {
            doutoneBlackColor: '#0a7eff',
            doutoneWhiteColor: '#e5defa',
            saturate: 0
        },
        template: function template(params) {
            var saturate = params.saturate;
            var doutone = getDoutone(hexToRgb(params.doutoneWhiteColor), hexToRgb(params.doutoneBlackColor));

            return '<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix type="matrix" values="' + doutone + '" />';
        }
    }, {
        name: 'orca',
        defaults: {
            contrast: 0.85,
            brightness: 0.9,
            color: '#2b524c',
            saturate: 0.2
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var tint = getTint(hexToRgb(params.color));

            return '<feColorMatrix type="saturate" values=' + saturate + ' />\n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feColorMatrix type="matrix" values="' + tint + '"/>';
        }
    }, {
        name: 'manhattan',
        defaults: {
            contrast: 0.85,
            brightness: 0.9,
            color: '#211c0f',
            saturate: 0.2
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var tint = getTint(hexToRgb(params.color));

            return '<feColorMatrix type="saturate" values=' + saturate + ' />\n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feColorMatrix type="matrix" values="' + tint + '"/>';
        }
    }, {
        name: 'goldie',
        defaults: {
            contrast: 0.85,
            brightness: 0.9,
            color: '#a6966e',
            saturate: 0.2
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var tint = getTint(hexToRgb(params.color));

            return '<feColorMatrix type="saturate" values=' + saturate + ' />\n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feColorMatrix type="matrix" values="' + tint + '"/>';
        }
    }, {
        name: 'flamingo',
        defaults: {
            contrast: 0.85,
            brightness: 0.9,
            color: '#ff4283',
            saturate: 0.2
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var tint = getTint(hexToRgb(params.color));

            return '<feColorMatrix type="saturate" values=' + saturate + ' />\n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feColorMatrix type="matrix" values="' + tint + '"/>';
        }
    }, {
        name: 'faded',
        defaults: {
            contrast: 0.85,
            brightness: 0.9,
            color: '#dcdddc',
            saturate: 0.2
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var tint = getTint(hexToRgb(params.color));

            return '<feColorMatrix type="saturate" values=' + saturate + ' />\n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feColorMatrix type="matrix" values="' + tint + '"/>';
        }
    }, {
        name: 'gotham',
        defaults: {
            brightness: 0.95,
            contrast: 1.35,
            saturate: 0.5,
            color: '#93676f',
            alpha: 0.08
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color1 = getColor(hexToRgb(params.color));
            var alpha = getAlpha(params.alpha);

            return '<feComponentTransfer>' + brightness + '</feComponentTransfer>\n<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feColorMatrix type="saturate" values=' + saturate + ' result="saturate"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color1 + '" result="color1" />\n<feComponentTransfer in="color1" result="color_alpha" >' + alpha + '</feComponentTransfer>\n<feBlend  in="color_alpha" in2="saturate" mode="multiply" result="source" />';
        }

    }, {
        name: 'hulk',
        defaults: {
            saturate: 0,
            contrast: 0.75,
            brightness: 1.2,
            color: '#b5c900'
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer> \n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color" />\n<feBlend  in="grayscale" in2="color" mode="multiply" />';
        }
    }, {
        name: 'midnight',
        defaults: {
            saturate: 0,
            contrast: 0.75,
            brightness: 1.2,
            color: '#00254b'
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer> \n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color" />\n<feBlend  in="grayscale" in2="color" mode="multiply" />';
        }
    }, {
        name: 'lucille',
        defaults: {
            saturate: 0,
            contrast: 0.75,
            brightness: 1.2,
            color: '#d60000'
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer> \n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color" />\n<feBlend  in="grayscale" in2="color" mode="multiply" />';
        }
    }, {
        name: 'organic',
        defaults: {
            saturate: 0,
            contrast: 0.75,
            brightness: 1.2,
            color: '#debda5'
        },
        template: function template(params) {
            var brightness = getBrightness(params.brightness);
            var contrast = getContrast(params.contrast);
            var saturate = params.saturate;
            var color = getColor(hexToRgb(params.color));

            return '<feComponentTransfer>' + contrast + '</feComponentTransfer>\n<feComponentTransfer>' + brightness + '</feComponentTransfer> \n<feColorMatrix type="saturate" values=' + saturate + ' result="grayscale"/>\n<feColorMatrix in="SourceGraphic" type="matrix" values="' + color + '" result="color" />\n<feBlend  in="grayscale" in2="color" mode="multiply" />';
        }
    }]

    /**
     * https://docs.webplatform.org/wiki/svg/tutorials/smarter_svg_filters
     * @type {{masterTemplate:function, templates:[]}}}
     */
};module.exports = filterTemplates;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = typeof window !== 'undefined' && window;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    UPLOADED_FONT_PREFIX: 'wf_',
    LONG_UPLOADED_FONT_PREFIX: 'wfont_'
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint quotes:0*/


var fonts = {
    "anton": {
        "displayName": "Anton",
        "fontFamily": "anton",
        "cdnName": "Anton",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 0
    },
    "arial": {
        "displayName": "Arial",
        "fontFamily": "arial",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "cyrillic", "hebrew", "arabic"],
        "permissions": "all",
        "fallbacks": "ｍｓ ｐゴシック,ms pgothic,돋움,dotum,helvetica",
        "spriteIndex": 2
    },
    "courier new": {
        "displayName": "Courier New",
        "fontFamily": "courier new",
        "cdnName": "",
        "genericFamily": "monospace",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "cyrillic", "hebrew", "arabic"],
        "permissions": "all",
        "fallbacks": "courier-ps-w01,courier-ps-w02,courier-ps-w10",
        "spriteIndex": 7
    },
    "arial black": {
        "displayName": "Arial Black",
        "fontFamily": "arial black",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "arial-w01-black,arial-w02-black,arial-w10 black",
        "spriteIndex": 12
    },
    "basic": {
        "displayName": "Basic",
        "fontFamily": "basic",
        "cdnName": "Basic",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 15
    },
    "caudex": {
        "displayName": "Caudex",
        "fontFamily": "caudex",
        "cdnName": "Caudex",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 17
    },
    "chelsea market": {
        "displayName": "Chelsea Market",
        "fontFamily": "chelsea market",
        "cdnName": "Chelsea+Market",
        "genericFamily": "fantasy",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 19
    },
    "comic sans ms": {
        "displayName": "Comic Sans MS",
        "fontFamily": "comic sans ms",
        "cdnName": "",
        "genericFamily": "cursive",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "comic-sans-w01-regular,comic-sans-w02-regular,comic-sans-w10-regular",
        "spriteIndex": 20
    },
    "corben": {
        "displayName": "Corben",
        "fontFamily": "corben",
        "cdnName": "Corben",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 23
    },
    "eb garamond": {
        "displayName": "EB Garamond",
        "fontFamily": "eb garamond",
        "cdnName": "EB+Garamond",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 24
    },
    "enriqueta": {
        "displayName": "Enriqueta",
        "fontFamily": "enriqueta",
        "cdnName": "Enriqueta",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 27
    },
    "forum": {
        "displayName": "Forum",
        "fontFamily": "forum",
        "cdnName": "Forum",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 29
    },
    "fredericka the great": {
        "displayName": "Fredericka the Great",
        "fontFamily": "fredericka the great",
        "cdnName": "Fredericka+the+Great",
        "genericFamily": "fantasy",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 32
    },
    "georgia": {
        "displayName": "Georgia",
        "fontFamily": "georgia",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "palatino,book antiqua,palatino linotype",
        "spriteIndex": 33
    },
    "impact": {
        "displayName": "Impact",
        "fontFamily": "impact",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "impact-w01-2010,impact-w02-2010,impact-w10-2010",
        "spriteIndex": 36
    },
    "jockey one": {
        "displayName": "Jockey One",
        "fontFamily": "jockey one",
        "cdnName": "Jockey+One",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 39
    },
    "josefin slab": {
        "displayName": "Josefin Slab",
        "fontFamily": "josefin slab",
        "cdnName": "Josefin+Slab",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 41
    },
    "jura": {
        "displayName": "Jura",
        "fontFamily": "jura",
        "cdnName": "Jura",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 42
    },
    "kelly slab": {
        "displayName": "Kelly Slab",
        "fontFamily": "kelly slab",
        "cdnName": "Kelly+Slab",
        "genericFamily": "fantasy",
        "provider": "google",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 45
    },
    "lucida console": {
        "displayName": "Lucida Console",
        "fontFamily": "lucida console",
        "cdnName": "",
        "genericFamily": "monospace",
        "provider": "system",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "lucida-console-w01",
        "spriteIndex": 48
    },
    "lucida sans unicode": {
        "displayName": "Lucida Sans Unicode",
        "fontFamily": "lucida sans unicode",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "lucida grande",
        "spriteIndex": 50
    },
    "marck script": {
        "displayName": "Marck Script",
        "fontFamily": "marck script",
        "cdnName": "Marck+Script",
        "genericFamily": "cursive",
        "provider": "google",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 51
    },
    "lobster": {
        "displayName": "Lobster",
        "fontFamily": "lobster",
        "cdnName": "Lobster",
        "genericFamily": "cursive",
        "provider": "google",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 54
    },
    "mr de haviland": {
        "displayName": "Mr De Haviland",
        "fontFamily": "mr de haviland",
        "cdnName": "Mr+De+Haviland",
        "genericFamily": "cursive",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 57
    },
    "niconne": {
        "displayName": "Niconne",
        "fontFamily": "niconne",
        "cdnName": "Niconne",
        "genericFamily": "fantasy",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 58
    },
    "noticia text": {
        "displayName": "Noticia Text",
        "fontFamily": "noticia text",
        "cdnName": "Noticia+Text",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 59
    },
    "open sans": {
        "displayName": "Open Sans",
        "fontFamily": "open sans",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 61
    },
    "overlock": {
        "displayName": "Overlock",
        "fontFamily": "overlock",
        "cdnName": "Overlock",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 64
    },
    "palatino linotype": {
        "displayName": "Palatino Linotype",
        "fontFamily": "palatino linotype",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "system",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 65
    },
    "patrick hand": {
        "displayName": "Patrick Hand",
        "fontFamily": "patrick hand",
        "cdnName": "Patrick+Hand",
        "genericFamily": "cursive",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 67
    },
    "play": {
        "displayName": "Play",
        "fontFamily": "play",
        "cdnName": "Play",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 69
    },
    "sarina": {
        "displayName": "Sarina",
        "fontFamily": "sarina",
        "cdnName": "Sarina",
        "genericFamily": "cursive",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 72
    },
    "signika": {
        "displayName": "Signika",
        "fontFamily": "signika",
        "cdnName": "Signika",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 74
    },
    "spinnaker": {
        "displayName": "Spinnaker",
        "fontFamily": "spinnaker",
        "cdnName": "Spinnaker",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 76
    },
    "tahoma": {
        "displayName": "Tahoma",
        "fontFamily": "tahoma",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "hebrew", "arabic"],
        "permissions": "all",
        "fallbacks": "tahoma-w01-regular,tahoma-w02-regular,tahoma-w10-regular,tahoma-w15--regular,tahoma-w99-regular",
        "spriteIndex": 77
    },
    "times new roman": {
        "displayName": "Times New Roman",
        "fontFamily": "times new roman",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "cyrillic", "hebrew", "arabic"],
        "permissions": "all",
        "fallbacks": "times",
        "spriteIndex": 81
    },
    "verdana": {
        "displayName": "Verdana",
        "fontFamily": "verdana",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "geneva",
        "spriteIndex": 86
    },
    "helveticaneuew01-45ligh": {
        "displayName": "Helvetica 45",
        "fontFamily": "helveticaneuew01-45ligh",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 89
    },
    "helveticaneuew01-65medi": {
        "displayName": "Helvetica 65",
        "fontFamily": "helveticaneuew01-65medi",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 90
    },
    "helveticaneuew01-75bold": {
        "displayName": "Helvetica 75",
        "fontFamily": "helveticaneuew01-75bold",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 91
    },
    "helveticaneuew01-95blac": {
        "displayName": "Helvetica 95",
        "fontFamily": "helveticaneuew01-95blac",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 92
    },
    "helveticaneuew01-thin": {
        "displayName": "Helvetica 35",
        "fontFamily": "helveticaneuew01-thin",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 93
    },
    "helveticaneuew01-ultlt": {
        "displayName": "Helvetica 25",
        "fontFamily": "helveticaneuew01-ultlt",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 94
    },
    "helveticaneuew02-45ligh": {
        "displayName": "Helvetica 45 Latin Ext",
        "fontFamily": "helveticaneuew02-45ligh",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin-ext"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 95
    },
    "helveticaneuew02-65medi": {
        "displayName": "Helvetica 65 Latin Ext",
        "fontFamily": "helveticaneuew02-65medi",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin-ext"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 96
    },
    "helveticaneuew02-75bold": {
        "displayName": "Helvetica 75 Latin Ext",
        "fontFamily": "helveticaneuew02-75bold",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin-ext"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 97
    },
    "helveticaneuew02-95blac": {
        "displayName": "Helvetica 95 Latin Ext",
        "fontFamily": "helveticaneuew02-95blac",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin-ext"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 98
    },
    "helveticaneuew02-thin": {
        "displayName": "Helvetica 35 Latin Ext",
        "fontFamily": "helveticaneuew02-thin",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin-ext"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 99
    },
    "helveticaneuew02-ultlt": {
        "displayName": "Helvetica 25 Latin Ext",
        "fontFamily": "helveticaneuew02-ultlt",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin-ext"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 100
    },
    "helveticaneuew10-45ligh": {
        "displayName": "Helvetica 45 Cyrillic",
        "fontFamily": "helveticaneuew10-45ligh",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["cyrillic"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 101
    },
    "helveticaneuew10-65medi": {
        "displayName": "Helvetica 65 Cyrillic",
        "fontFamily": "helveticaneuew10-65medi",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["cyrillic"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 102
    },
    "helveticaneuew10-75bold": {
        "displayName": "Helvetica 75 Cyrillic",
        "fontFamily": "helveticaneuew10-75bold",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["cyrillic"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 103
    },
    "helveticaneuew10-95blac": {
        "displayName": "Helvetica 95 Cyrillic",
        "fontFamily": "helveticaneuew10-95blac",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["cyrillic"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 104
    },
    "helveticaneuew10-35thin": {
        "displayName": "Helvetica 35 Cyrillic",
        "fontFamily": "helveticaneuew10-35thin",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["cyrillic"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 105
    },
    "helveticaneuew10-25ultl": {
        "displayName": "Helvetica 25 Cyrillic",
        "fontFamily": "helveticaneuew10-25ultl",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["cyrillic"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 106
    },
    "meiryo": {
        "displayName": "Meiryo",
        "fontFamily": "meiryo",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["japanese"],
        "permissions": "legacy",
        "fallbacks": ""
    },
    "segoe_printregular": {
        "displayName": "Segoe Print",
        "fontFamily": "segoe_printregular",
        "cdnName": "",
        "genericFamily": "cursive",
        "provider": "open source",
        "characterSets": ["latin"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 107
    },
    "bodoni-w01-poster": {
        "displayName": "Bodoni Poster",
        "fontFamily": "bodoni-w01-poster",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["latin", "cyrillic"],
        "permissions": "all",
        "fallbacks": "bodoni-poster-w10",
        "spriteIndex": 108
    },
    "stencil-w01-bold": {
        "displayName": "Stencil",
        "fontFamily": "stencil-w01-bold",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 110
    },
    "itc-arecibo-w01-regular": {
        "displayName": "ITC Arecibo",
        "fontFamily": "itc-arecibo-w01-regular",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 111
    },
    "avenida-w01": {
        "displayName": "Avenida",
        "fontFamily": "avenida-w01",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "avenida-w02",
        "spriteIndex": 112
    },
    "pacifica-w00-condensed": {
        "displayName": "Pacifica Condensed",
        "fontFamily": "pacifica-w00-condensed",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 114
    },
    "geotica-w01-four-open": {
        "displayName": "Geotica Four Open",
        "fontFamily": "geotica-w01-four-open",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 115
    },
    "marzo-w00-regular": {
        "displayName": "Marzo",
        "fontFamily": "marzo-w00-regular",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 116
    },
    "braggadocio-w01": {
        "displayName": "Braggadocio",
        "fontFamily": "braggadocio-w01",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 117
    },
    "reklamescriptw00-medium": {
        "displayName": "Reklame Script",
        "fontFamily": "reklamescriptw00-medium",
        "cdnName": "",
        "genericFamily": "cursive",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 118
    },
    "snellroundhandw01-scrip": {
        "displayName": "Snell Roundhand",
        "fontFamily": "snellroundhandw01-scrip",
        "cdnName": "",
        "genericFamily": "cursive",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 120
    },
    "din-next-w01-light": {
        "displayName": "DIN Next Light",
        "fontFamily": "din-next-w01-light",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "din-next-w02-light,din-next-w10-light",
        "spriteIndex": 121
    },
    "helvetica-w01-roman": {
        "displayName": "Helvetica",
        "fontFamily": "helvetica-w01-roman",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "helvetica-w02-roman,helvetica-lt-w10-roman",
        "spriteIndex": 124
    },
    "helvetica-w01-light": {
        "displayName": "Helvetica Light",
        "fontFamily": "helvetica-w01-light",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "helvetica-w02-light",
        "spriteIndex": 127
    },
    "helvetica-w01-bold": {
        "displayName": "Helvetica Bold",
        "fontFamily": "helvetica-w01-bold",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "helvetica-w02-bold,helvetica-lt-w10-bold",
        "spriteIndex": 129
    },
    "nimbus-sans-tw01con": {
        "displayName": "Nimbus Sans",
        "fontFamily": "nimbus-sans-tw01con",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 132
    },
    "soho-w01-thin-condensed": {
        "displayName": "Soho Condensed",
        "fontFamily": "soho-w01-thin-condensed",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "soho-w02-thin-condensed",
        "spriteIndex": 133
    },
    "droid-serif-w01-regular": {
        "displayName": "Droid Serif",
        "fontFamily": "droid-serif-w01-regular",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "droid-serif-w02-regular,droid-serif-w10-regular",
        "spriteIndex": 135
    },
    "clarendon-w01-medium-692107": {
        "displayName": "Clarendon LT",
        "fontFamily": "clarendon-w01-medium-692107",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "clarendon-w02-medium-693834",
        "spriteIndex": 138
    },
    "museo-w01-700": {
        "displayName": "Museo",
        "fontFamily": "museo-w01-700",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 140
    },
    "museo-slab-w01-100": {
        "displayName": "Museo Slab",
        "fontFamily": "museo-slab-w01-100",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 141
    },
    "americantypwrteritcw01--731025": {
        "displayName": "American Typewriter",
        "fontFamily": "americantypwrteritcw01--731025",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "americantypwrteritcw02--737091",
        "spriteIndex": 142
    },
    "monoton": {
        "displayName": "Monoton",
        "fontFamily": "monoton",
        "cdnName": "Monoton",
        "genericFamily": "fantasy",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 144
    },
    "sacramento": {
        "displayName": "Sacramento",
        "fontFamily": "sacramento",
        "cdnName": "Sacramento",
        "genericFamily": "cursive",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 146
    },
    "cookie": {
        "displayName": "Cookie",
        "fontFamily": "cookie",
        "cdnName": "Cookie",
        "genericFamily": "cursive",
        "provider": "google",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 148
    },
    "raleway": {
        "displayName": "Raleway",
        "fontFamily": "raleway",
        "cdnName": "Raleway",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 150
    },
    "open sans condensed": {
        "displayName": "Open Sans Condensed",
        "fontFamily": "open sans condensed",
        "cdnName": "Open+Sans+Condensed:300",
        "genericFamily": "sans-serif",
        "provider": "google",
        "characterSets": ["latin", "latin-ext", "cyrillic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 151
    },
    "amatic sc": {
        "displayName": "Amatic SC",
        "fontFamily": "amatic sc",
        "cdnName": "Amatic+SC",
        "genericFamily": "cursive",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 154
    },
    "coquette-w00-light": {
        "displayName": "Coquette",
        "fontFamily": "coquette-w00-light",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin", "latin-ext"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 155
    },
    "rosewood-w01-regular": {
        "displayName": "Rosewood",
        "fontFamily": "rosewood-w01-regular",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 157
    },
    "helvetica neue": {
        "displayName": "Helvetica Neue",
        "fontFamily": "helvetica neue",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "legacy",
        "fallbacks": ""
    },
    "helvetica neue italic": {
        "displayName": "Helvetica Neue Italic",
        "fontFamily": "helvetica neue italic",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "legacy",
        "fallbacks": ""
    },
    "helvetica neue thin": {
        "displayName": "Helvetica Neue Thin",
        "fontFamily": "helvetica neue thin",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "legacy",
        "fallbacks": ""
    },
    "helvetica neue medium": {
        "displayName": "Helvetica Neue Medium",
        "fontFamily": "helvetica neue medium",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "legacy",
        "fallbacks": ""
    },
    "frank-ruhl-w26-regular": {
        "displayName": "Frank Ruhl",
        "fontFamily": "frank-ruhl-w26-regular",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 158
    },
    "alef-regular": {
        "displayName": "Alef",
        "fontFamily": "alef-regular",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 159
    },
    "miriam-w26-medium": {
        "displayName": "Miriam",
        "fontFamily": "miriam-w26-medium",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 160
    },
    "adler-w26-regular": {
        "displayName": "Adler",
        "fontFamily": "adler-w26-regular",
        "cdnName": "",
        "genericFamily": "cursive",
        "provider": "monotype",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 161
    },
    "haim-arukeem-w26-medium": {
        "displayName": "Longlife",
        "fontFamily": "haim-arukeem-w26-medium",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 162
    },
    "shabazi-w26-bold": {
        "displayName": "Shabazi Bold",
        "fontFamily": "shabazi-w26-bold",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 163
    },
    "gulash-w26-regular": {
        "displayName": "Gulash",
        "fontFamily": "gulash-w26-regular",
        "cdnName": "",
        "genericFamily": "cursive",
        "provider": "monotype",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 164
    },
    "chips-w26-normal": {
        "displayName": "Chips",
        "fontFamily": "chips-w26-normal",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 165
    },
    "nekudot-w26-bold": {
        "displayName": "Nekudot Bold",
        "fontFamily": "nekudot-w26-bold",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 166
    },
    "opensanshebrewcondensed-regular": {
        "displayName": "Open Sans Condensed",
        "fontFamily": "opensanshebrewcondensed-regular",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 167
    },
    "asimon-aaa-400": {
        "displayName": "Asimon",
        "fontFamily": "asimon-aaa-400",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 168
    },
    "atlas-aaa-500": {
        "displayName": "Atlas",
        "fontFamily": "atlas-aaa-500",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 169
    },
    "omes-aaa-400": {
        "displayName": "Omes",
        "fontFamily": "omes-aaa-400",
        "cdnName": "",
        "genericFamily": "cursive",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 170
    },
    "almoni-dl-aaa-300": {
        "displayName": "Almoni DL Light",
        "fontFamily": "almoni-dl-aaa-300",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 171
    },
    "almoni-dl-aaa-400": {
        "displayName": "Almoni DL Regular",
        "fontFamily": "almoni-dl-aaa-400",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 172
    },
    "almoni-dl-aaa-700": {
        "displayName": "Almoni DL Bold",
        "fontFamily": "almoni-dl-aaa-700",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 173
    },
    "mixtape-aaa-400": {
        "displayName": "Mixtape",
        "fontFamily": "mixtape-aaa-400",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 174
    },
    "museum-aaa-400": {
        "displayName": "Museum",
        "fontFamily": "museum-aaa-400",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 175
    },
    "meodedpashut-oeregular": {
        "displayName": "Meoded",
        "fontFamily": "meodedpashut-oeregular",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["hebrew"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 176
    },
    "arabictypesettingw23-re": {
        "displayName": "Arabic Typesetting Regular",
        "fontFamily": "arabictypesettingw23-re",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 177
    },
    "midan-w20": {
        "displayName": "Midan",
        "fontFamily": "midan-w20",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 178
    },
    "arian-lt-w20-light": {
        "displayName": "Arian Light",
        "fontFamily": "arian-lt-w20-light",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 179
    },
    "arian-lt-w20-regular": {
        "displayName": "Arian",
        "fontFamily": "arian-lt-w20-regular",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 180
    },
    "coheadlinew23-arabicbol": {
        "displayName": "Co Headline Arabic Bold",
        "fontFamily": "coheadlinew23-arabicbol",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "legacy",
        "fallbacks": ""
    },
    "janna-lt-w20-regular": {
        "displayName": "Janna",
        "fontFamily": "janna-lt-w20-regular",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 181
    },
    "helveticaneueltw20-ligh": {
        "displayName": "Neue Helvetica Arabic",
        "fontFamily": "helveticaneueltw20-ligh",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 182
    },
    "dinnextltw23-ultralight": {
        "displayName": "DIN Next Arabic",
        "fontFamily": "dinnextltw23-ultralight",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 183
    },
    "tanseekmodernw20-light": {
        "displayName": "Tanseek Modern Light",
        "fontFamily": "tanseekmodernw20-light",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 184
    },
    "ahmedltw20-outlineregul": {
        "displayName": "Ahmed Outline",
        "fontFamily": "ahmedltw20-outlineregul",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 185
    },
    "kufi-lt-w20-regular": {
        "displayName": "Kufi Regular",
        "fontFamily": "kufi-lt-w20-regular",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 186
    },
    "amiri": {
        "displayName": "Amiri",
        "fontFamily": "amiri",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "open source",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 187
    },
    "droid-naskh": {
        "displayName": "Droid Naskh",
        "fontFamily": "droid-naskh",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "open source",
        "characterSets": ["arabic"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 188
    },
    "ｍｓ ゴシック": {
        "displayName": "MS Gothic",
        "fontFamily": "ｍｓ ゴシック",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["japanese"],
        "permissions": "all",
        "fallbacks": "ms gothic,ヒラギノ角ゴ pro w3,hiragino kaku gothic pro,osaka",
        "spriteIndex": 189
    },
    "ｍｓ 明朝": {
        "displayName": "MS Mincho",
        "fontFamily": "ｍｓ 明朝",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "system",
        "characterSets": ["japanese"],
        "permissions": "all",
        "fallbacks": "ms mincho,ヒラギノ明朝 pro w3,hiragino mincho pro",
        "spriteIndex": 190
    },
    "ｍｓ ｐゴシック": {
        "displayName": "MS PGothic",
        "fontFamily": "ｍｓ ｐゴシック",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["japanese"],
        "permissions": "all",
        "fallbacks": "ms pgothic,ヒラギノ角ゴ pro w3,hiragino kaku gothic pro,osaka",
        "spriteIndex": 191
    },
    "ｍｓ ｐ明朝": {
        "displayName": "MS PMincho",
        "fontFamily": "ｍｓ ｐ明朝",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "system",
        "characterSets": ["japanese"],
        "permissions": "all",
        "fallbacks": "ms pmincho,ヒラギノ明朝 pro w3,hiragino mincho pro",
        "spriteIndex": 192
    },
    "メイリオ": {
        "displayName": "Meiryo",
        "fontFamily": "メイリオ",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["japanese"],
        "permissions": "all",
        "fallbacks": "meiryo,ヒラギノ角ゴ pro w3,hiragino kaku gothic pro",
        "spriteIndex": 193
    },
    "맑은 고딕": {
        "displayName": "Malgun Gothic",
        "fontFamily": "맑은 고딕",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "malgun gothic,apple sd gothic neo,applegothic",
        "spriteIndex": 194
    },
    "돋움": {
        "displayName": "Dotum",
        "fontFamily": "돋움",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "dotum,apple sd gothic neo,applegothic",
        "spriteIndex": 195
    },
    "굴림": {
        "displayName": "Gulim",
        "fontFamily": "굴림",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "system",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "gulim,apple sd gothic neo,applegothic",
        "spriteIndex": 196
    },
    "nanumgothic-regular": {
        "displayName": "Nanum Gothic",
        "fontFamily": "nanumgothic-regular",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 197
    },
    "bm-hanna": {
        "displayName": "BM Hanna",
        "fontFamily": "bm-hanna",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "open source",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 198
    },
    "fbneogothic": {
        "displayName": "FB Neo Gothic",
        "fontFamily": "fbneogothic",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 199
    },
    "fbchamblue": {
        "displayName": "FB Cham Blue",
        "fontFamily": "fbchamblue",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 200
    },
    "fbbluegothicl": {
        "displayName": "FB Blue Gothic",
        "fontFamily": "fbbluegothicl",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 201
    },
    "fbplum": {
        "displayName": "FB Plum",
        "fontFamily": "fbplum",
        "cdnName": "",
        "genericFamily": "fantasy",
        "provider": "monotype",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 202
    },
    "fbgreen": {
        "displayName": "FB Green",
        "fontFamily": "fbgreen",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["korean"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 203
    },
    "cinzel": {
        "displayName": "Cinzel",
        "fontFamily": "cinzel",
        "cdnName": "Cinzel",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 204
    },
    "sail": {
        "displayName": "Sail",
        "fontFamily": "sail",
        "cdnName": "Sail",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 205
    },
    "playfair display": {
        "displayName": "Playfair Display",
        "fontFamily": "playfair display",
        "cdnName": "Playfair+Display",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 206
    },
    "libre baskerville": {
        "displayName": "Libre Baskerville",
        "fontFamily": "libre baskerville",
        "cdnName": "Libre+Baskerville",
        "genericFamily": "serif",
        "provider": "google",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 207
    },
    "trend-sans-w00-four": {
        "displayName": "Trend",
        "fontFamily": "trend-sans-w00-four",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 208
    },
    "proxima-n-w01-reg": {
        "displayName": "Proxima Nova",
        "fontFamily": "proxima-n-w01-reg",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 209
    },
    "bree-w01-thin-oblique": {
        "displayName": "Bree",
        "fontFamily": "bree-w01-thin-oblique",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 210
    },
    "lulo-clean-w01-one-bold": {
        "displayName": "Lulo Clean",
        "fontFamily": "lulo-clean-w01-one-bold",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 211
    },
    "futura-lt-w01-book": {
        "displayName": "Futura",
        "fontFamily": "futura-lt-w01-book",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 212
    },
    "futura-lt-w01-light": {
        "displayName": "Futura Light",
        "fontFamily": "futura-lt-w01-light",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 213
    },
    "brandon-grot-w01-light": {
        "displayName": "Brandon Grotesque",
        "fontFamily": "brandon-grot-w01-light",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 214
    },
    "avenir-lt-w01_85-heavy1475544": {
        "displayName": "Avenir",
        "fontFamily": "avenir-lt-w01_85-heavy1475544",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 215
    },
    "avenir-lt-w01_35-light1475496": {
        "displayName": "Avenir Light",
        "fontFamily": "avenir-lt-w01_35-light1475496",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 216
    },
    "didot-w01-italic": {
        "displayName": "Linotype Didot",
        "fontFamily": "didot-w01-italic",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 217
    },
    "adobe-caslon-w01-smbd": {
        "displayName": "Adobe Caslon",
        "fontFamily": "adobe-caslon-w01-smbd",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 218
    },
    "kepler-w03-light-scd-cp": {
        "displayName": "Kepler",
        "fontFamily": "kepler-w03-light-scd-cp",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 219
    },
    "baskervillemtw01-smbdit": {
        "displayName": "Monotype Baskerville",
        "fontFamily": "baskervillemtw01-smbdit",
        "cdnName": "",
        "genericFamily": "serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 220
    },
    "belinda-w00-regular": {
        "displayName": "Belinda",
        "fontFamily": "belinda-w00-regular",
        "cdnName": "",
        "genericFamily": "script",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 221
    },
    "helveticaneuew01-55roma": {
        "displayName": "Helvetica 55",
        "fontFamily": "helveticaneuew01-55roma",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "studio",
        "fallbacks": "",
        "spriteIndex": 222
    },
    "peaches-and-cream-regular-w00": {
        "displayName": "Peaches & Cream",
        "fontFamily": "peaches-and-cream-regular-w00",
        "cdnName": "",
        "genericFamily": "script",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 223
    },
    "dinneuzeitgroteskltw01-_812426": {
        "displayName": "DIN Neuzeit Grotesk",
        "fontFamily": "dinneuzeitgroteskltw01-_812426",
        "cdnName": "",
        "genericFamily": "sans-serif",
        "provider": "monotype",
        "characterSets": ["latin"],
        "permissions": "all",
        "fallbacks": "",
        "spriteIndex": 224
    }
};

module.exports = fonts;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var log = __webpack_require__(13);

/**
 * returns an animation factory
 * @returns {{animate: animate, transition: transition, sequence: sequence, registerAnimation: registerAnimation, registerTransition: registerTransition, getProperties: getProperties, getAnimationsDefs: getAnimationsDefs, getTransitionsDefs: getTransitionsDefs}}
 */
function create() {
    var animationsDefs = {};
    var transitionsDefs = {};

    /**
     * Start a new sequence
     * @param [params]
     * @constructor
     */
    function SequenceBuilder(params) {
        var baseSequence = 'BaseSequence'; // I have to use a var or ESLint will be mad.
        this.timeline = animationsDefs[baseSequence](params ? _.cloneDeep(params) : {});
    }

    /**
     * Add another animation, transition or sequence to the sequence
     * @param {TweenMax|TimelineMax|Array} tweens
     * @param {String|number} [position='+=0']
     * @param {String|number} [align='normal']
     * @returns {SequenceBuilder}
     */
    SequenceBuilder.prototype.add = function (tweens, position, align) {
        position = typeof position === 'undefined' ? '+=0' : position;
        align = align || 'normal';
        this.timeline.add(tweens, position, align);
        return this;
    };

    /**
     * Get the real timeline attached to the sequence
     * @returns {TimelineMax}
     */
    SequenceBuilder.prototype.get = function () {
        return this.timeline;
    };

    /**
     * Instantiate a new SequenceBuilder
     * @variation 1
     * @param [params]
     * @returns {SequenceBuilder}
     */
    function sequence(params) {
        return new SequenceBuilder(params);
    }

    /**
     * Schedule an animation on an element
     * @variation 2
     * @param {String} name The name of the animation (ie. "FadeIn")
     * @param {Array<HTMLElement>|HTMLElement} elements DOM element to animate
     * @param {Number} [duration=1] Animation Duration in seconds
     * @param {Number} [delay=0] The time to wait in seconds before starting the animation
     * @param {Object} [params] Additional parameters for the animation
     * @returns {TweenMax|TimelineMax|null} The animation function to schedule, null if this animation is not registered
     */

    function animate(name, elements, duration, delay, params) {
        var animationsDef = animationsDefs[name];
        if (!animationsDef) {
            log.error('Warning:', name, 'is not a registered animation. skipping.');
            return null;
        }
        return animationsDef(elements, duration, delay, params ? _.cloneDeep(params) : {});
    }

    /**
     * Schedule an transition animation between two elements
     * The difference from "animate" is that "transition" functions receives two elements and animated between them.
     * @variation 2
     * @param {String} name The name of the animation (ie. "FadeIn")
     * @param {Array<HTMLElement>|HTMLElement} sourceElements DOM element to animate from
     * @param {Array<HTMLElement>|HTMLElement} destinationElements DOM element to animate to
     * @param {Number} [duration=1] Animation Duration in seconds
     * @param {Number} [delay=0] The time to wait in seconds before starting the animation
     * @param {Object} [params] Additional parameters for the animation
     * @returns {TimelineMax|null} The animation function to schedule, null if this animation is not registered
     */
    function transition(name, sourceElements, destinationElements, duration, delay, params) {
        var transitionsDef = transitionsDefs[name];
        if (!transitionsDef) {
            log.error('Warning:', name, 'is not a registered transition. skipping.');
            return null;
        }
        return transitionsDef(sourceElements, destinationElements, duration, delay, params ? _.cloneDeep(params) : {});
    }

    /**
     * This function is used by animation and transition classes to register themselves on this animations instance
     * @param {string} animationName The public name of the animation which it will be called with
     * @param {function} animationFunc The animation function
     */
    function registerAnimation(animationName, animationFunc) {
        if (transitionsDefs[animationName]) {
            log.error('Warning: there is already a transition with the name', animationName);
        }
        animationsDefs[animationName] = animationFunc;
    }

    /**
     * API Sugar. currently does the same as registerAnimation
     * This function is used by animation and transition classes to register themselves on this animations instance
     * @param {string} animationName The public name of the animation which it will be called with
     * @param {function} animationFunc The animation function
     */
    function registerTransition(transitionName, transitionFunc) {
        if (animationsDefs[transitionName]) {
            log.error('Warning: there is already an animation with the name', transitionName);
        }
        transitionsDefs[transitionName] = transitionFunc;
    }

    /**
     * @typedef {object} AnimationProperties
     * @property {array<string>} groups        - Groups (or tags) this animation or transition is assigned to
     * @property {boolean} [hideOnStart]       - Animations only: Flag notating if this animation should hide the element before starting
     * @property {number} [defaultDuration]    - Transitions only: the default transition duration
     */
    /**
     * Get special properties for the passed animation or transition name
     * @param {string} name
     * @returns {AnimationProperties}
     */
    function getProperties(name) {
        return (animationsDefs[name] || transitionsDefs[name] || {}).properties || {};
    }

    function getAnimationsDefs() {
        return animationsDefs;
    }

    function getTransitionsDefs() {
        return transitionsDefs;
    }

    /**
     * @class core.animationsFactory
     */
    return {
        animate: animate,
        transition: transition,
        sequence: sequence,
        registerAnimation: registerAnimation,
        registerTransition: registerTransition,
        getProperties: getProperties,
        getAnimationsDefs: getAnimationsDefs,
        getTransitionsDefs: getTransitionsDefs
    };
}

module.exports = {
    create: create
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var domMeasurements = __webpack_require__(9);

function create(tweenMax, TimelineMax) {
    var _allowedTweenMaxParamsList = [
    //Basics
    'ease', 'duration', 'delay', 'to', 'from', 'repeat', 'yoyo', 'repeatDelay', 'easeParams', 'stagger', 'transformOrigin',
    //Advanced
    'clearProps', 'paused', 'overwrite', 'autoClear', 'parseTransform', 'fireUpdateCommand', 'data', 'elementClearParams', 'perspective', 'transformPerspective', 'immediateRender', 'callbacks', 'force3D', 'transformStyle'];

    var _allowedTimelineMaxParamsList = [
    //Basics
    'delay', 'repeat', 'yoyo', 'repeatDelay', 'stagger',
    //Advanced
    'paused', 'align', 'tweens', 'autoClear', 'data', 'elementClearParams', 'callbacks'];

    /**
     * Animate an element.
     * Passed params are being validated and filtered against _allowedTweenMaxParamsList list
     * @param {Array<HTMLElement>|HTMLElement} elements DOM element to animate
     * @param                         {Object} params the tween params passed by the animation resource
     * @param                        {Boolean} [params.autoClear=false] tells the tween to reset element original style on complete
     * @param                         {Object} [params.elementClearParams] Which types of clearing to run over elements inside the tween
     * @param             {Array<HTMLElement>} [params.elementClearParams.elements] Which types of clearing to run over elements inside the tween
     * @param                  {Array<String>} [params.elementClearParams.types] Which types of clearing to run over elements inside the tween
     * @param                  {string|number} [params.stagger] stagger passed elements, also uses OnCompleteAll instead of onComplete
     * @param                       {Function} [params.callbacks.onStart]
     * @param                       {Function} [params.callbacks.onComplete]
     * @param                       {Function} [params.callbacks.onInterrupt]
     * @param                       {Function} [params.callbacks.onUpdate]
     * @param                  {Array<String>} allowedAnimationParamsList a list of tween parameters allowed for this tween
     * @returns {TweenMax}
     */
    function tween(elements, params, allowedAnimationParamsList) {
        var tweenFunc = void 0;
        // We handle only Arrays
        if (!_.isArray(elements)) {
            if (elements instanceof window.NodeList) {
                elements = _.toArray(elements);
            } else {
                elements = [elements];
            }
        }

        params = params || {};
        params = _validateAnimationParams(params, [allowedAnimationParamsList, _allowedTweenMaxParamsList]);

        _assignCallbacks(params);

        if (params.from && params.to) {
            tweenFunc = _fromTo;
        } else if (params.from) {
            tweenFunc = _from;
        } else {
            tweenFunc = _to;
        }
        return tweenFunc(elements, params);
    }

    /**
     * Accepts a list of tweenMax arguments and returns a timeline with all the returned tweens timelined to the timeline 0 mark
     * Passed params are being validated and filtered against _allowedTimelineMaxParamsList list
     * @variation 3
     * @param                   {Array<tweenMax>} tweensAndtimelinesList an array of tweenMax and TimelineMax objects
     * @param                         {Object} [params] extra tweenEngine parameters
     * @param                        {Boolean} [params.autoClear=false] tells the tween to reset all elements original style on complete
     * @param                         {Object} [params.elementClearParams] Which types of clearing to run over elements inside the tween
     * @param             {Array<HTMLElement>} [params.elementClearParams.elements] Which types of clearing to run over elements inside the tween
     * @param                  {Array<String>} [params.elementClearParams.types] Which types of clearing to run over elements inside the tween
     * @param                  {string|number} [params.stagger] stagger passed elements, also uses OnCompleteAll instead of onComplete
     * @param                       {Function} [params.callbacks.onStart]
     * @param                       {Function} [params.callbacks.onComplete]
     * @param                       {Function} [params.callbacks.onInterrupt]
     * @param                       {Function} [params.callbacks.onUpdate]
     * @param                  {Array<String>} allowedAnimationParamsList a list of tween parameters allowed for this tween
     * @returns {TimelineMax}
     */

    function timeline(params, allowedAnimationParamsList) {
        params = _validateAnimationParams(params || {}, [allowedAnimationParamsList, _allowedTimelineMaxParamsList]);
        _assignCallbacks(params);
        return new TimelineMax(params);
    }

    /**
     * Calls a tween of 0 seconds duration, equivalent to TweenMax 'set' just with our engine syntax and callbacks
     * @param {Array<HTMLElement>|HTMLElement} elements DOM element to animate
     * @param {Object} params the tween params passed by the animation resource (no need to 'to' or 'from', always defaults to 'to')
     * @returns {TweenMax}
     */
    function set(elements, params) {
        params = params ? _.cloneDeep(params) : {};
        params.duration = 0;
        params.delay = 0;
        params.to = params.to || {};
        return tween(elements, params, _.keys(params));
    }

    /**
     * Kill a tween or timeline and invoke a callback if passed
     * Before killing the animation set the position of the play head to the end of the animation (simulate completion)
     * @param {TweenMax|TimelineMax} src
     * @param {number} [seekTo] when stopping the animation - keep the components in their current state or seek to the end of the animation.
     */
    function kill(src, seekTo) {

        if (!src.paused()) {
            src.pause();
            _onInterruptHandler(src);
        }
        if (_.isNumber(seekTo)) {
            src.progress(seekTo, true);
        }
        src.kill();
        if (src.clear) {
            src.clear();
        }
    }

    /**
     * Adds a ticker ( wrapper for requestAnimationFrame / setTimeout 60FPS )
     * We are telling the browser that we wish to perform ( usually an animation ) and that the callback should be called before the next repaint
     * @param {Function} callback
     */
    function addTickerEvent(callback) {
        tweenMax.ticker.addEventListener('tick', callback);
    }

    /**
     * Removes the registered ticker function
     * @param {Function} callback
     */
    function removeTickerEvent(callback) {
        tweenMax.ticker.removeEventListener('tick', callback);
    }

    /**
     * Return if the passed element is in the middle of an animation
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    function isTweening(element) {
        return tweenMax.isTweening(element);
    }

    /**
     * Set a new "from" animation, the animation will end at the default state of the element
     * a clone of the passed params object is saved on the tweenMax's 'data' object
     * @param {Array<HTMLElement>|HTMLElement} elements DOM element or DOM Id
     * @param {Object} params the parameters for the animation
     * @param {string|number} params.stagger use stagger
     * @returns {TweenMax}
     * @private
     */
    function _from(elements, params) {
        var tw = void 0,
            seq = void 0,
            data = void 0;

        var duration = params.duration;
        var stagger = params.stagger;
        var delay = params.delay;

        var fromParams = _.defaults(params, params.from);
        fromParams.data = fromParams.data || {};

        delete fromParams.from;
        delete fromParams.duration;
        delete fromParams.stagger;

        if (typeof stagger !== 'undefined') {
            data = fromParams.data;
            fromParams.data = {};
            delete fromParams.delay;

            tw = tweenMax.staggerFrom(elements, duration, fromParams, stagger);
            seq = timeline({ data: data, delay: delay }).add(tw);
        } else {
            tw = tweenMax.from(elements, duration, fromParams);
        }

        return seq || tw;
    }

    /**
     * Set a new "to" animation, the animation will start at the default state of the element
     * a clone of the passed params object is saved on the tweenMax's 'data' object
     * @param {Array<HTMLElement>|HTMLElement} elements DOM element or DOM Id
     * @param {Object} params the parameters for the animation
     * @param {string|number} params.stagger use stagger
     * @returns {TweenMax}
     * @private
     */
    function _to(elements, params) {
        var tw = void 0,
            seq = void 0,
            data = void 0;
        var duration = params.duration;
        var stagger = params.stagger;
        var delay = params.delay;

        var toParams = _.defaults(params, params.to || {});
        toParams.data = toParams.data || {};

        delete toParams.to;
        delete toParams.duration;
        delete toParams.stagger;

        if (typeof stagger !== 'undefined') {
            data = toParams.data;
            toParams.data = {};
            delete toParams.delay;

            tw = tweenMax.staggerTo(elements, duration, toParams, stagger);
            seq = timeline({ data: data, delay: delay }).add(tw);
        } else {
            tw = tweenMax.to(elements, duration, toParams);
        }

        return seq || tw;
    }

    /**
     * Set a new "fromTo" animation
     * a clone of the passed params object is saved on the tweenMax's 'data' object
     * @param {Array<HTMLElement>|HTMLElement} elements DOM element or DOM Id
     * @param {Object} params the parameters for the animation
     * @param {string|number} params.stagger use stagger
     * @returns {TweenMax}
     * @private
     */
    function _fromTo(elements, params) {
        var toParams = void 0,
            tw = void 0,
            seq = void 0,
            data = void 0;

        var duration = params.duration;
        var stagger = params.stagger;
        var delay = params.delay;

        var fromParams = params.from;
        toParams = params.to;
        toParams.data = toParams.data || {};

        delete params.to;
        delete params.from;
        delete params.duration;
        delete params.stagger;
        delete toParams.duration;
        delete toParams.stagger;

        toParams = _.merge(toParams, params);

        if (typeof stagger !== 'undefined') {
            data = toParams.data;
            toParams.data = {};
            delete toParams.delay;

            tw = tweenMax.staggerFromTo(elements, duration, fromParams, toParams, stagger);
            seq = timeline({ data: data, delay: delay }).add(tw);
        } else {
            tw = tweenMax.fromTo(elements, duration, fromParams, toParams);
        }

        return seq || tw;
    }

    function _assignCallbacks(params) {

        params.data = params.data || {};

        if (params.callbacks) {
            params.data.callbacks = {};
            if (params.callbacks.onComplete) {
                params.data.callbacks.onComplete = params.callbacks.onComplete;
                params.onComplete = _onCompleteHandler;
                params.onCompleteParams = ['{self}'];
            }
            if (params.callbacks.onReverseComplete) {
                params.data.callbacks.onReverseComplete = params.callbacks.onReverseComplete;
                params.onReverseComplete = _onReverseCompleteHandler;
                params.onReverseCompleteParams = ['{self}'];
            }
            if (params.callbacks.onStart) {
                params.data.callbacks.onStart = params.callbacks.onStart;
                params.onStart = _onStartHandler;
                params.onStartParams = ['{self}'];
            }
            if (params.callbacks.onUpdate) {
                params.data.callbacks.onUpdate = params.callbacks.onUpdate;
                params.onUpdate = _onUpdateHandler;
                params.onUpdateParams = ['{self}'];
            }
            if (params.callbacks.onInterrupt) {
                params.data.callbacks.onInterrupt = params.callbacks.onInterrupt;
            }
        }

        delete params.callbacks;

        return params;
    }

    /**
     * OnComplete callback for tweens and timelines
     * @param {TweenMax|TimelineMax} src
     * @private
     */
    function _onCompleteHandler(src) {
        _callHandlerIfExists(src, 'onComplete');
    }

    /**
     * OnReverseComplete callback for tweens and timelines
     * @param {TweenMax|TimelineMax} src
     * @private
     */
    function _onReverseCompleteHandler(src) {
        _callHandlerIfExists(src, 'onReverseComplete');
    }

    /**
     * OnStart callback for tweens and timelines
     * @param {TweenMax|TimelineMax} src
     * @private
     */
    function _onStartHandler(src) {
        _callHandlerIfExists(src, 'onStart');
    }

    /**
     * OnUpdate callback (will invoke every animationFrame) for tweens and timelines
     * @param {TweenMax|TimelineMax} src
     * @private
     */
    function _onUpdateHandler(src) {
        _callHandlerIfExists(src, 'onUpdate');
    }

    /**
     * OnUpdate callback (will invoke every animationFrame) for tweens and timelines
     * @param {TweenMax|TimelineMax} src
     * @private
     */
    function _onInterruptHandler(src) {
        _callHandlerIfExists(src, 'onInterrupt');
    }

    function _callHandlerIfExists(src, eventName) {
        if (_.isFunction(_.get(src, 'data.callbacks.' + eventName))) {
            src.data.callbacks[eventName](src);
        }
    }

    /**
     * Removes from the passed params object values that are not present in the union of allowedAnimationParamsList and this._allowedTweenMaxParamsList
     * @param {Object} params
     * @param {Array<Array<String>>} allowedAnimationParamsLists array of arrays of allowed params for this animation
     * @returns {Object}
     * @private
     */
    function _validateAnimationParams(params, allowedAnimationParamsLists) {

        var allowedParamsList = _.union.apply(_, allowedAnimationParamsLists);

        _.forEach(params, function (value, key, collection) {
            // If the parameter is 'to' of 'from' (for fromTo animations)
            // run validation on the second level
            if (key === 'to' || key === 'from') {
                _validateAnimationParams(collection[key], allowedAnimationParamsLists);
            } else if (!_.includes(allowedParamsList, key)) {
                delete collection[key];
            }
        });
        return params;
    }

    function delayedCall(delay, callback, params, scope) {
        return tweenMax.delayedCall(delay, callback, params, scope);
    }

    /**
     *
     * @param src
     * @param {number} duration
     * @param {number} from
     * @param {number} to
     * @param {string} [easing=Linear.easeOut]
     * @param {{onStart:function, onUpdate:function, onComplete:function}} [callbacks]
     * @returns {*}
     */
    function animateTimeScale(src, duration, from, to, easing, callbacks) {
        var fromParams = {
            timeScale: from
        };
        var toParams = {
            timeScale: to,
            easing: easing || 'Linear.easeNone'
        };
        if (callbacks) {
            _.assign(toParams, callbacks);
        }
        if (from === 0 && src.paused()) {
            src.play();
        }
        return tweenMax.fromTo(src, duration, fromParams, toParams);
    }

    /**
     * Utility function, USE WITH CAUTION.
     * see http://greensock.com/docs/#/HTML5/GSAP/TweenMax/static_lagSmoothing/
     * @param {number} threshold
     * @param {number} [adjustedLag] optional if threshold is 0;
     */
    function adjustLagSmoothing(threshold, adjustedLag) {
        //tweenMax is not loaded on server side rendering and tests, so testing for existence
        if (typeof tweenMax.lagSmoothing === 'function') {
            tweenMax.lagSmoothing(threshold, adjustedLag);
        }
    }

    /**
     * Utility function, USE WITH CAUTION.
     * see http://greensock.com/docs/#/HTML5/All/TweenLite/ticker/
     * @param {boolean} isRaf
     */
    function useRAF(isRaf) {
        if (tweenMax.ticker && typeof tweenMax.ticker.useRAF === 'function') {
            tweenMax.ticker.useRAF(isRaf);
        }
    }

    /**
     * @class core.animations.tweenEngineGreenSock
     */
    return {
        timeline: timeline,
        tween: tween,
        set: set,
        kill: kill,
        addTickerEvent: addTickerEvent,
        removeTickerEvent: removeTickerEvent,
        isTweening: isTweening,
        getElementRect: domMeasurements.getElementRect,
        getContentRect: domMeasurements.getContentRect,
        getBoundingRect: domMeasurements.getBoundingRect,
        getBoundingContentRect: domMeasurements.getBoundingContentRect,
        delayedCall: delayedCall,
        animateTimeScale: animateTimeScale,
        adjustLagSmoothing: adjustLagSmoothing,
        useRAF: useRAF
    };
}

module.exports = {
    create: create
};

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var backgroundUtils = __webpack_require__(70);
var renderDoneMixin = __webpack_require__(44);
var htmlParser = __webpack_require__(11);
var htmlTransformer = __webpack_require__(12);
var textSecurityFixer = __webpack_require__(55);
var throttleUtils = __webpack_require__(56);
var keyboardUtils = __webpack_require__(34);
var classNames = __webpack_require__(22);
var cookieUtils = __webpack_require__(24);
var tween = __webpack_require__(59);
var urlUtils = __webpack_require__(15);
var store = __webpack_require__(50);
var storeNew = __webpack_require__(51);
var mobileViewportFixer = __webpack_require__(40);
var dataUtils = __webpack_require__(25);
var dateTimeUtils = __webpack_require__(26);
var validationUtils = __webpack_require__(60);
var cssUtils = __webpack_require__(6);
var hashUtils = __webpack_require__(10);
var guidUtils = __webpack_require__(33);
var arrayUtils = __webpack_require__(18);
var stringUtils = __webpack_require__(5);
var mediaZoomCalculations = __webpack_require__(39);
var objectUtils = __webpack_require__(42);
var animationFrame = __webpack_require__(8);
var domMeasurements = __webpack_require__(9);
var scrollUtils = __webpack_require__(46);
var storage = __webpack_require__(49);
var style = __webpack_require__(52);
var verticalMenuCalculations = __webpack_require__(61);
var galleriesCommonLayout = __webpack_require__(32);
var requestsUtil = __webpack_require__(7);
var boundingLayout = __webpack_require__(20);
var nonPageItemZoom = __webpack_require__(41);
var reactComponentUtils = __webpack_require__(43);
var appPartMediaInnerViewNameUtils = __webpack_require__(17);
var dockUtils = __webpack_require__(27);
var viewportUtils = __webpack_require__(62);
var containerBackgroundUtils = __webpack_require__(23);
var math = __webpack_require__(14);
var functionUtils = __webpack_require__(31);
var mediaConsts = __webpack_require__(38);
var blogAppPartNames = __webpack_require__(19);
var siteConstants = __webpack_require__(48);
var textPatternRecognizer = __webpack_require__(54);
var errorPages = __webpack_require__(29);

var _require = __webpack_require__(35),
    logWixCodeConsoleMessage = _require.logWixCodeConsoleMessage,
    logWixCodeConsoleError = _require.logWixCodeConsoleError;

var matrixCalculations = __webpack_require__(36);
var matrixScalingCalculations = __webpack_require__(37);
var timersMixins = __webpack_require__(58);
var timeUtils = __webpack_require__(57);
var browserDetection = __webpack_require__(21);
var svgFilters = __webpack_require__(53);
var fragment = __webpack_require__(30);
var dynamicPagesUtils = __webpack_require__(28);
var log = __webpack_require__(13);
var createFontUtils = __webpack_require__(16);
var fonts = __webpack_require__(63);
var tweenEngine = __webpack_require__(64);
var SimpleDrag = __webpack_require__(47);
var Screenfull = __webpack_require__(45);

/**
 * @exports coreUtils
 */
module.exports = {
    log: log,
    renderDoneMixin: renderDoneMixin,
    htmlTransformer: htmlTransformer,
    textSecurityFixer: textSecurityFixer,
    htmlParser: htmlParser,
    throttleUtils: throttleUtils,
    keyboardUtils: keyboardUtils,
    classNames: classNames,
    cookieUtils: cookieUtils,
    tween: tween,
    urlUtils: urlUtils,
    Store: store,
    StoreNew: storeNew,
    mobileViewportFixer: mobileViewportFixer,
    dataUtils: dataUtils,
    dateTimeUtils: dateTimeUtils,
    validationUtils: validationUtils,
    cssUtils: cssUtils,
    hashUtils: hashUtils,
    guidUtils: guidUtils,
    arrayUtils: arrayUtils,
    stringUtils: stringUtils,
    mediaZoomCalculations: mediaZoomCalculations,
    objectUtils: objectUtils,
    animationFrame: animationFrame,
    domMeasurements: domMeasurements,
    scrollUtils: scrollUtils,
    storage: storage,
    style: style,
    galleriesCommonLayout: galleriesCommonLayout,
    requestsUtil: requestsUtil,
    boundingLayout: boundingLayout,
    verticalMenuCalculations: verticalMenuCalculations,
    nonPageItemZoom: nonPageItemZoom,
    appPartMediaInnerViewNameUtils: appPartMediaInnerViewNameUtils,
    reactComponentUtils: reactComponentUtils,
    dockUtils: dockUtils,
    viewportUtils: viewportUtils,
    containerBackgroundUtils: containerBackgroundUtils,
    math: math,
    functionUtils: functionUtils,
    mediaConsts: mediaConsts,
    balataConsts: mediaConsts.balataConsts,
    blogAppPartNames: blogAppPartNames,
    siteConstants: siteConstants,
    textPatternRecognizer: textPatternRecognizer,
    errorPages: errorPages,
    logWixCodeConsoleMessage: logWixCodeConsoleMessage,
    logWixCodeConsoleError: logWixCodeConsoleError,
    matrix: {
        calculations: matrixCalculations,
        scalingCalculations: matrixScalingCalculations
    },
    timersMixins: timersMixins,
    timeUtils: timeUtils,
    browserDetection: browserDetection,
    svgFilters: svgFilters,
    fragment: fragment,
    dynamicPagesUtils: dynamicPagesUtils,
    createFontUtils: createFontUtils,
    fonts: fonts,
    tweenEngine: tweenEngine,
    SimpleDrag: SimpleDrag,
    Screenfull: Screenfull,
    backgroundUtils: backgroundUtils
};

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// coreUtils.js